export const workspace = {
codeLanguagesLabel: "لغة الشفرة",
codeLanguages: {
curl: "curl",
js: "JavaScript",
python: "Python",
powerQuery: "Power Query",
powershell: "PowerShell",
},
overviewScreen: {
loading: "جارٍ تحميل مساحة العمل...",
fallbackWorkspaceName: "مساحة العمل",
fallbackTeamName: "فريق",
fallbackPersonalName: "شخصي",
notSet: "غير محدد",
roleUnavailable: "الدور غير متاح",
personalMode: "الوضع الشخصي",
addSummaryHint: "أضف ملخصًا قصيرًا في ملف تعريف المؤسسة.",
currentContextLabel: "السياق الحالي",
yourRoleLabel: "دورك",
currencyLabel: "العملة",
languageLabel: "اللغة",
manageOrgA11y: "إدارة الملف التعريفي للمؤسسة",
viewOrgA11y: "عرض الملف التعريفي للمؤسسة",
manageOrgTitle: "إدارة المنظمة",
viewOrgTitle: "عرض المؤسسة",
manageOrgSubtitle: "الملف التعريفي والتفاصيل القانونية وملخص الشركة.",
teamsA11y: "الفرق والدعوات",
teamsTitle: "الفرق والدعوات",
teamsSubtitle: "تبديل السياق والعضويات والدعوات.",
configurationTitle: "التكوين",
configurationSubtitle: "كل ما يمكنك إعداده، مُجمَّعًا حسب المجال.",
groupWorkspaceLabel: "مساحة العمل",
groupOperationsLabel: "العمليات",
groupTemplatesLabel: "قوائم التحقق",
groupIntegrationsLabel: "التكاملات",
groupAiLabel: "الذكاء الاصطناعي",
groupBillingLabel: "الفوترة",
groupSupportLabel: "الدعم",
itemOrgProfileTitle: "الملف التعريفي للمؤسسة",
itemOrgProfileSubtitleAdmin: "الاسم القانوني والصناعة والعنوان والملاحظات الخاصة.",
itemOrgProfileSubtitleMember: "عرض الاسم القانوني والقطاع والعنوان.",
itemTeamsTitle: "الفرق والدعوات",
itemTeamsSubtitleAdmin: "الأعضاء والأدوار وتبديل السياق والدعوات.",
itemTeamsSubtitleMember: "عرض الأعضاء والأدوار؛ تبديل السياق.",
itemBrandingTitle: "هوية التقارير",
itemBrandingSubtitleAdmin: "الشعار وتفاصيل الشركة لملفات PDF والمشاركات والصادرات فقط.",
itemBrandingSubtitleMember: "عرض الشعار وتفاصيل الشركة المستخدمة في ملفات PDF والمشاركات والصادرات.",
itemContractorWorkTitle: "عملي كمقاول",
itemContractorWorkSubtitle: "المهام وطلبات عروض الأسعار التي أرسلتها إليك مساحات عمل أخرى.",
itemMaintenancePlansTitle: "خطط الصيانة",
itemMaintenancePlansSubtitle: "كل الخطط المتكررة في مساحة العمل، مجمّعة حسب الأصل.",
itemFeaturesTitle: "الميزات",
itemFeaturesSubtitle: "ما هو مفعّل أو مقفل بحسب الخطة أو معطّل.",
itemDefaultsTitle: "الإعدادات الإقليمية الافتراضية",
itemDefaultsSubtitle: "العملة واللغة والمنطقة الزمنية وطرق المشاركة.",
itemTemplatesTitle: "قوائم التحقق",
itemTemplatesSubtitle: "قوائم فحص التفتيش القابلة لإعادة الاستخدام.",
itemIndustryPacksTitle: "حزم القطاعات",
itemIndustryPacksSubtitle: "نقاط انطلاق للعقارات والأسطول والمعدات والمرافق.",
itemIntegrationsTitle: "التكاملات وAPI",
itemIntegrationsSubtitle: "الواردات وAPI العامة وMCP والأتمتة والأصول المتصلة.",
itemAiAuditTitle: "تدقيق الذكاء الاصطناعي والأتمتة",
itemAiAuditSubtitle: "استخدام الذكاء الاصطناعي في مساحة العمل ونشاط الأتمتة.",
itemBillingTitle: "الفوترة والاستخدام",
itemBillingSubtitleAdmin: "الخطة وأرصدة الذكاء الاصطناعي والأصول الخاضعة للفوترة وسجل الأرصدة.",
itemBillingSubtitleMember: "عرض الخطة واستخدام الرصيد؛ يمكن للمسؤول فقط تغييرهما.",
itemHandbookTitle: "دليل التكامل",
itemHandbookSubtitle: "أدلة لربط AssetWRX وأتمتته.",
},
organizationScreen: {
  allSaved: "تم الحفظ. تفاصيل مساحة عملك محدّثة.",
  allChangesSaved: "تم حفظ كل التغييرات",
  saveChanges: "حفظ التغييرات",
  unsavedKeep: "متابعة التعديل",
  unsavedDiscard: "مغادرة",
  unsavedBody: "غيّرت تفاصيل في هذه الصفحة. إذا غادرت الآن ستضيع هذه التغييرات.",
  unsavedTitle: "المغادرة دون حفظ؟",
pageTitle: "الملف التعريفي للمؤسسة",
pageSubtitle: "هوية مساحة العمل وتفاصيل الاتصال والمعلومات القانونية. يوجد نمط رأس خاص بالتقرير ضمن التقارير.",
memberNotice: "يمكن لمالكي مساحة العمل فقط تعديل تفاصيل المؤسسة والعلامة التجارية للتقارير. يمكنك عرض المعلومات المشتركة أدناه.",
loadingProfile: "جارٍ تحميل الملف التعريفي للمؤسسة…",
fallbackWorkspaceName: "مساحة العمل",
logoSectionTitle: "شعار مساحة العمل",
changeLogoA11y: "تغيير شعار مساحة العمل",
uploading: "جارٍ التحميل…",
changeLogo: "تغيير الشعار",
removeLogoA11y: "إزالة الشعار",
remove: "إزالة",
workspaceNameLabel: "اسم مساحة العمل",
workspaceNamePlaceholder: "تسمية مساحة العمل",
saveWorkspaceName: "حفظ اسم مساحة العمل",
organizationSectionTitle: "المؤسسة",
summaryLabel: "ملخص",
summaryPlaceholder: "وصف مختصر لمؤسستك",
industryLabel: "القطاع",
companySizeLabel: "حجم الشركة",
companySizePlaceholder: "مثال: \u{2066}1–10\u{2069}، \u{2066}11–50\u{2069}",
websiteLabel: "الموقع الإلكتروني",
websitePlaceholder: "https://example.com",
countryCodeLabel: "رمز البلد",
countryCodePlaceholder: "مثال: GB",
regionLabel: "المنطقة",
saveOrganization: "حفظ المنظمة",
supportContactsTitle: "جهات اتصال الدعم",
supportEmailLabel: "بريد الدعم الإلكتروني",
supportPhoneLabel: "هاتف الدعم",
saveSupportContacts: "حفظ جهات اتصال الدعم",
legalBillingTitle: "الشؤون القانونية والفواتير",
legalBillingSubtitle: "مرئي فقط لأصحاب مساحة العمل.",
legalEntityNameLabel: "اسم الكيان القانوني",
tradingNameLabel: "الاسم التجاري / اسم العرض",
primaryContactEmailLabel: "البريد الإلكتروني لجهة الاتصال الأساسية",
primaryContactPhoneLabel: "هاتف الاتصال الأساسي",
registeredAddressLabel: "العنوان المسجل",
operationalAddressLabel: "العنوان التشغيلي",
taxNumberLabel: "رقم الضريبة/ضريبة القيمة المضافة",
registrationNumberLabel: "رقم تسجيل الشركة",
billingContactNameLabel: "اسم جهة اتصال الفوترة",
billingContactEmailLabel: "البريد الإلكتروني لجهة اتصال الفوترة",
billingContactPhoneLabel: "هاتف جهة اتصال الفواتير",
saveLegalBilling: "حفظ الأمور القانونية والفواتير",
memberPrivateNote: "تفاصيل الكيان القانوني والضرائب والتسجيل والفوترة مقتصرة على مالكي مساحة العمل.",
reportBrandingLink: "العلامة التجارية للتقارير والتصدير",
savedTitle: "تم الحفظ",
workspaceNameSaved: "تم تحديث اسم مساحة العمل.",
saveFailedTitle: "فشل الحفظ",
couldNotSave: "تعذر الحفظ.",
checkPhoneTitle: "تحقق من رقم الهاتف",
checkPhoneBody: "أدخل رقمًا صالحًا للبلد المحدد، أو اترك الهاتف فارغًا.",
organizationDetailsSaved: "تم تحديث تفاصيل المؤسسة.",
legalBillingSaved: "تم تحديث التفاصيل القانونية وتفاصيل الفوترة.",
permissionRequiredTitle: "الإذن مطلوب",
permissionRequiredBody: "يُرجى السماح بالوصول إلى مكتبة الصور لتحميل الشعار.",
fileTooLargeTitle: "الملف كبير جدًا",
fileTooLargeBody: "يجب ألا يتجاوز حجم الشعار 10 ميجابايت.",
logoUpdated: "تم تحديث شعار مساحة العمل.",
uploadFailedTitle: "فشل التحميل",
couldNotUploadLogo: "تعذر تحميل الشعار.",
removedTitle: "تمت الإزالة",
logoRemoved: "تمت إزالة شعار مساحة العمل.",
removeFailedTitle: "فشلت الإزالة",
couldNotRemoveLogo: "تعذر إزالة الشعار.",
},
brandingScreen: {
readOnlyTitle: "للقراءة فقط",
readOnlyBody: "يمكن فقط لمالكي مساحة العمل تغيير العلامة التجارية للتقرير.",
permissionRequiredTitle: "الإذن مطلوب",
permissionRequiredBody: "يُرجى السماح بالوصول إلى مكتبة الصور لتحميل الشعار.",
fallbackWorkspaceName: "مساحة العمل",
workspaceBrandingAppliedTitle: "تم تطبيق العلامة التجارية لمساحة العمل",
workspaceBrandingAppliedBody: "تم نسخ اسم مساحة العمل وشعارها إلى حقول العلامة التجارية للتقرير. راجعها ثم اضغط حفظ لتطبيقها.",
noWorkspaceTitle: "لا توجد مساحة عمل",
noWorkspaceBody: "ملفك الشخصي ليس لديه حساب مساحة عمل حتى الآن.",
savedTitle: "تم الحفظ",
brandingSaved: "تم تحديث إعدادات العلامة التجارية للتقرير.",
saveFailedTitle: "فشل الحفظ",
couldNotSaveBranding: "تعذر حفظ إعدادات العلامة التجارية للتقرير.",
intro: "يتم تطبيقه على التقارير المستضافة، وتصدير PDF، ومخرجات الفحص المشتركة، ومشاركة رسائل البريد الإلكتروني. قم بتعيين الحقول هنا لاستبدال العلامة التجارية الافتراضية AssetWRX على تلك المخرجات؛ اتركها فارغة للحفاظ على إعدادات AssetWRX الافتراضية.",
memberHint: "يمكن لمالكي مساحة العمل فقط تحرير العلامة التجارية. يمكنك مراجعة الإعدادات الحالية أدناه.",
fromReportHint: "تم فتح هذا القسم من مساحة عمل التقارير. تنطبق التغييرات فورًا على التقارير المستضافة والصادرات الجديدة.",
loadingSettings: "جارٍ تحميل إعدادات العلامة التجارية…",
reportLogoLabel: "شعار التقرير",
reportLogoHint: "يُستخدم في التقارير وملفات PDF المصدَّرة ورسائل المشاركة عبر البريد الإلكتروني فقط.",
changeLogoA11y: "تغيير صورة شعار التقرير",
addLogoA11y: "إضافة صورة شعار التقرير",
changeLogo: "تغيير شعار التقرير",
addLogo: "إضافة شعار التقرير",
removeLogoA11y: "إزالة شعار التقرير",
removeLogo: "إزالة شعار التقرير",
copyFromWorkspaceA11y: "استخدم شعار مساحة العمل الخاصة بك واسمها للتقارير",
copyFromWorkspace: "استخدم شعار واسم مساحة العمل الخاصة بي",
noLogoHint: "لم يتم تعيين شعار للتقرير - تستخدم الصادرات العلامة التجارية AssetWRX حتى تقوم بإضافة شعار هنا.",
companyNameLabel: "اسم الشركة / العرض",
companyNamePlaceholder: "مثال: نورثفيلد للخدمات العقارية",
companyNameA11y: "الشركة أو الاسم المعروض للتقارير",
addressBlockLabel: "كتلة العنوان",
addressBlockPlaceholder: "تظهر أسطر العناوين في رأس التقرير",
addressBlockA11y: "كتلة عنوان التقرير",
contactBlockLabel: "كتلة الاتصال",
contactBlockPlaceholder: "البريد الإلكتروني / الهاتف / الموقع",
contactBlockA11y: "كتلة الاتصال في التقرير",
footerLabel: "تذييل الصفحة / إخلاء المسؤولية",
footerPlaceholder: "إخلاء مسؤولية اختياري في تذييل التقرير",
footerA11y: "تذييل التقرير أو إخلاء المسؤولية",
accentColorLabel: "لون التمييز (اختياري)",
accentColorA11y: "القيمة السداسية العشرية للون التمييز في التقرير",
accentColorHint: "استخدم التنسيق السداسي العشري (#RRGGBB). اتركه فارغًا لاستخدام لون التمييز الافتراضي في AssetWRX.",
savingA11y: "حفظ العلامة التجارية للتقرير",
saveA11y: "حفظ إعدادات العلامة التجارية للتقرير",
saving: "جارٍ الحفظ…",
saveBranding: "حفظ العلامة التجارية",
},
teamsScreen: {
recentlyJoined: "انضم مؤخرًا",
switchFailedTitle: "تعذر تبديل مساحة العمل",
tryAgain: "حاول مرة أخرى.",
pendingInviteTitle: "في انتظار دعوة الفريق",
pendingInviteBody_one: "دعوة واحدة بانتظار في إدارة الفريق.",
pendingInviteBody_other: "{{count}} دعوة بانتظار في إدارة الفريق.",
teamManagementTitle: "إدارة الفريق",
teamManagementSubtitle: "الدعوات والأدوار والخيارات المتقدمة.",
createFirstTeam: "قم بإنشاء فريقك الأول",
openTeamManagement: "فتح إدارة الفريق",
teamManagementMenuSubtitle: "إعدادات بملء الشاشة لفرقك ودعواتك.",
teamsAndContextTitle: "فرقك",
teamsAndContextSubtitle: "الفريق الذي تعمل فيه، وكل الفرق التي تنتمي إليها.",
changeContext: "تبديل الفريق",
workspaceLabel: "مساحة العمل",
currentContextLabel: "تعمل في",
roleInContextLabel: "دورك",
loadFailed: "تعذّر تحميل فرقك. أعد فتح هذه الصفحة للمحاولة مرة أخرى.",
teamMembershipsTitle: "عضويات الفرق",
manageInTeamSettings: "إدارة إعدادات الفريق",
noMemberships: "أنت لست عضوًا حاليًا في أي فريق.",
membershipMeta: "الدور: {{role}} · انضم في {{date}}",
currentBadge: "الحالي",
workingContextTitle: "تبديل الفريق",
workingContextSubtitle: "اختر الفريق الذي ترى أصوله وعمله. تعرض المساحة الشخصية عملك فقط.",
personalOption: "شخصي",
pendingInviteBody_zero: "لا دعوات بانتظار في إدارة الفريق.",
pendingInviteBody_two: "دعوتان بانتظار في إدارة الفريق.",
pendingInviteBody_few: "{{count}} دعوات بانتظار في إدارة الفريق.",
pendingInviteBody_many: "{{count}} دعوة بانتظار في إدارة الفريق.",
},
aiUsageInsights: {
title: "رؤى استخدام الذكاء الاصطناعي",
subtitle: "يجمع الاستدعاءات والأرصدة والتعليقات من آخر {{days}} يومًا. يتم التحديث عند إعادة التحميل.",
refresh: "تحديث",
loadingUsage: "جارٍ تحميل الاستخدام…",
alertHeader_one: "قدرة واحدة تحتاج إلى مراجعة",
alertHeader_other: "{{count}} قدرة تحتاج إلى مراجعة",
healthAttention: "تحتاج بعض ميزات الذكاء الاصطناعي إلى الاهتمام — يمكن لمسؤول مساحة العمل مراجعة التفاصيل.",
healthNormal: "تعمل جميع ميزات الذكاء الاصطناعي بشكل طبيعي.",
kpiCreditsBurned: "الأرصدة المستهلكة",
kpiCalls: "الاستدعاءات",
kpiErrors: "الأخطاء",
kpiCacheHitRate: "معدل الإصابة في ذاكرة التخزين المؤقت",
projectedMonthly: "متوقع شهريًا",
pctOfBudget: "{{pct}}% من ميزانية {{budget}}",
extrapolatedFromWindow: "مُستقرأ خطيًا من هذه الفترة البالغة {{days}} يومًا",
noActivity: "لا يوجد نشاط للذكاء الاصطناعي في هذه الفترة. شجِّع المستخدمين على تجربة المساعد لرؤية بيانات هنا.",
colCapability: "القدرة",
colCalls: "الاستدعاءات",
colCredits: "الأرصدة",
colAvgMs: "متوسط مللي ثانية",
colFeedback: "👍/ 👎",
colAccept: "قبول",
openDetailHint: "فتح تفاصيل القدرة",
alert: {
neverHelpful_zero: "لا أصوات سلبية ولا إيجابية بعد.",
neverHelpful_one: "صوت سلبي واحد ولا صوت إيجابي. مؤشر قوي على وجود خلل.",
neverHelpful_two: "صوتان سلبيان ولا صوت إيجابي. مؤشر قوي على وجود خلل.",
neverHelpful_few: "{{count}} أصوات سلبية ولا صوت إيجابي. مؤشر قوي على وجود خلل.",
neverHelpful_many: "{{count}} صوتًا سلبيًا ولا صوت إيجابي. مؤشر قوي على وجود خلل.",
neverHelpful_other: "{{count}} صوت سلبي ولا صوت إيجابي. مؤشر قوي على وجود خلل.",
lowAcceptance: "نسبة القبول {{pct}}٪ (العدد {{total}}). راجع التعليمات أو الأمثلة.",
highErrorRate: "{{pct}}٪ من الاستدعاءات تفشل ({{errors}}/{{calls}}). تحقق من وظيفة الخادم أو من توفر النموذج.",
},
feature: {
unknown: "غير منسوب",
ai_assistant: "مساعد الذكاء الاصطناعي",
connected_event: "حدث من جهاز متصل",
automation: {
asset_health_calculated: "حساب صحة الأصل",
asset_compliance_calculated: "حساب امتثال الأصل",
asset_risk_calculated: "حساب مخاطر الأصل",
asset_risk_assessment_persist_batch: "حفظ مخاطر الأصول دفعة واحدة",
recipe_run: "تشغيل وصفة أتمتة",
},
asset: {
extract_vin_or_serial: "قراءة رقم الهيكل أو الرقم التسلسلي",
generate_advanced_report: "تقرير أصل متقدم",
improve_description: "تحسين وصف الأصل",
infer_identity: "التعرّف على الأصل",
journey_summary: "ملخص رحلة الأصل",
timeline_summary: "ملخص الخط الزمني للأصل",
},
assistant: {
recommend_next_actions: "الإجراءات التالية من المساعد",
},
connected: {
event_ingest: "رسالة من جهاز متصل",
},
document: {
extract_metadata: "قراءة تفاصيل المستند",
},
esg: {
  writeup: "ملخص ESG",
},
home: {
operations_briefing: "موجز العمليات",
},
insights: {
recommend_next_actions: "الإجراءات التالية الموصى بها",
},
inspection: {
analyse_image: "تحليل صورة الفحص",
completed: "اكتمال الفحص",
fix_recommendation: "توصية الإصلاح",
generate_job_drafts: "مسودات مهام من الفحص",
generate_summary: "ملخص الفحص",
improve_note: "تحسين ملاحظة الفحص",
},
job: {
completion_closeout: "إغلاق المهمة",
extract_invoice_line_items: "قراءة بنود الفاتورة",
generate_invoice_draft: "مسودة فاتورة",
improve_update_note: "تحسين تحديث المهمة",
suggest_certificate_draft: "اقتراح شهادة",
suggest_completion_criteria: "اقتراح معايير الإكمال",
suggest_follow_up_job: "اقتراح مهمة متابعة",
},
quote: {
compare_quotes: "مقارنة عروض الأسعار",
generate_rfq_scope: "صياغة نطاق طلب عرض السعر",
recommend_quote: "التوصية بعرض سعر",
summarize_quotes: "تلخيص عروض الأسعار",
},
request: {
polish_follow_up_draft: "تحسين الرد على الطلب",
},
site: {
generate_advanced_report: "تقرير موقع متقدم",
},
template: {
generate_draft: "مسودة قائمة تحقق",
},
vision: {
analyse_group: "مسح WRX Vision",
verify_completion: "فحص أدلة WRX Verified",
},
work: {
analyse_evidence: "تحليل أدلة العمل",
},
},
entityType: {
asset: "أصل",
job: "مهمة",
inspection: "فحص",
request: "طلب",
quote: "عرض سعر",
site: "موقع",
document: "مستند",
template: "قائمة تحقق",
contact: "جهة اتصال",
},
feedback: {
helpful: "مفيد",
not_helpful: "غير مفيد",
},
action: {
refine: "طُلب التحسين",
},
creditMode: {
none: "بلا",
estimated: "تقديري",
actual: "فعلي",
},
alertHeader_zero: "لا قدرات تحتاج إلى مراجعة",
alertHeader_two: "قدرتان تحتاجان إلى مراجعة",
alertHeader_few: "{{count}} قدرات تحتاج إلى مراجعة",
alertHeader_many: "{{count}} قدرة تحتاج إلى مراجعة",
},
aiCapabilityDetail: {
kicker: "تفاصيل القدرة · 30 يومًا",
closeA11y: "إغلاق التفاصيل",
loading: "جارٍ تحميل التفاصيل...",
noFeedback: "لا توجد تعليقات حتى الآن بشأن هذه الإمكانية.",
sectionFeedback: "تفاصيل التعليقات",
sectionActionTaken: "الإجراء المتخذ",
sectionDailyActivity: "النشاط اليومي",
noActivity: "لا يوجد نشاط في هذه الفترة.",
sectionRecentEntities: "الكيانات الأخيرة",
totalLine_one: "حدث واحد إجمالًا في هذه الفترة.",
totalLine_other: "{{count}} حدث إجمالًا في هذه الفترة.",
totalLine_zero: "لا أحداث في هذه الفترة.",
totalLine_two: "حدثان إجمالًا في هذه الفترة.",
totalLine_few: "{{count}} أحداث إجمالًا في هذه الفترة.",
totalLine_many: "{{count}} حدثًا إجمالًا في هذه الفترة.",
},
syncCenter: {
  errors: {
    unsupportedWrite: "يحتاج هذا التغيير إلى إصدار أحدث من التطبيق لإرساله. سيبقى محفوظًا على هذا الجهاز.",
    waitingOnFailedParent: "بانتظار السجل الذي ينتمي إليه، والذي تعذّر إرساله. أصلح ذلك العنصر أو تجاهله في هذه الصفحة أولاً.",
    transientUnknown: "لم يُرسل هذا التغيير بعد. ستتم إعادة المحاولة، وتواصل مع الدعم إذا تكرر ذلك.",
    permanentUnknown: "لا يمكن تطبيق هذا التغيير تلقائيًا. راجعه أو تجاهله.",
    serverError: "حدثت مشكلة في الخادم. ستتم إعادة الإرسال، وتواصل مع الدعم إذا تكرر ذلك.",
    rateLimited: "الخادم مشغول. ستتم إعادة الإرسال قريبًا.",
    network: "مشكلة في الاتصال. سيتم الإرسال تلقائيًا، أو يمكنك إعادة المحاولة الآن.",
    conflict: "توجد نسخة أحدث محفوظة بالفعل. تجاهل هذا التغيير ثم راجع أحدث نسخة.",
    notFound: "تمت إزالة العنصر الذي يخصه هذا التغيير. يمكنك تجاهله.",
    permission: "ليس لديك إذن لإرسال هذا التغيير. اطلب ذلك من مسؤول مساحة العمل.",
    blocked: "هذا التغيير محفوظ على هذا الجهاز لكن تعذّر إرساله. أعد المحاولة أو تجاهله.",
    authRetry: "سجّل الدخول مرة أخرى لإرسال هذا التغيير. إنه محفوظ على هذا الجهاز.",
  },
pageTitle: "تغييرات لم تُرسل",
pageSubtitle: "تغييرات محفوظة على هذا الجهاز تنتظر الإرسال.",
healthTitle: "الصحة",
statusSectionTitle: "الحالة",
retryAll: "أرسل الآن",
queuedWritesSynced: "تم إرسال كل شيء",
lastSync: "آخر إرسال {{age}}",
noSyncsYet: "لم يُرسل شيء بعد",
queuedLabel: "بانتظار الإرسال",
inFlightLabel: "جارٍ الإرسال",
lastFlushLabel: "آخر إرسال",
lastDurationLabel: "المدة الأخيرة",
never: "أبدًا",
pendingWritesTitle: "بانتظار الإرسال",
unsentAnswersTitle: "إجابات فحص على هذا الجهاز",
unsentAnswersBody: "تُرسل تلقائيًا عند الاتصال بالإنترنت. إذا تغيّر الفحص في مكان آخر، افتحه لمراجعتها وإرسالها.",
openInspection: "فتح الفحص",
queuedInspectionPhotos: "صور فحص في انتظار الرفع: {{total}}",
recoveryNote_one: "أحد التغييرات المحفوظة بواسطة إصدار سابق من التطبيق ليس له مالك مسجل. تم الاحتفاظ بها بدلاً من تعيينها لمن قام بتسجيل الدخول بعد ذلك. إذا كان هذا العمل ملكك، فطالب به وستتم مزامنته؛ وإلا تجاهله.",
recoveryNote_other: "{{count}} تغيير محفوظ بواسطة إصدار سابق من التطبيق ليس لها مالك مسجل. تم الاحتفاظ بها بدلاً من تعيينها لمن سجّل الدخول بعد ذلك. إذا كان هذا العمل ملكك، فطالب به وستتم مزامنته؛ وإلا تجاهله.",
claimAsMine: "المطالبة باسمي",
discard: "تجاهل",
claimAllAsMine: "المطالبة بكل شيء باسمي",
discardAll: "تجاهل الكل",
noQueuedWritesTitle: "لا شيء بانتظار الإرسال",
noQueuedWritesBody: "تُرسل التغييرات التي تجريها على هذا الجهاز فور اتصالك بالإنترنت. تظهر صور الفحص في فحصها.",
hideTechnicalDetails: "إخفاء التفاصيل الفنية",
showTechnicalDetails: "عرض التفاصيل الفنية",
technicalDetail_one: "{{rawError}} · محاولة واحدة",
technicalDetail_other: "{{rawError}} · {{count}} محاولة",
retry: "إعادة المحاولة",
offlineSupportTitle: "ما الذي يعمل دون اتصال",
statusOnlineRequired: "يتطلب اتصالًا",
statusLocalDraft: "يُحفظ على هذا الجهاز أولًا",
policyEntity: {
Asset: "أصل",
Inspection: "فحص",
Job: "مهمة",
Schedule: "جدولة",
Request: "طلب",
Comment: "تعليق",
Media: "وسائط",
},
policyAction: {
createAsset: "إنشاء أصل",
editAsset: "تعديل أصل",
addDocument: "إضافة مستند",
answerChecklistItems: "الإجابة عن بنود قائمة التحقق",
startInspection: "بدء فحص جديد",
submitInspection: "إيقاف الفحص مؤقتًا أو متابعته أو إكماله",
createJob: "إنشاء مهمة",
addJobPhotos: "إضافة صور عند إنشاء مهمة",
postActivity: "نشر ملاحظات النشاط والصور",
moveJobStatus: "قبول أمر العمل أو جدولته أو اعتماده",
startPauseCompleteJob: "بدء أمر العمل أو إيقافه مؤقتًا أو إكماله",
updateJobDetails: "تحديث تفاصيل المهمة",
scheduleInspection: "جدولة فحص",
answerCheck: "الإجابة عن فحص المهمة",
recordMeterReading: "تسجيل قراءة عداد",
reportCantComplete: "الإبلاغ عن تعذّر إكمال العمل",
decideChangeRequest: "البتّ في طلب تغيير",
createOrRespondRequest: "إنشاء طلب أو الرد عليه",
postComment: "نشر تعليق",
uploadEvidence: "رفع الأدلة",
},
supportCopy: {
queued: "يُحفظ محليًا ثم يُزامَن تلقائيًا",
local_draft: "يُحفظ محليًا حتى الإرسال",
online_required: "يتطلب اتصالًا بالإنترنت",
},
conflictCopy: {
idempotent_replay: "إعادة محاولة آمنة: لا تتكرر العملية نفسها.",
merge_review: "إذا تغيّرت البيانات على الخادم، راجعها وادمجها قبل الحفظ.",
latest_write: "آخر تغيير يقبله الخادم هو المعتمد.",
},
entryAsset: "أصل جديد",
entryInspectionJob: "أمر عمل التفتيش",
entryJob: "أمر عمل جديد",
entryJobPhoto: "صورة أمر العمل",
entryJobUpdate: "تحديث أمر العمل",
entryScheduledInspection: "فحص مجدول",
entryAssetDocument: "مستند الأصول",
entryFieldMove: "بدء أو إيقاف مؤقت أو إكمال",
entryNewInspection: "فحص جديد",
ageJustNow: "الآن",
ageMinutesAgo: "منذ {{mins}} د",
ageHoursAgo: "منذ {{hrs}} ساعة",
ageDaysAgo: "منذ {{days}} يوم",
readErrorBody: "تعذرت قراءة العمل المحفوظ. لا يزال موجودًا على هذا الجهاز ولم يُتجاهل.",
flushErrorBody: "تعذّر إرسال تغييراتك. لا تزال محفوظة على هذا الجهاز.",
claimErrorBody: "لا يمكن المطالبة بهذه التغييرات. ولا تزال محفوظة على هذا الجهاز.",
discardManyErrorBody: "لا يمكن تجاهل هذه التغييرات. ولا تزال محفوظة على هذا الجهاز.",
discardOneErrorBody: "تعذر تجاهل التغيير. لا يزال محفوظًا على هذا الجهاز.",
recoveryNote_zero: "لا توجد تغييرات محفوظة بواسطة إصدار سابق من التطبيق بلا مالك مسجل.",
recoveryNote_two: "تغييران محفوظان بواسطة إصدار سابق من التطبيق ليس لهما مالك مسجل. تم الاحتفاظ بهما بدلاً من تعيينهما لمن سجّل الدخول بعد ذلك. إذا كان هذا العمل ملكك، فطالب به وستتم مزامنته؛ وإلا تجاهله.",
recoveryNote_few: "{{count}} تغييرات محفوظة بواسطة إصدار سابق من التطبيق ليس لها مالك مسجل. تم الاحتفاظ بها بدلاً من تعيينها لمن سجّل الدخول بعد ذلك. إذا كان هذا العمل ملكك، فطالب به وستتم مزامنته؛ وإلا تجاهله.",
recoveryNote_many: "{{count}} تغييرًا محفوظًا بواسطة إصدار سابق من التطبيق ليس لها مالك مسجل. تم الاحتفاظ بها بدلاً من تعيينها لمن سجّل الدخول بعد ذلك. إذا كان هذا العمل ملكك، فطالب به وستتم مزامنته؛ وإلا تجاهله.",
technicalDetail_zero: "{{rawError}} · لا محاولات",
technicalDetail_two: "{{rawError}} · محاولتان",
technicalDetail_few: "{{rawError}} · {{count}} محاولات",
technicalDetail_many: "{{rawError}} · {{count}} محاولة",
},
trustCenter: {
pageTitle: "مركز الثقة",
pageSubtitle: "التدقيق والتكاملات والوصول ووضعية الامتثال لمساحة العمل هذه.",
loading: "جارٍ التحميل...",
auditLogTitle: "سجل التدقيق",
auditLogDescription: "من فعل ماذا ومتى، عبر الأصول وأوامر العمل والفحوصات وإجراءات الإدارة.",
auditLogEmptyTitle: "سجل التدقيق غير متوفر بعد",
auditLogEmptyBody: "بمجرد تفعيل سجل التدقيق لمساحة عملك، سيظهر هنا كل إجراء مهم مع الفاعل والهدف والطابع الزمني.",
integrationHealthTitle: "صحة التكاملات",
integrationHealthDescription: "موصلات API + MCP + IoT: حالة الاتصال، آخر مزامنة، معدل الخطأ.",
integrationHealthEmptyTitle: "لا توجد عمليات تكامل متصلة",
integrationHealthEmptyBody: "قم بتوصيل التكامل لرؤية الصحة المباشرة هنا - بما في ذلك آخر مزامنة ناجحة ومعدل الخطأ وحالة إعادة المحاولة.",
webhookRetryTitle: "إعادة محاولات خطاف الويب",
webhookRetryDescription: "عمليات تسليم خطاف الويب الصادرة التي فشلت وتمت إعادة محاولتها، مع النصوص وأكواد الاستجابة.",
webhookRetryEmptyTitle: "لا يوجد فشل في خطاف الويب",
webhookRetryEmptyBody: "ستظهر هنا عمليات تسليم خطاف الويب الفاشلة (مع سجل إعادة المحاولة والنصوص الخاصة بها) عند حدوثها.",
apiKeysTitle: "مفاتيح API والنطاقات",
apiKeysDescription: "المفاتيح الصادرة والنطاقات وحالة التدوير ومن قام بإنشائها.",
apiKeysEmptyTitle: "لم يتم إصدار مفاتيح API",
apiKeysEmptyBody: "عندما يقوم مالك مساحة العمل بإنشاء مفتاح API، ستظل نطاقاته وإيقاع التدوير موجودًا هنا.",
rolesTitle: "الأدوار والأذونات",
rolesDescription: "من يمكنه فعل ماذا عبر الفرق، مع الأذونات الفعلية والتجاوزات.",
rolesEmptyTitle: "لم يتم تسجيل أي تعيينات للأدوار حتى الآن",
rolesEmptyBody: "سيظهر هنا كل مستخدم وفريق، والأذونات التي يمتلكونها، وأي تجاوزات.",
complianceTitle: "وضعية الامتثال",
complianceDescription: "جاهزية SOC2 / ISO وموقع تخزين البيانات ومدة الاحتفاظ بها وحالة التصدير.",
complianceEmptyTitle: "لم تُسجَّل أي إشارات امتثال بعد",
complianceEmptyBody: "ستظهر هنا جاهزية SOC2 / ISO وموقع تخزين البيانات ومدة الاحتفاظ بها وحالة التصدير عند تسجيلها لمساحة العمل هذه.",
audit: {
byActor: "بواسطة {{name}}",
toRecipient: "إلى {{name}}",
action: {
asset: {
created: "تم إنشاء أصل",
updated: "تم تحديث أصل",
shared: "تمت مشاركة أصل",
share_revoked: "تم إلغاء مشاركة أصل",
},
inspection: {
created: "تم إنشاء فحص",
started: "بدأ فحص",
completed: "اكتمل فحص",
failed_item_recorded: "سُجّل بند غير مطابق",
approved: "تم اعتماد فحص",
reopened: "أُعيد فتح فحص",
shared: "تمت مشاركة تقرير",
share_approved: "تم اعتماد تقرير",
share_rejected: "تم رفض تقرير",
},
job: {
created: "تم إنشاء مهمة",
assigned: "تم إسناد مهمة",
started: "بدأت مهمة",
completed: "اكتملت مهمة",
reopened: "أُعيد فتح مهمة",
verified: "تم التحقق من مهمة",
},
document: {
created: "تمت إضافة مستند",
renewed: "تم تجديد مستند",
superseded: "استُبدل مستند بإصدار أحدث",
},
compliance: {
expiring_detected: "رُصد قرب انتهاء صلاحية امتثال",
},
insight: {
generated: "تم إنشاء رؤية",
feedback_submitted: "أُرسلت ملاحظات على رؤية",
},
technician: {
assignment_recommended: "اقتُرح مكلَّف بالمهمة",
assignment_accepted: "قبِل المكلَّف المهمة",
},
condition: {
assessment_calculated: "تم تقييم الحالة",
recommendation_created: "أُنشئت توصية بشأن الحالة",
recommendation_accepted: "قُبلت توصية بشأن الحالة",
recommendation_dismissed: "تم تجاهل توصية بشأن الحالة",
},
scheduling: {
recommendation_shown: "عُرض اقتراح جدولة",
recommendation_selected: "اختير اقتراح جدولة",
},
assistant: {
  change: "تم التغيير عبر المساعد",
  undo: "تم التراجع عبر المساعد",
},
},
entity: {
asset: "أصل",
job: "مهمة",
inspection: "فحص",
document: "مستند",
asset_share: "مشاركة أصل",
inspection_share: "مشاركة تقرير",
insight: "رؤية",
compliance: "امتثال",
technician: "إسناد",
site: "الموقع",
scheduled_inspection: "فحص مجدول",
template: "قائمة التحقق",
asset_request: "طلب",
},
},
},
teamInvite: {
pageTitle: "دعوة فريق",
invalidLink: "رابط الدعوة غير صالح",
loadTimeout: "يستغرق تحميل الدعوة وقتًا طويلاً. تحقق من اتصالك وحاول مرة أخرى.",
notFound: "لم يتم العثور على الدعوة",
expiredMessage: "انتهت صلاحية دعوتك{{where}}{{when}}. اطلب ممن دعاك إرسال دعوة جديدة.",
expiredWhereSuffix: " إلى {{teamName}}",
expiredWhenSuffix: " في {{date}}",
loadFailed: "فشل تحميل الدعوة",
emailMismatchTitle: "عدم تطابق البريد الإلكتروني",
emailMismatchBody: "تم إرسال هذه الدعوة إلى {{email}}. يرجى تسجيل الدخول باستخدام هذا البريد الإلكتروني للقبول.",
errorTitle: "خطأ",
linkSendFailedTitle: "تعذر إرسال الرابط",
linkSendFailedBody: "يرجى المحاولة مرة أخرى، أو اطلب من الشخص الذي دعاك إعادة إرسال الدعوة.",
loadingInvitation: "جارٍ تحميل الدعوة...",
invalidOrExpiredTitle: "غير صالح أو منتهية الصلاحية",
linkNoLongerValid: "رابط الدعوة هذا لم يعد صالحًا.",
tryAgain: "إعادة المحاولة",
goToApp: "انتقل إلى AssetWRX",
cardTitle: "دعوة الفريق",
invitedPrefix: "لقد تمت دعوتك للانضمام",
invitedRoleSuffix: "كـ {{role}}.",
checkEmailForLink: "تحقق من {{email}} للحصول على رابط تسجيل الدخول. يعيدك إلى هنا لتقبل.",
signInAsEmail: "سجِّل الدخول باسم {{email}} لقبول هذه الدعوة",
linkSent: "تم إرسال الرابط",
emailSignInLink: "أرسل لي رابط تسجيل الدخول عبر البريد الإلكتروني",
signIn: "تسجيل الدخول",
wrongAccountHint: "تم إرسال هذه الدعوة إلى {{email}}. قم بتسجيل الدخول باستخدام هذا الحساب.",
signInDifferentAccount: "تسجيل الدخول بحساب مختلف",
accept: "قبول",
decline: "رفض",
},
logoOrInitials: {
logoA11y: "شعار مساحة العمل",
initialsA11y: "الأحرف الأولى من مساحة العمل",
},
shellTabsListA11y: "أقسام إعدادات مساحة العمل",
teamManage: {
offerFailedTitle: "تعذّر إرسال العرض",
tryAgain: "حاول مرة أخرى بعد قليل.",
offerSent: "طُلب من {{name}} قبول الملكية. لن يتغير شيء حتى يقبل.",
linkCopied: "تم نسخ رابط الدعوة. أرسله إليهم بالطريقة التي تناسبك.",
inviteLinkTitle: "رابط الدعوة",
checkEmails: "تحقق من {{emails}} ثم حاول مرة أخرى.",
enterEmail: "أدخل عنوان بريد إلكتروني واحدًا على الأقل.",
invitesSent_zero: "لم تُرسل أي دعوات.",
invitesSent_one: "أُرسلت الدعوة إلى {{email}}. سيصله بريد إلكتروني فيه رابط للانضمام، وسيظهر ضمن الأعضاء بعد القبول.",
invitesSent_two: "أُرسلت دعوتان. يصل كل شخص بريد إلكتروني فيه رابط للانضمام، ويظهر ضمن الأعضاء بعد القبول.",
invitesSent_few: "أُرسلت {{count}} دعوات. يصل كل شخص بريد إلكتروني فيه رابط للانضمام، ويظهر ضمن الأعضاء بعد القبول.",
invitesSent_many: "أُرسلت {{count}} دعوة. يصل كل شخص بريد إلكتروني فيه رابط للانضمام، ويظهر ضمن الأعضاء بعد القبول.",
invitesSent_other: "أُرسلت {{count}} دعوة. يصل كل شخص بريد إلكتروني فيه رابط للانضمام، ويظهر ضمن الأعضاء بعد القبول.",
undeliveredTitle: "حُفظت الدعوة ولم يُرسل البريد",
undeliveredBody: "تعذّر إرسال بريد إلكتروني إلى {{emails}}. اضغط نسخ رابط الدعوة وأرسله إليهم بنفسك.",
copyInviteLink: "نسخ رابط الدعوة",
ok: "حسنًا",
joined: "انضممت إلى {{team}}. يظهر العمل المشترك مع الفريق الآن في الرئيسية وفي العمل.",
joinFailedTitle: "تعذّر الانضمام إلى الفريق",
notNow: "ليس الآن",
declineTitle: "رفض الدعوة؟",
declineBody: "هل تريد رفض الدعوة إلى {{team}}؟ ستحتاج إلى دعوة جديدة للانضمام لاحقًا.",
declineFailedTitle: "تعذّر رفض الدعوة",
created: "{{name}} جاهز. ادعُ أشخاصًا ليتمكنوا من رؤية أصوله وعمله.",
createFailedTitle: "تعذّر إنشاء الفريق",
createFailedBody: "تعذّر إنشاء الفريق الآن. حاول مرة أخرى بعد قليل.",
switchedTo: "أنت تعمل الآن في {{team}}",
switchFailedTitle: "تعذّر تبديل الفريق",
switchToA11y: "التبديل إلى {{team}}",
personalHint: "أنت في المساحة الشخصية ولا ترى إلا عملك. اضغط على فريق للتبديل إليه.",
tapToSwitchHint: "اضغط على فريق للتبديل إليه. تتغير الأصول والعمل إلى ما يخص ذلك الفريق.",
noTeamTitle: "لا يوجد فريق بعد",
noTeamBody: "أنشئ فريقًا لمشاركة الأصول والعمل مع زملائك. يمكنك دعوة الأشخاص بعد ذلك.",
adoptAssets_zero: "لا توجد أصول لإضافتها إلى {{team}}.",
adoptAssets_one: "أضف أصلك إلى {{team}}. أنت وحدك من يراه الآن.",
adoptAssets_two: "أضف أصليك إلى {{team}}. أنت وحدك من يراهما الآن.",
adoptAssets_few: "أضف أصولك الـ{{count}} إلى {{team}}. أنت وحدك من يراها الآن.",
adoptAssets_many: "أضف أصولك الـ{{count}} إلى {{team}}. أنت وحدك من يراها الآن.",
adoptAssets_other: "أضف أصولك الـ{{count}} إلى {{team}}. أنت وحدك من يراها الآن.",
adoptFailedTitle: "تعذّرت إضافة الأصول",
membershipHint: "يمكن للأشخاص الذين تدعوهم هنا تسجيل الدخول والعمل في هذا الفريق. للاحتفاظ ببيانات شخص دون منحه وصولًا (مقاول أو مستأجر)، أضفه في جهات الاتصال.",
emailPlaceholder: "alex@example.com\nsam@example.com",
inviteAsA11y: "دعوة بصفة {{role}}",
roleDescription: {
member: "إنجاز أوامر العمل والفحوصات والطلبات وتحديثها.",
admin: "دعوة الأشخاص وإزالتهم وتغيير إعدادات الفريق.",
},
sendInvite_zero: "إرسال الدعوة",
sendInvite_one: "إرسال الدعوة",
sendInvite_two: "إرسال دعوتين",
sendInvite_few: "إرسال {{count}} دعوات",
sendInvite_many: "إرسال {{count}} دعوة",
sendInvite_other: "إرسال {{count}} دعوة",
inviteExpired: "انتهت في {{date}}. اضغط إعادة الإرسال لدعوتهم مرة أخرى.",
inviteSentOn: "أُرسلت في {{date}}",
resendFailedTitle: "تعذّرت إعادة إرسال الدعوة",
resent: "أُعيد إرسال الدعوة إلى {{email}}.",
resendA11y: "إعادة إرسال الدعوة إلى {{email}}",
cancelInviteA11y: "إلغاء دعوة {{email}}",
cancelInviteFailedTitle: "تعذّر إلغاء الدعوة",
cancelInviteConfirmTitle: "إلغاء هذه الدعوة؟",
cancelInviteConfirmBody: "إذا كان لدى {{email}} الرابط بالفعل، فسيتوقف عن العمل.",
cancelInviteConfirm: "إلغاء الدعوة",
membersTitle: "الأعضاء · {{n}}",
mfaPending: "{{n}} لم يُعدّوا التحقق بعد",
mfaAllCovered: "الجميع محميون",
mfaSocialExempt: "{{n}} يسجلون الدخول عبر Google أو Apple (غير مطلوب)",
mfaOnA11y: "فعّل {{name}} التحقق بخطوتين",
mfaOffA11y: "لم يفعّل {{name}} التحقق بخطوتين",
moreActionsA11y: "إجراءات أخرى لـ {{name}}",
yourSkills: "مهاراتك",
memberSkills: "مهارات {{name}}",
skillsSaveFailedTitle: "تعذّر حفظ هذه المهارات",
skillsSaveFailedBody: "لم يتغير شيء. تحقق من اتصالك وحاول مرة أخرى.",
saveSkills: "حفظ المهارات",
transferBody: "هل تعرض ملكية الفريق على {{name}}؟ يجب أن يقبل قبل أن يتغير أي شيء، وبعدها تصبح مسؤولًا.",
sendOffer: "إرسال العرض",
resetMfaBody: "هل تريد مسح إعداد التحقق بخطوتين لدى {{name}}؟ سيُطلب منه إعداد تطبيق مصادقة من جديد عند تسجيل الدخول التالي. استخدم هذا عندما يفقد أحدهم هاتفه.",
reset: "إعادة تعيين",
resetMfaDoneTitle: "أُعيد تعيين التحقق بخطوتين",
resetMfaDone: "يمكن لـ {{name}} إعداد التحقق بخطوتين من جديد عند تسجيل الدخول التالي.",
resetMfaNothing: "لم يكن لدى {{name}} تحقق بخطوتين. لا شيء لإعادة تعيينه.",
resetFailedTitle: "تعذّرت إعادة تعيين التحقق بخطوتين",
removeBody: "هل تريد إزالة {{name}} من الفريق؟",
removeBodyWithJobs_zero: "هل تريد إزالة {{name}} من الفريق؟",
removeBodyWithJobs_one: "هل تريد إزالة {{name}} من الفريق؟ يبقى أمر عمل مفتوح واحد مسندًا إليه حتى تعيد إسناده.",
removeBodyWithJobs_two: "هل تريد إزالة {{name}} من الفريق؟ يبقى أمرا عمل مفتوحان مسندين إليه حتى تعيد إسنادهما.",
removeBodyWithJobs_few: "هل تريد إزالة {{name}} من الفريق؟ تبقى {{count}} أوامر عمل مفتوحة مسندة إليه حتى تعيد إسنادها.",
removeBodyWithJobs_many: "هل تريد إزالة {{name}} من الفريق؟ يبقى {{count}} أمر عمل مفتوحًا مسندًا إليه حتى تعيد إسنادها.",
removeBodyWithJobs_other: "هل تريد إزالة {{name}} من الفريق؟ يبقى {{count}} أمر عمل مفتوح مسندًا إليه حتى تعيد إسنادها.",
remove: "إزالة",
leaveBody: "هل تريد مغادرة {{team}}؟ ستحتاج إلى دعوة جديدة للانضمام مرة أخرى.",
leave: "مغادرة",
leaveFailedTitle: "تعذّرت مغادرة الفريق",
deleteBody: "هل تريد حذف {{team}}؟ تعود أصوله وفحوصاته وأوامر عمله إلى حسابك. لا يمكن التراجع عن ذلك.",
delete: "حذف",
deleteFailedTitle: "تعذّر حذف الفريق",
renameFailedTitle: "تعذّرت إعادة تسمية الفريق",
theMember: "العضو",
noMemberMatches: "لا يوجد عضو مطابق.",
defaults: {
companyTitle: "الإعدادات الافتراضية للشركة",
companyHint: "تنطبق على شركتك بالكامل. يمكنك أيضًا تغييرها من الحساب ← الإعدادات.",
teamTitle: "إعدادات هذا الفريق",
teamHint: "استخدم الإعدادات الافتراضية للشركة أو حدّد إعدادات مختلفة لهذا الفريق.",
teamCurrency: "عملة الفريق",
teamSharing: "كيف يشارك هذا الفريق العمل",
sameAsCompany: "مثل الشركة",
setForTeam: "تحديد لهذا الفريق",
inUse: "المستخدم لهذا الفريق",
},
errors: {
teamNotFound: "تعذّر العثور على هذا الفريق. ارجع وافتحه مرة أخرى.",
inviteNotFound: "لم يتم العثور على هذه الدعوة أو انتهت صلاحيتها.",
invite: "تعذّر إرسال الدعوة. حاول مرة أخرى بعد قليل.",
resend: "تعذّرت إعادة إرسال الدعوة. حاول مرة أخرى بعد قليل.",
accept: "تعذّر الانضمام إلى الفريق. تأكد أن الدعوة ما زالت مفتوحة وأنك سجلت الدخول بالبريد الإلكتروني الذي أُرسلت إليه.",
deleteTeam: "تعذّر حذف الفريق. حاول مرة أخرى بعد قليل.",
onlyOwnerDelete: "مالك الفريق وحده يمكنه حذف الفريق.",
transfer: "تعذّر إرسال العرض. حاول مرة أخرى بعد قليل.",
acceptTransfer: "تعذّر قبول الملكية. حاول مرة أخرى بعد قليل.",
declineTransfer: "تعذّر رفض العرض. حاول مرة أخرى بعد قليل.",
cancelTransfer: "تعذّر إلغاء العرض. حاول مرة أخرى بعد قليل.",
promote: "تعذّر جعله مالكًا. حاول مرة أخرى بعد قليل.",
demote: "تعذّر تغيير دوره. حاول مرة أخرى بعد قليل.",
alreadyMember: "هذا الشخص موجود في الفريق بالفعل.",
alreadyInvited: "أُرسلت دعوة إلى هذا البريد الإلكتروني بالفعل.",
noAccount: "ما زال إعداد مساحة عملك جاريًا. انتظر لحظة ثم حاول مرة أخرى.",
},
},
featuresScreen: {
  lockedRowA11y: "{{feature}}، مقفلة بالخطة. يفتح الخطط التي تتضمنها.",
  statusNotYet: "غير متاحة بعد",
  title: "الميزات",
  subtitle: "ما هو مفعّل في مساحة العمل هذه. اضغط على ميزة مقفلة بالخطة لرؤية الخطط التي تتضمنها.",
  simplePresetTitle: "الإعداد البسيط",
  simplePresetBody: "المجموعة الأساسية لفريق صغير: الأصول والمواقع والطلبات والفحوصات والمهام والمراجعات والتقارير وجهات الاتصال وخطط الصيانة. تُطفأ التحليلات والمقاولون والفرق والتكاملات والذكاء الاصطناعي وأدوات المطوّرين، وكل منها على بُعد مفتاح واحد هنا.",
  simplePresetButton: "استخدم الإعداد البسيط",
  simplePresetConfirm: "إطفاء التحليلات والمقاولين والفرق والتكاملات والذكاء الاصطناعي وأدوات المطوّرين لمساحة العمل هذه؟ يبقى كل منها على بُعد مفتاح واحد.",
  simplePresetApplied: "تم التبديل إلى الإعداد البسيط.",
  switchA11y: "{{feature}}: تشغيل أو إيقاف لمساحة العمل هذه",
  switchFailed: "لم يُحفظ التغيير. تحقق من الاتصال وحاول مجددًا.",
  adminHint: "يبدّل المالكون والمشرفون الميزات هنا؛ ويرى الآخرون ما هو مفعّل.",
  statusEnabled: "مفعّلة",
  statusDisabled: "معطّلة",
  statusLockedPlan: "مقفلة بحسب الخطة",
  statusRestrictedRole: "مقيّدة بحسب الدور",
  statusDisabledAdmin: "متوقفة لمساحة العمل هذه",
  statusBeta: "تجريبية",
  statusDependency: "تحتاج إلى ميزة أخرى",
  statusUnavailable: "غير متاحة",
  statusSetByAssetwrxOn: "مفعّلة من AssetWRX",
  statusSetByAssetwrxOff: "متوقفة من AssetWRX",
  statusLoading: "جارٍ التحقق…",
  modules: "الوحدات",
  capabilities: "القدرات",
  empty: "لا توجد ميزات لعرضها بعد.",
  planLabel: "الخطة: {{plan}}",
  planUngated: "الخطة: لا حدود مطبّقة",
},
featureCatalog: {
modules: {
assets: { title: "الأصول" },
sites: { title: "المواقع" },
requests: { title: "الطلبات" },
inspections: { title: "الفحوصات" },
jobs: { title: "المهام" },
reviews: { title: "المراجعات" },
reports: { title: "التقارير" },
analytics: { title: "الرؤى" },
contacts: { title: "جهات الاتصال" },
contractors: { title: "المقاولون" },
teams: { title: "الفرق" },
automation: { title: "الأتمتة" },
integrations: { title: "التكاملات" },
ai: { title: "الذكاء الاصطناعي" },
administration: { title: "الإدارة" },
settings: { title: "الإعدادات" },
developer: { title: "المطوّرون" },
},
capabilities: {
  asset_360: { title: "Asset 360", description: "تقرير Asset 360: الحكم العام وبطاقة الأداء وأقسام للقارئ المختار وخطة العمل وجودة البيانات، مع نسخة بالذكاء الاصطناعي عند الطلب." },
  site_360: { title: "Site 360", description: "تقرير Site 360: الموقع كله بمبانيه ومناطقه، والامتثال والمخاطر والأعمال والمقاولون، مع نسخة بالذكاء الاصطناعي عند الطلب." },
  esg: { title: "الاستدامة والحوكمة البيئية (ESG)", description: "الطاقة والكربون وشهادات أداء الطاقة وسجلات غازات التبريد المفلورة للمواقع والأصول، مع عرض للمحفظة وفصل ESG في Site 360 وAsset 360. إضافة مدفوعة." },
  esg_ai_writeup: { title: "ملخص ESG بالذكاء الاصطناعي", description: "ملخص ESG مكتوب مع إجراءات مقترحة، يعدّه الذكاء الاصطناعي من أرقام ESG. يستهلك أرصدة." },
group_rules: { title: "قواعد المجموعات", description: "قواعد تجدول قائمة التحقق نفسها على كل أصل مطابق، وتبقيها على الأصول المضافة لاحقًا." },
rounds: { title: "الجولات", description: "مهمة واحدة تمر بقائمة تحقق على عدة أصول بالترتيب." },
contractor_inspections: { title: "فحوص ينفذها المقاولون", description: "أسند فحصاً إلى مقاول لديه حساب AssetWRX؛ يظهر في عمله وينفذه بقائمة الفحص نفسها." },
sub_jobs: { title: "الأعمال الفرعية", description: "يمكن أن يضم أمر العمل أعمالًا فرعية، لكل منها شخصها أو مقاولها وتاريخها وفحوصها وتكاليفها؛ وينتظرها أمر العمل الرئيسي." },
custom_asset_types: { title: "أنواع أصول وحقول مخصّصة", description: "أنواع أصول خاصة بك بحقولها الخاصة، إلى جانب المكان والمعدات والمركبة وغير ذلك." },
bulk_asset_setup: { title: "الإنشاء الجماعي وقوالب المنشآت", description: "أنشئ أماكن أو أصولًا كثيرة دفعة واحدة، أو مبنى كاملًا من قالب منشأة." },
contact_import: { title: "استيراد جهات الاتصال", description: "استورد جهات الاتصال من دفتر عناوين الهاتف أو من ملف." },
ai_checklist_generation: { title: "إنشاء قوائم التحقق بالذكاء الاصطناعي", description: "صِغ قائمة تحقق بالذكاء الاصطناعي من وصف أو صورة أو مستند." },
assistant_changes: { title: "المساعد يمكنه تغيير السجلات", description: "يُعدّ المساعد أصولًا ومواقع وفحوصات ومهام وقواعد مجموعات جديدة أو محدّثة ليؤكدها شخص." },
assistant_planning: { title: "تخطيط المساعد وتحسينه", description: "يخطط المساعد الأيام، ويوازن عبء العمل، ويقترح الأوقات، وينصح بشأن برامج الصيانة." },
assistant_insights: { title: "رؤى المساعد وملخّصاته", description: "يشرح المساعد الاتجاهات والتكاليف والأسباب، ويُعدّ التقارير، ويقدّم ملخّصًا أسبوعيًا." },
assistant_photo: { title: "أسئلة المساعد عن الصور", description: "اسأل المساعد عن صورة تلتقطها أو تختارها." },
assistant_voice: { title: "صوت المساعد", description: "تحدّث إلى المساعد واستمع إلى ردوده (يتطلب أحدث إصدار من التطبيق في المتجر)." },
feature_requests: { title: "طلبات الميزات", description: "اطلب ميزة، وتابع طلباتك، وصوّت على الأفكار التي ندرسها." },
qr_codes: { title: "رموز QR", description: "إنشاء رموز QR ومسحها لتعريف الأصول." },
barcode_scan: { title: "مسح الباركود", description: "امسح الباركود للبحث عن معرّفات الأصول أو تسجيلها." },
condition_intelligence: { title: "ذكاء الحالة", description: "حالة الأصل وفق القواعد، وتوصيات المخاطر، وملاءمة الفنيين في صفحة الأصل وفي المُجدول." },
location_tracking: { title: "تتبّع الموقع", description: "سجل مواقع الأصل والمواقع التي تسجّلها الفحوصات والمهام والمصادر المتصلة." },
knowledge_base: { title: "قاعدة المعرفة", description: "أدلة الاستخدام والأسئلة الشائعة والملاحظات والملفات على الأصل، والبحث في المعرفة عبر الأصول، وروابط مشاركة دون تسجيل دخول." },
approvals: { title: "الموافقات", description: "مسارات الموافقة والفرز للطلبات وعمليات الإكمال." },
photo_capture: { title: "التقاط الصور", description: "التقط الصور كأدلة في الفحوصات والمهام والطلبات." },
video_capture: { title: "تسجيل الفيديو", description: "أرفق مقاطع فيديو قصيرة كأدلة." },
drawing: { title: "الرسم والتعليق التوضيحي", description: "أضف رسومًا وتعليقات توضيحية على الصور." },
voice_dictation: { title: "الإملاء الصوتي", description: "أملِ الملاحظات ومحتوى العمل الميداني بصوتك." },
speech_recognition: { title: "التعرّف على الكلام", description: "تحويل الكلام إلى نص على الجهاز لتشغيل الإملاء الصوتي." },
ml_kit: { description: "أدوات تعلّم آلي على الجهاز (التسميات والباركود والنصوص)." },
evidence_intelligence: { title: "ذكاء الأدلة", description: "حلّل أدلة العمل على الجهاز، ولا يُستعان بالذكاء الاصطناعي إلا عند الطلب." },
wrx_vision: { description: "امسح مجموعة أو بندًا في الفحص؛ قراءة العدادات والمعرّفات والباركود على الجهاز، مع مراجعة الاقتراحات قبل حفظ أي شيء." },
wrx_vision_cloud: { title: "تحليل WRX Vision السحابي", description: "تحليل سحابي لمسح Vision: الحالة والعيوب والفحوصات غير الملحوظة وفق معايير قائمة التحقق." },
wrx_vision_pack_fleet: { title: "حزمة الأساطيل من WRX Vision", description: "فحوصات أضرار المركبات: الانبعاجات والخدوش والزجاج والأضواء والإطارات والعجلات." },
wrx_vision_pack_equipment: { title: "حزمة المعدات من WRX Vision", description: "فحوصات المعدات والآلات: الواقيات والتسريبات والخراطيم والكابلات والتآكل واللوحات والعدادات." },
wrx_vision_pack_property: { title: "حزمة العقارات من WRX Vision", description: "فحوصات الغرف والمباني: الرطوبة والنمو الشبيه بالعفن والتشققات والزجاج والتجهيزات وإمكانية الوصول." },
wrx_vision_pack_safety: { title: "حزمة معدات السلامة من WRX Vision", description: "فحوصات بصرية لمعدات السلامة: طفايات الحريق وأجهزة الإنذار واللافتات وإمكانية الوصول. لا تمنح أي شهادة." },
wrx_vision_training_share: { title: "بيانات تحسين WRX Vision", description: "مفعّل افتراضيًا: تُستخدم صور الأدلة التي استندت إليها اقتراحات Vision المراجَعة لتحسين Vision. يمكن لمالك مساحة العمل إيقافه." },
wrx_verified: { description: "أدلة الإكمال على المهام: النتائج المتوقعة، وصور قبل وبعد، وفحص للأدلة يقرّر فيه المراجِع." },
work_intelligence: { title: "ذكاء العمل", description: "واجهة مشتركة لتحليل أدلة العمل عبر جميع مسارات العمل." },
work_planning: { description: "خطّط لمن يفعل ماذا ومتى وبأي ترتيب: تقويم الأشخاص حسب الوقت، والسعة، والتنقّل، وجاهزية القطع والمهارات، وخطط مقترحة يطبّقها شخص." },
schedule_exceptions: { title: "حوكمة الجدولة", description: "طلبات من الميدان لتخطي العمل المجدول أو إعادة جدولته أو إعادة إسناده، والقرارات بشأنها." },
compliance_register: { title: "سجل الامتثال", description: "سجل على مستوى مساحة العمل للشهادات والتجديدات والأدلة المتأخرة." },
journey_intelligence: { title: "ذكاء الرحلات", description: "سرد ورؤى بالذكاء الاصطناعي حول الرحلات التشغيلية." },
journey_analytics: { title: "تحليلات الرحلات", description: "لوحات معلومات ومسارات تحويل لتدفّق الرحلات عبر المحفظة." },
power_bi_export: { title: "التصدير إلى Power BI", description: "صدّر مجموعات بيانات التحليلات إلى Power BI." },
quotes: { title: "عروض الأسعار", description: "اطلب عروض أسعار المقاولين وقارن بينها واختر منها." },
scheduling: { title: "الجدولة", description: "التخطيط بالتقويم والعمل المجدول." },
recurring_work: { title: "العمل المتكرر", description: "فحوصات متكررة وجداول صيانة وقائية." },
maintenance_programmes: { title: "برامج الصيانة", description: "برامج صيانة متعددة المراحل حسب العداد والتقويم ومراحل متسلسلة." },
csv_import: { title: "الاستيراد من CSV", description: "استورد جهات الاتصال والأصول من ملف CSV." },
excel_import: { title: "الاستيراد من Excel", description: "استورد بيانات منظمة من مصنفات Excel." },
power_automate: { description: "شغّل مسارات Power Automate من أحداث المنصة." },
iot_connectors: { title: "موصلات إنترنت الأشياء", description: "استقبل إشارات إنترنت الأشياء لإطلاق العمل." },
embed: { title: "AssetWRX المضمّن", description: "شغّل واجهات مختارة من AssetWRX (العمل والأصول والفحوصات والمهام والتقارير) داخل بوابة أخرى، دون إطار تطبيق AssetWRX." },
embed_interactive: { title: "التضمين التفاعلي", description: "اسمح لواجهات AssetWRX المضمّنة بتحديث الأصول وإجراء الفحوصات وتغيير المهام، لا عرضها فقط." },
ai_summary: { title: "ملخصات الذكاء الاصطناعي", description: "ملخصات ومسودات يولّدها الذكاء الاصطناعي في مختلف الشاشات." },
ai_assistants: { title: "مساعدو الذكاء الاصطناعي", description: "مساعدون تفاعليون بالذكاء الاصطناعي." },
field_ai_assist: { title: "مساعدة الذكاء الاصطناعي في الحقول", description: "الإملاء والتحسين والتلخيص في حقل النص حيث تعمل." },
industry_packs: { title: "حزم القطاعات", description: "ثبّت حزمًا منتقاة من قوائم التحقق وخطط الصيانة، مع اقتراحات الحزم لكل أصل." },
offline_mode: { title: "وضع عدم الاتصال", description: "اعمل دون اتصال مع مزامنة تلقائية عند عودة الاتصال." },
notifications: { title: "الإشعارات", description: "إشعارات داخل التطبيق وفورية وعبر البريد الإلكتروني." },
rest_api: { description: "وصول مباشر إلى واجهة REST API." },
graphql: { description: "وصول إلى واجهة GraphQL API." },
webhooks: { title: "خطافات الويب", description: "اشترك في خطافات ويب صادرة موقّعة." },
mcp: { description: "وصول عبر Model Context Protocol لعمليات التكامل القائمة على الوكلاء." },
},
},
shellTabs: {
industryPacks: "حزم القطاعات",
assetTypes: "أنواع الأصول",
features: "الميزات",
overview: "نظرة عامة",
organization: "المؤسسة",
defaults: "الافتراضيات",
teams: "الفرق",
reports: "هوية التقارير",
integration: "التكاملات",
},
integrationHub: {
  ownerOnly: "يمكن لمالك مساحة العمل فقط، {{owner}}، إعداد التكاملات ومفاتيح API ووصول الذكاء الاصطناعي. يمكنك رؤية ما هو متصل؛ اطلب من {{owner}} إعداد أي شيء جديد.",
  ownerOnlyUnnamed: "يمكن لمالك مساحة العمل فقط إعداد التكاملات ومفاتيح API ووصول الذكاء الاصطناعي. يمكنك رؤية ما هو متصل؛ اطلب من مالك مساحة العمل إعداد أي شيء جديد.",
askOwnerSetup: "اطلب من {{owner}} إعداد هذا.",
askOwnerSetupUnnamed: "اطلب من مالك مساحة العمل إعداد هذا.",
tryAgainShortly: "حاول مرة أخرى بعد لحظات.",
loadOfflineHint: "تأكد من أن هذا الجهاز متصل بالإنترنت، ثم حاول مرة أخرى.",
conditionInvalidTitle: "تحقق من هذا الشرط",
conditionInvalidBody: "للقائمة، اكتب القيم بين أقواس مربعة، مثل [\"مفتوح\", \"متأخر\"].",
recipeDraftCreated: "تم حفظ مسودة الوصفة. شغّلها عندما تكون جاهزًا.",
retryQueued: "بدأت إعادة المحاولة. تظهر النتيجة في سجل التشغيل.",
importRowFailed: "تعذّر حفظ الصف {{row}}. تحقق من قيم هذا الصف.",
importCustomTypeUnknown: "الصف {{row}}: لا يوجد نوع أصل باسم \"{{name}}\" لهذا الصنف، لذا حُفظ بدون نوع.",
importSitsInMissing: "الصف {{row}}: تعذّر العثور على \"{{name}}\" لوضعه داخله. حُفظ دون أن يكون داخل أي شيء.",
importSitsInNotAllowed: "الصف {{row}}: لا يمكن أن يوجد في \"{{name}}\" (المكان داخل مكان فقط، والمركبة لا توجد داخل شيء). حُفظ دون أن يكون داخل أي شيء.",
importFileUnreadableTitle: "تعذّرت قراءة الملف",
importFileUnreadable: "احفظه بصيغة CSV أو Excel، ثم اختره مرة أخرى.",
importFailed: "توقف الاستيراد. تحقق من ملفك، ثم اختر إعادة محاولة الاستيراد.",
apiErrors: {
sessionExpired: "جلستك لم تعد صالحة. سجّل الدخول مرة أخرى، ثم أعد المحاولة.",
ownerOnly: "يمكن لمالك مساحة العمل فقط إعداد التكاملات ومفاتيح API ووصول الذكاء الاصطناعي. اطلب منه القيام بذلك.",
forbidden: "ليست لديك صلاحية للقيام بهذا.",
sourceInactive: "هذا المصدر المتصل غير نشط. أعد تفعيله أو جدّد الرمز قبل إعادة المحاولة.",
mcpAuth: "تعذّر على اتصال الذكاء الاصطناعي تسجيل الدخول. تحقق من مفتاحه، ثم حاول مرة أخرى.",
mcpUnreachable: "تعذّر الوصول إلى خادم MCP. تحقق من عنوان URL وبيانات الاعتماد والوصول إلى الشبكة، ثم حاول مرة أخرى.",
sourceToken: "رمز مصدر البيانات هذا غير صالح لمساحة العمل هذه.",
mcpRuntime: "تعذّر إكمال اتصال الذكاء الاصطناعي. تحقق من عنوانه ومفتاحه، ثم حاول مرة أخرى.",
mcpAdmin: "تعذّر تحديث اتصال الذكاء الاصطناعي. تحقق من التفاصيل وحاول مرة أخرى.",
automationRun: "تعذّر إكمال اختبار الأتمتة أو إعادة محاولتها. راجع الإعدادات وحاول مرة أخرى.",
automationAdmin: "تعذّر حفظ الأتمتة. تحقق مما أدخلته وحاول مرة أخرى.",
connectedIngest: "لم تُقبل رسالة الجهاز. تحقق من الرمز ومراجع الأصول التي يرسلها، ثم حاول مرة أخرى.",
connectedAdmin: "تعذّر تحديث مصدر البيانات هذا. تحقق من المصدر أو القاعدة أو الرسالة وحاول مرة أخرى.",
workspaceAdmin: "تعذّر حفظ هذا الإعداد. حاول مرة أخرى، أو اسأل مالك مساحة العمل.",
generic: "تعذّر إكمال الطلب. يرجى المحاولة مرة أخرى.",
},
  importRetry: "إعادة محاولة الاستيراد",
  importExcelFeature: "استيراد من Excel",
  importRetrying: "جارٍ إعادة المحاولة…",
  importStopped: "توقف عند الصف {{row}}: {{message}} لم يُستورد هذا الصف ولا الصفوف التي بعده.",
  importWizard: {
  step: {
  file: "الملف",
  object: "النوع",
  map: "المطابقة",
  preview: "المعاينة",
  done: "تم",
  },
  skip: "— تخطٍّ —",
  noDefault: "— بلا قيمة افتراضية —",
  optionalDefault: "قيمة افتراضية اختيارية…",
  sampleLeadDownload: "جديد على الاستيراد؟ نزّل مثالًا جاهزًا (أعمدة وقيم صالحة).",
  sampleLeadCopy: "جديد على الاستيراد؟ انسخ مثالًا جاهزًا (أعمدة وقيم صالحة).",
  sampleAssetsDownload: "تنزيل نموذج الأصول",
  sampleAssetsCopy: "نسخ نموذج الأصول",
  sampleContactsDownload: "تنزيل نموذج جهات الاتصال",
  sampleContactsCopy: "نسخ نموذج جهات الاتصال",
  sampleAssetsA11yDownload: "تنزيل ملف CSV نموذجي لاستيراد الأصول",
  sampleAssetsA11yCopy: "نسخ ملف CSV نموذجي لاستيراد الأصول",
  sampleContactsA11yDownload: "تنزيل ملف CSV نموذجي لاستيراد جهات الاتصال",
  sampleContactsA11yCopy: "نسخ ملف CSV نموذجي لاستيراد جهات الاتصال",
  sampleCalloutDownload: "جداول بيانات نموذجية: نزّل ملفات النماذج من الخطوة 1 أو من الأسفل.",
  sampleCalloutCopy: "جداول بيانات نموذجية: انسخ ملفات النماذج من الخطوة 1 أو من الأسفل.",
  formatReferenceShow: "عرض المرجع الكامل لتنسيق البيانات",
  formatReferenceHide: "إخفاء المرجع الكامل لتنسيق البيانات",
  },
webhookSecretIssued: "تم إصدار بيانات اعتماد جديدة لخطاف الويب. انسخها الآن — لن تُعرض مرة أخرى.",
webhookSecretReveal: "إظهار",
webhookSecretHide: "إخفاء",
webhookSecretCopy: "نسخ",
webhookSecretCopied: "تم النسخ",
webhookSecretDismiss: "إغلاق",
webhookSecretHiddenA11y: "بيانات اعتماد خطاف الويب، مخفية. استخدم “إظهار” لعرضها.",
webhookSecretRevealedA11y: "بيانات اعتماد خطاف الويب، ظاهرة على الشاشة.",
breadcrumb: "الحساب · مساحة العمل · التكاملات",
breadcrumbShort: "مساحة العمل · التكاملات",
titleShort: "مركز التكاملات",
hintShow: "نصائح التبويب",
hintHide: "إخفاء النصائح",
eyebrow: "تكاملات مساحة العمل",
title: "تكاملات جاهزة للأعمال",
metaLine: "اربط أدوات عملك باستخدام مفاتيح API وخطافات الويب والأتمتة البسيطة.",
contextHintApis: "الواجهات البرمجية أولاً: أنشئ مفاتيح آمنة، راجع الصلاحيات (scopes)، وافتح مرجع API المباشر.",
contextHintApisGateway: "مفاتيح API والوصول: الإدارة تستخدم جلستك المسجّلة عبر بوابة مساحة العمل. أنشئ المفاتيح خطوة بخطوة، تحقق من الاتصال، ثم افتح المرجع المباشر.",
contextHintMcp: "MCP لمساحة العمل: سجّل الخوادم الخارجية المعتمدة، وشفّر بيانات الاعتماد، واكتشف البيانات الوصفية، واحتفظ بسجل قابل للتدقيق لعمليات الاستدعاء.",
contextHintImport: "استيراد البيانات: حمّل جداول البيانات واربط سجلاتك بسرعة.",
contextHintAutomations: "محفزات الأحداث: الوصفات وسجل التشغيل. أنشئ حسابات الخدمة ومفاتيح API من تبويب مفاتيح API والوصول — وليس هنا.",
contextHintConnected: "الإدخال المتصل تبويب مستقل: أنشئ مصادر، وبدّل الرموز لكل مصدر، وراجع الأحداث الواردة والتطابقات غير المحلولة، ثم فعّل القواعد. استخدم مفاتيح API والوصول فقط عندما تريد حساب خدمة لمساحة العمل بدلاً من رمز الإدخال.",
contextHintConnectedShort: "أنشئ مصدرًا، وانسخ الرمز أحادي الاستخدام من النافذة المنبثقة، وأرسل JSON بطلب POST إلى رابط الإدخال، ثم أضف قواعد اختيارية. مفاتيح حساب الخدمة موجودة تحت مفاتيح API والوصول.",
connectedAssetsLink: "الأصول المتصلة",
resourcesHelp: "مرجع API (داخل التطبيق)",
mainTabImport: "استيراد البيانات",
mainTabAutomations: "محفزات الأحداث",
mainTabApisAccess: "مفاتيح API والوصول",
mainTabMcp: "خوادم MCP",
mainTabConnected: "الإدخال المتصل",
guidedCategory: {
workflow: "سير العمل اليومي",
inspection: "إبلاغ نظام آخر عن الفحوصات",
job: "إبلاغ نظام آخر عن أوامر العمل",
asset_sync: "مزامنة الأصول",
inbound_webhook: "الاستقبال من نظام آخر",
scheduled: "وفق جدول",
outbound: "الاختبار",
},
journey: {
stage_choose: "اختيار",
stage_configure: "تكوين",
stage_authorise: "تفويض",
stage_mapping: "ربط",
stage_preview: "معاينة",
stage_test: "اختبار",
stage_activate: "تفعيل",
stage_monitor: "مراقبة",
stepCounter: "الخطوة {{current}} من {{total}}",
back: "رجوع",
next: "استمرار",
finish: "إنهاء",
close: "إغلاق",
loading: "جارٍ التحميل…",
testing: "جارٍ العمل…",
succeeded: "نجاح",
failed: "فشل",
requestId: "رقم الطلب",
retry: "إعادة المحاولة",
nameLabel: "اسم الاتصال",
outcome_read: "قراءة البيانات من AssetWRX",
outcome_read_desc: "يسحب النظام الآخر الأصول أو الفحوصات أو أوامر العمل من AssetWRX.",
outcome_send: "إرسال البيانات إلى AssetWRX",
outcome_send_desc: "ينشئ النظام الآخر سجلات في AssetWRX أو يحدّثها.",
outcome_listen: "استقبال الأحداث من AssetWRX",
outcome_listen_desc: "يُشعر AssetWRX النظام الآخر عند حدوث تغييرات.",
outcome_combination: "مزيج منها",
outcome_combination_desc: "اتجاهان — قراءة وكتابة والبقاء متزامنًا.",
createAccess: "إنشاء وصول آمن",
accessCreated: "تم إنشاء الوصول الآمن",
accessFailed: "تعذّر إنشاء الوصول الآمن",
keyExpiryLabel: "انتهاء صلاحية المفتاح",
keyExpiry30: "30 يومًا",
keyExpiry90: "90 يومًا",
keyExpiry365: "سنة واحدة",
keyExpiryNever: "أبدًا",
apiKeyLabel: "مفتاح API",
customScopesHint: "فعّل فقط الصلاحيات التي يحتاجها هذا الاتصال.",
elevatedScopeHelp: "تحتاج وصولاً غير مقيّد؟ راجعه وأنشئه في وحدة التحكم المتقدمة.",
matchField: "مطابقة السجلات",
matchExternalId: "مطابقة الأصول بواسطة المعرّف الخارجي",
idempotencyPolicy: "تستخدم الأحداث المصدرية المكررة نفس معرّف حدث المصدر، لذلك لا تؤدي إعادة المحاولة إلى إنشاء عمل مكرر.",
conflictPolicy: "عندما يغيّر النظامان سجلًا",
conflictPolicyNote: "يبني فريق تقنية المعلومات هذه القاعدة في المزامنة؛ ويعرضها AssetWRX له في صفحة الاتصال. لتجنّب التكرار، تبحث المزامنة عن كل أصل بمعرّفه الخارجي قبل إنشائه.",
conflict_manual_review: "اسأل شخصًا",
conflict_manual_review_desc: "الأكثر أمانًا. لا يستبدل نظامك سجلًا غيّره أحد في AssetWRX، بل يعلّمه ليراجعه شخص.",
conflict_source_wins: "نظامك هو المرجع",
conflict_source_wins_desc: "يحدّث نظامك سجل AssetWRX الذي له المعرّف الخارجي نفسه.",
conflict_assetwrx_wins: "AssetWRX هو المرجع",
conflict_assetwrx_wins_desc: "يترك نظامك السجلات التي غُيّرت في AssetWRX كما هي.",
previewTitle: "مراجعة قبل الاختبار",
previewHint: "أكّد الغرض التجاري والوصول وقواعد المعالجة. الاختبار لن يفعّل الاتصال.",
previewConnection: "الاتصال",
previewAccess: "الوصول",
previewDestination: "الوجهة",
previewEvents: "الأحداث",
previewScopeCount_zero: "{{count}} صلاحية بأقل امتياز",
previewScopeCount_one: "صلاحية واحدة بأقل امتياز",
previewScopeCount_two: "صلاحيتان بأقل امتياز",
previewScopeCount_few: "{{count}} صلاحيات بأقل امتياز",
previewScopeCount_many: "{{count}} صلاحيةً بأقل امتياز",
previewScopeCount_other: "{{count}} صلاحية بأقل امتياز",
previewConflict: "سياسة التعارض",
previewProviderDefault: "الإعداد الافتراضي الآمن لمزوّد الخدمة",
previewRetry: "إعادة المحاولات",
previewIdempotent: "آمن عند التكرار؛ يتم تجاهل الأحداث المكررة",
secretOnce: "انسخ هذا الآن — لن يمكن عرضه مرة أخرى لأسباب أمنية.",
secretSaved: "لقد حفظت هذا بشكل آمن",
copy: "نسخ",
copied: "تم النسخ",
testConnection: "اختبار الاتصال",
testStatusExplain: "سنستدعي نقطة نهاية الحالة للقراءة فقط بمفتاحك الجديد للتأكد من عملها. لن يتم إنشاء أو تغيير أي شيء.",
connected: "متصل",
connectedDetail: "قبل AssetWRX بيانات الاعتماد واستجاب بنجاح.",
connectionFailed: "فشل الاتصال",
quickStartExplain: "وجّه تطبيقك إلى عنوان URL الأساسي هذا وأرسل مفتاحك في رأس الطلب x-asset-inspector-key.",
baseUrlLabel: "عنوان URL الأساسي",
firstRequestLabel: "الطلب الأول",
quickStartKeyNote: "استبدل YOUR_API_KEY بالمفتاح الذي حفظته للتو. لا نخزّنه أبدًا في الأمثلة.",
ready: "اتصالك جاهز",
readyDetail: "يمكنك إدارته في أي وقت من اتصالاتك.",
activating: "جارٍ التشغيل…",
activateFailed: "لم يتم تشغيل اتصالك بعد",
activateFailedDetail: "اختر إعادة المحاولة. لم يُشغَّل أي شيء بعد.",
done: "تم",
na_openGuides: "فتح دليل المطورين",
na_openReference: "فتح مرجع API",
na_setupEvents: "إعداد الأحداث",
na_createAutomation: "إنشاء أتمتة",
na_manageSource: "إدارة المصدر والقواعد",
identifierExplain: "يجب أن يحدد كل حدث وارد الأصل الذي ينتمي إليه. اختر كيف ستُعرّف أجهزتك الأصول.",
idKind_external: "معرّف خارجي",
idKind_qr: "رمز QR",
createSource: "إنشاء مصدر بيانات",
sourceCreated: "تم إنشاء مصدر البيانات",
sourceFailed: "تعذّر إنشاء مصدر البيانات",
ingestTokenLabel: "رمز الإدخال",
ingestAddressLabel: "العنوان الذي ترسل إليه الأجهزة",
ingestHowTo: "أعطِ فريق الأجهزة هذا العنوان ورمز الإدخال. كل رسالة هي طلب HTTPS POST إلى العنوان مع الرمز في الترويسة x-connected-source-token.",
sendAnotherTest: "جرّب معرّفًا آخر",
sendTestExplain: "أرسل حدث اختبار آمن واحد الآن. اختياريًا، أدخل أحد معرّفات أصولك الحقيقية لرؤية مطابقة مباشرة.",
testIdentifierLabel: "معرّف الأصل (اختياري)",
sendTestEvent: "إرسال حدث اختبار",
eventMatched: "تم استلام الحدث · تمت مطابقة الأصل",
eventMatchedDetail: "قبل AssetWRX الحدث وربطه بالأصل المطابق.",
eventUnmatched: "تم استلام الحدث · لم يتم تحديد الأصل",
eventUnmatchedDetail: "الاتصال يعمل — لكن لم نتمكن من مطابقة هذا المعرّف بأصل. أدخل معرّف أصل حقيقيًا، أو عالج الأمر لاحقًا في الأحداث المتصلة.",
eventFailed: "تم رفض الحدث",
title_business: "ربط نظام أعمال",
business_choose_title: "ما الذي تقوم بربطه؟",
business_choose_hint: "أعطه اسمًا يمكنك التعرّف عليه واختر نوع النظام.",
business_outcome_title: "ما الذي تريد أن يقوم به؟",
business_outcome_hint: "يساعدنا هذا في اقتراح الوصول الآمن المناسب.",
business_mapping_title: "ربط السجلات والتعارضات",
business_mapping_hint: "استخدم معرّفات خارجية ثابتة وحدّد ما يحدث عند تغيير كلا النظامين لسجل ما.",
business_access_title: "إنشاء وصول آمن",
business_access_hint: "ينشئ AssetWRX حساب خدمة ومفتاح API واحد لهذا الاتصال.",
business_test_title: "اختبار الاتصال",
business_activate_title: "إنهاء",
sys_erp: "تخطيط موارد المؤسسات",
sys_crm: "إدارة علاقات العملاء",
sys_finance: "المالية",
sys_maintenance: "الصيانة",
sys_data: "منصة بيانات",
sys_custom: "تطبيق مخصص",
sys_other: "أخرى",
title_developer: "بناء تطبيق مخصص",
dev_choose_title: "سمّ تطبيقك",
dev_choose_hint: "يُستخدم هذا لتسمية مفتاح API لتتمكن من إيجاده لاحقًا.",
dev_access_title: "إنشاء وصول آمن",
dev_access_hint: "اختر أقل وصول يحتاجه هذا التطبيق. الوصول غير المقيّد موجود في وحدة التحكم المتقدمة.",
dev_quickstart_title: "أرسل طلبك الأول",
dev_activate_title: "إنهاء",
title_iot: "ربط مصدر بيانات",
iot_choose_title: "سمّ المصدر",
iot_choose_hint: "ما الذي يرسل البيانات إلى AssetWRX؟",
iot_configure_title: "كيف سيتم تحديد الأصول؟",
iot_token_title: "تأمين المصدر",
iot_token_hint: "ترسل الأجهزة هذا الرمز في رأس الطلب x-connected-source-token.",
iot_test_title: "إرسال الحدث الأول",
iot_activate_title: "إنهاء",
src_device: "جهاز / مستشعر",
src_gateway: "بوابة إنترنت الأشياء",
src_platform: "منصة إنترنت الأشياء",
src_external: "نظام خارجي",
title_webhook: "إنشاء اتصال أحداث",
wh_choose_title: "سمّ اتصال الأحداث هذا",
wh_choose_hint: "عند حدوث شيء في AssetWRX، إلى أين يجب أن نرسله؟",
wh_configure_title: "الوجهة والأحداث",
wh_secret_title: "إنشاء سر التوقيع",
wh_test_title: "إرسال حدث اختبار",
wh_activate_title: "تفعيل",
destUrlLabel: "رابط الوجهة",
destUrlError: "أدخل رابط https:// صالحًا.",
chooseEvents: "أي تغييرات يجب أن نرسلها؟",
signingExplain: "تحقّق من هذا التوقيع في كل عملية تسليم للتأكد من أنه صادر فعلاً من AssetWRX.",
signingSecretLabel: "سر التوقيع",
generateSecret: "إنشاء سر التوقيع",
webhookCreated: "تم إنشاء اتصال الأحداث",
webhookFailed: "تعذّر إنشاء اتصال الأحداث",
webhookTestExplain: "أرسل تسليمًا تجريبيًا موقّعًا إلى نقطة النهاية الآن للتأكد من قدرتها على استقبال الأحداث.",
sendTestDelivery: "إرسال تسليم تجريبي",
webhookTestSent: "تم تسليم حدث الاختبار",
webhookTestDetail: "قبلت نقطة نهايتك تسليمًا موقّعًا لحدث {{event}}{{http}}.",
webhookTestRejected: "لم تقبل نقطة نهايتك حدث الاختبار",
webhookTestFailed: "تعذّر إرسال حدث الاختبار",
na_viewDeliveries: "عرض التسليمات",
evtgrp_assets: "الأصول",
evt_asset_created: "تم إنشاء الأصل",
evt_asset_updated: "تم تحديث الأصل",
evt_asset_deleted: "تم حذف الأصل",
evtgrp_inspections: "عمليات التفتيش",
evt_inspection_created: "تم إنشاء التفتيش",
evt_inspection_updated: "تم تحديث التفتيش",
evt_inspection_completed: "تم إكمال التفتيش",
evtgrp_wrx: "WRX (أوامر العمل)",
evt_job_created: "تم إنشاء WRX",
evt_job_status: "تغيّرت حالة WRX",
evt_job_completed: "تم إكمال WRX",
evtgrp_contacts: "جهات الاتصال",
evt_contact_created: "تم إنشاء جهة الاتصال",
evt_contact_updated: "تم تحديث جهة الاتصال",
evtgrp_connected: "البيانات المتصلة",
evt_connected_received: "تم استلام حدث متصل",
evt_connected_unresolved: "حدث متصل غير مطابق",
evt_connected_alert: "تم رفع تنبيه متصل",
title_automation: "أتمتة عملية",
auto_choose_title: "ما الذي تريد أتمتته؟",
auto_choose_hint: "اختر نقطة انطلاق. يمكنك ضبط كل شيء بدقة بعد ذلك.",
auto_configure_title: "إنشاء الأتمتة",
auto_configure_hint: "بضعة اختيارات، ثم اقرأ الجملة — هذا بالضبط ما سيحدث.",
auto_test_title: "اختبار الأتمتة",
auto_activate_title: "إنهاء",
tmpl_inspection_issue: "عند إكمال تفتيش",
tmpl_wrx_completed: "عند إكمال WRX",
tmpl_wrx_status: "عند تغيّر حالة WRX",
tmpl_asset_changed: "عند تغيّر أصل",
tmpl_scratch: "البدء من الصفر",
tmpl_inbound_webhook: "عندما يستدعي نظام آخر خطاف الويب الخاص بك",
tmpl_action_create_wrx: "إنشاء طلب عمل (WRX)",
tmpl_action_send_event: "إرساله إلى خطاف الويب الخاص بك",
tmpl_action_notify: "إشعار نظام آخر",
tmpl_action_choose: "تختار في أداة الإنشاء",
tmpl_action_inbound_wrx: "إنشاء WRX من الطلب",
automationCreateExplain: "سننشئ هذه الأتمتة كمسودة. تضيف الشروط والإجراءات الدقيقة في أداة الإنشاء، ثم تفعّلها.",
createAutomation: "إنشاء أتمتة",
automationCreated: "تم إنشاء مسودة الأتمتة",
automationFailed: "تعذّر إنشاء الأتمتة",
automationTestExplain: "شغّل الأتمتة مرة واحدة الآن للتأكد من أن المشغّل متصل بشكل صحيح. لا تعمل المسودات من الأتمتة من تلقاء نفسها.",
runTest: "تشغيل الاختبار",
automationRan: "تم إكمال تشغيل الاختبار",
automationRanDetail: "حالة التشغيل: {{status}}. أضف إجراءات في أداة الإنشاء لتجعلها تعمل.",
automationCreateExplain2: "سننشئ هذه الأتمتة مع مشغّلها وإجراء أول، جاهزة للاختبار والتفعيل.",
automationCreatedWithAction: "تم إنشاء الأتمتة",
automationDraftDetail: "أضف الإجراءات التي يجب أن تقوم بها في أداة الإنشاء.",
automationInboundReady: "رابط خطاف الويب الوارد ورمزه معروضان أدناه. انسخ الرمز الآن.",
automationDestUrlLabel: "إلى أين يجب أن نرسله؟",
automationDestUrlHint: "نرسل طلب POST لكل حدث مطابق إلى رابط HTTPS هذا، موقّعًا لتتمكن من التحقق منه.",
automationInboundOnce: "هذا هو خطاف الويب الوارد الخاص بك. انسخ الرمز الآن - لن يمكن عرضه مرة أخرى.",
automationInboundUrlLabel: "رابط خطاف الويب (أرسل POST هنا)",
automationInboundTokenLabel: "رمز سري",
autoJobTitle: "طلب عمل مؤتمت",
automationRanDetail2: "حالة التشغيل: {{status}}. تم تشغيل إجراء الأتمتة مرة واحدة ببيانات نموذجية.",
automationRunFailed: "فشل تشغيل الاختبار",
na_openBuilder: "فتح أداة إنشاء الأتمتة",
title_ai: "ربط وكيل ذكاء اصطناعي",
ai_choose_title: "سمّ اتصال الذكاء الاصطناعي",
ai_choose_hint: "على سبيل المثال، المساعد أو الوكيل الذي تريد ربطه.",
ai_nameLabel: "سمّ هذا الاتصال",
ai_modeLabel: "كيف تريد الاتصال؟",
ai_modeFirstParty: "السماح لمساعد ذكاء اصطناعي باستخدام AssetWRX",
ai_modeFirstPartyDesc: "فعّل خادم MCP لـ AssetWRX ليتمكن المساعدون المعتمدون من القراءة واقتراح الإجراءات بأمان.",
ai_modeExternal: "ربط خادم MCP خارجي",
ai_modeExternalDesc: "سجّل خادم MCP تابعًا لجهة خارجية عبر رابطه ليتمكن AssetWRX من استدعاء أدواته وموارده.",
mcpExternalExplain: "أدخل رابط HTTPS لخادم MCP وكيفية مصادقة AssetWRX معه.",
mcpBaseUrlLabel: "رابط الخادم",
mcpAuthLabel: "المصادقة",
mcpAuthNone: "بدون مصادقة",
mcpAuthBearer: "رمز Bearer",
mcpAuthApiKey: "مفتاح API",
mcpAuthCustom: "رأس مخصص",
mcpHeaderNameLabel: "اسم الرأس",
mcpSecretPlaceholder: "السر / الرمز",
mcpRegister: "تسجيل الخادم",
mcpRegistered: "تم تسجيل الخادم الخارجي",
mcpRegisterFailed: "تعذّر تسجيل الخادم",
mcpNoKeyExplain: "يستخدم هذا الاتصال بيانات الاعتماد التي أدخلتها للتو للخادم الخارجي. لا حاجة إلى مفتاح AssetWRX.",
mcpExternalTestExplain: "سنتصل بالخادم ونسرد الأدوات والموارد التي يعرضها.",
mcpTestConnection: "اختبار الاتصال",
mcpTestFailed: "تعذّر الوصول إلى الخادم",
mcpConnected: "متصل بالخادم",
mcpDiscovered: "تم العثور على {{tools}} أدوات و {{resources}} موارد.",
ai_enable_title: "السماح بوصول الذكاء الاصطناعي",
ai_access_title: "اختر مستوى الوصول",
ai_access_hint: "اختر ما يمكن للذكاء الاصطناعي رؤيته والقيام به. يمكنه فقط اقتراح تغييرات، ما زالت تحتاج إلى تأكيد.",
ai_test_title: "التحقق من الاتصال",
ai_activate_title: "إنهاء",
mcpExplain: "يمكن لمساعدي الذكاء الاصطناعي ووكلائه المعتمدين قراءة معلومات AssetWRX المحددة بأمان واقتراح إجراءات. كل تغيير يقترحه الذكاء الاصطناعي ما زال يحتاج إلى تأكيد.",
mcpEndpointLabel: "نقطة نهاية اتصال الذكاء الاصطناعي",
enableAi: "تمكين وصول الذكاء الاصطناعي",
mcpEnabled: "تم تمكين وصول الذكاء الاصطناعي",
mcpEnableFailed: "تعذّر تمكين وصول الذكاء الاصطناعي",
mcpVerifyExplain: "سنؤكد أن المفتاح يعمل وأن موصل الذكاء الاصطناعي قابل للوصول. لن يتم تغيير أي شيء.",
verifyAi: "التحقق من اتصال الذكاء الاصطناعي",
mcpActive: "اتصال الذكاء الاصطناعي نشط",
mcpDegraded: "تم تمكين اتصال الذكاء الاصطناعي",
mcpVerifyDetail: "المفتاح يعمل واستجاب موصل الذكاء الاصطناعي. يمكن للوكلاء المعتمدين الاتصال الآن.",
mcpVerifyFailed: "تعذّر التحقق من اتصال الذكاء الاصطناعي",
na_reviewActivity: "مراجعة نشاط الذكاء الاصطناعي",
title_files: "إعداد تبادل الملفات",
files_choose_title: "سمّ اتصال الملفات هذا",
files_choose_hint: "حمّل المستندات والملفات إلى AssetWRX، أو نزّلها، باستخدام روابط آمنة قصيرة المدة.",
files_access_title: "إنشاء وصول آمن",
files_access_hint: "يغطي خيار «عمليات الأصول» الرفع والتنزيل؛ ويغطي خيار «قراءة فقط» التنزيل فقط.",
files_test_title: "اختبار تبادل الملفات",
files_activate_title: "إنهاء",
na_openFilesGuide: "فتح دليل الملفات",
filesReady: "تبادل الملفات جاهز",
filesReadOnlyDetail: "يمكن لهذا المفتاح تنزيل الملفات لكن لا يمكنه رفعها، لذا تحققنا من أنه يسجّل الدخول. تعمل روابط التنزيل مع الملفات الموجودة في AssetWRX.",
filesReadyReadOnly: "تبادل الملفات جاهز (تنزيل فقط)",
filesBothDetail: "تم إصدار روابط تحميل وتنزيل موقّعة بنجاح.",
filesUploadDetail: "تم إصدار رابط تحميل موقّع. تستخدم عمليات التنزيل نفس آلية الروابط الآمنة.",
filesTestFailed: "تعذّر إصدار الروابط الموقّعة",
filesTestExplain: "سنطلب من AssetWRX رابط تحميل موقّعًا قصير المدة بمفتاحك الجديد. لن يتم تحميل أي شيء — هذا فقط يثبت أن الاتصال يمكنه نقل الملفات.",
filesObjectKey: "مفتاح عنصر نموذجي",
filesTest: "اختبار تبادل الملفات",
automationScratchExplain: "سننشئ أتمتة فارغة يمكنك بناؤها في المنشئ المتقدم.",
automationEventReady: "جاهزة للعمل تلقائيًا",
automationEventTestExplain: "تعمل هذه من تلقاء نفسها عندما تقوم مساحة العمل بما تراقبه. لا شيء تضغطه — سترى كل تشغيل في سجلها.",
},
home: {
eyebrow: "تكاملات مساحة العمل",
title: "ما الذي تريد تحقيقه؟",
subtitle: "اختر النتيجة التجارية. سيوجّهك AssetWRX خلال الإعداد الآمن والاختبار والتفعيل.",
resumeTitle: "استئناف الإعداد",
discardDraft: "تجاهل الإعداد المحفوظ",
card_business_title: "ربط نظام أعمال آخر",
card_business_desc: "اربط نظام ERP أو CRM أو منصة مالية أو نظام صيانة أو تطبيق أعمال آخر.",
card_business_cta: "ربط نظام",
card_webhook_title: "التفاعل عند حدوث شيء",
card_webhook_desc: "أرسل أحداثًا إلى نظام آخر عند تغيّر أصل أو فحص أو أمر عمل أو طلب.",
card_webhook_cta: "إنشاء اتصال أحداث",
card_automation_title: "أتمتة عملية",
card_automation_desc: "نفّذ إجراءات تلقائيًا عند حدوث شيء في AssetWRX أو نظام متصل آخر.",
card_automation_cta: "إنشاء أتمتة",
card_iot_title: "ربط المستشعرات والأجهزة",
card_iot_desc: "أدخل قراءات المستشعرات والأجهزة إلى AssetWRX واربطها بالأصل الصحيح.",
card_iot_cta: "ربط مصدر بيانات",
card_ai_title: "ربط وكيل ذكاء اصطناعي",
card_ai_desc: "السماح لمساعدي الذكاء الاصطناعي ووكلائه المعتمدين بالعمل مع AssetWRX بأمان.",
card_ai_cta: "ربط الذكاء الاصطناعي",
card_developer_title: "بناء تطبيق مخصص",
card_developer_desc: "استخدم واجهة برمجة AssetWRX لبناء تطبيقات وتكاملات مخصصة.",
card_developer_cta: "بدء البناء",
card_files_title: "تبادل الملفات",
card_files_desc: "حمّل المستندات والملفات إلى AssetWRX، أو نزّلها، باستخدام روابط آمنة قصيرة المدة.",
card_files_cta: "إعداد تبادل الملفات",
card_import_title: "استيراد السجلات من جدول بيانات",
card_import_desc: "استورد الأصول أو جهات الاتصال من ملف CSV أو Excel. اربط أعمدتك بالحقول الصحيحة، عاين، ثم أنشئ السجلات.",
card_import_cta: "استيراد من ملف",
card_power_bi_title: "التقارير في Power BI",
card_power_bi_desc: "حمّل الأصول والفحوصات وأوامر العمل إلى Power BI أو Excel، مع تحديثها وفق جدولك.",
card_power_bi_cta: "إعداد Power BI",
card_power_automate_title: "استخدام Power Automate",
card_power_automate_desc: "ابدأ تدفقات Microsoft عند تغيّر العمل، وأنشئ أوامر العمل والفحوصات من تدفقاتك.",
card_power_automate_cta: "إعداد Power Automate",
tier_start_title: "ابدأ ببساطة",
tier_start_subtitle: "إرشاد خطوة بخطوة. بعضها يمنحك مفتاحًا لتسلّمه لمن يدير النظام الآخر.",
tier_data_title: "البيانات والأحداث والأتمتة",
tier_data_subtitle: "نقل البيانات، والتفاعل مع التغييرات، وأتمتة العمل.",
tier_dev_title: "المطورون والذكاء الاصطناعي",
tier_dev_subtitle: "البناء على واجهة API وربط وكلاء الذكاء الاصطناعي.",
connectionsTitle: "اتصالاتك",
connectionsEmptyTitle: "لا توجد اتصالات حتى الآن",
connectionsEmptyDesc: "اختر نتيجة أعلاه لربط نظامك الأول.",
connectionsEmptyMember: "يتولى مالك مساحة العمل إعداد الاتصالات.",
connectionsLoadFailed: "تعذّر تحميل اتصالاتك.",
connectionsRetry: "إعادة المحاولة",
lockedSubtitle: "اربط أنظمة أخرى، وأتمت العمل، واربط المستشعرات أو وكلاء الذكاء الاصطناعي.",
activityNever: "لا يوجد نشاط حتى الآن",
status_draft: "مسودة",
status_testing: "قيد الاختبار",
status_active: "نشط",
status_paused: "متوقف مؤقتًا",
status_error: "يتطلب اهتمامًا",
status_archived: "غير نشط",
devToolsTitle: "أدوات المطورين",
dev_api_title: "مرجع API",
dev_api_subtitle: "تصفح مرجع REST وGraphQL المباشر.",
dev_docs_title: "الأدلة والوثائق",
dev_docs_subtitle: "أدلة قائمة على المهام، أمثلة، واستكشاف الأخطاء وإصلاحها.",
dev_advanced_title: "وحدة التحكم المتقدمة",
dev_advanced_subtitle: "كل المفاتيح ووصول الذكاء الاصطناعي والأتمتة والبيانات الواردة في مكان واحد.",
dev_keys_title: "مفاتيح API",
dev_keys_subtitle: "أنشئ المفاتيح التي تستخدمها عمليات التكامل ودوّرها وألغِها.",
dev_ai_title: "وصول مساعدي الذكاء الاصطناعي",
dev_ai_subtitle: "اختر ما يمكن لمساعدي الذكاء الاصطناعي الخارجيين رؤيته وفعله، ووافق على تغييراتهم.",
devTitle: "الربط والبناء والأتمتة",
devSectionTitle: "المطورون والمراجع",
devSectionSubtitle: "للفرق التي تربط الأنظمة مباشرة، أو تمنح مساعدي الذكاء الاصطناعي الوصول، أو تدير المفاتيح.",
devSectionSubtitleApi: "للفرق التي تربط الأنظمة مباشرة أو تدير المفاتيح.",
devSectionSubtitleMcp: "للفرق التي تمنح مساعدي الذكاء الاصطناعي الوصول، مع أدلة خطوة بخطوة.",
devSectionSubtitleGuides: "أدلة وأمثلة واستكشاف الأخطاء وإصلاحها لعمليات التكامل الخاصة بك.",
journeyUnavailableTitle: "غير متوفر حتى الآن",
journeyUnavailableDesc: "يجري إعداد هذه الرحلة. يُرجى التحقق مرة أخرى بعد قليل.",
},
connection: {
type_business_system: "نظام أعمال",
type_event_webhook: "خطاف ويب (Webhook)",
type_automation: "أتمتة",
type_iot_connected: "المستشعرات وإنترنت الأشياء",
type_ai_mcp: "وكيل ذكاء اصطناعي",
type_developer_app: "تطبيق مخصص",
type_file_exchange: "تبادل الملفات",
overview: "نظرة عامة",
lastActivity: "آخر نشاط",
source: "المصدر",
sourceManaged: "اتصال مُدار",
sourceDerived: "مستمد من مورد موجود",
whatsConnected: "ما الذي تم ربطه",
noResources: "لا توجد موارد مرتبطة.",
activity: "النشاط الأخير",
activityEmpty: "لا يوجد نشاط أخير لعرضه حتى الآن.",
health_healthy: "سليم",
health_attention: "يتطلب اهتمامًا",
health_inactive: "غير نشط",
health_active: "نشط",
health_degraded: "متدهور",
health_paused: "متوقف مؤقتًا",
health_revoked: "مُلغى",
healthTitle: "حالة الاتصال",
lastSuccess: "آخر نجاح",
lastFailure: "آخر فشل",
noFailure: "لا يوجد مسجّل",
affectedObjects: "الكائنات المتأثرة",
recovery_manage: "إدارة الاتصال",
recovery_recover: "مراجعة الفشل وإعادة الاتصال",
recovery_resume: "استئناف الاتصال",
recovery_review_history: "مراجعة سجل الوصول",
notFoundTitle: "الاتصال غير موجود",
notFoundDesc: "ربما تمت إزالته. عد إلى الصفحة الرئيسية للتكاملات.",
actionFailed: "تعذّر تحديث الاتصال.",
archiveTitle: "إلغاء وصول الاتصال؟",
archiveMsg: "سيتوقف الوصول فورًا. ستبقى إعدادات التهيئة وسجل النشاط متاحة للتدقيق.",
archive: "إلغاء الوصول",
pause: "إيقاف مؤقت",
activate: "تفعيل",
openAdvanced: "فتح في وحدة التحكم المتقدمة",
kind_service_account: "مفتاح API",
kind_webhook_subscription: "اتصال أحداث (webhook)",
kind_connected_source: "مصدر بيانات متصل",
kind_mcp_server: "خادم ذكاء اصطناعي / MCP",
kind_automation_recipe: "وصفة أتمتة",
},
docs: {
title: "الأدلة والوثائق",
subtitle: "أدلة قائمة على المهام، أمثلة عملية، واستكشاف الأخطاء وإصلاحها.",
notFound: "الدليل غير موجود",
achieve: "ما ستحققه",
need: "ما تحتاجه",
steps: "الخطوات",
verify: "كيف تعرف أنه نجح",
failure: "إذا فشل",
next: "ما يجب فعله بعد ذلك",
rawHandbook: "الدليل الأصلي (متقدم)",
minutes_zero: "أقل من دقيقة",
minutes_one: "دقيقة واحدة",
minutes_two: "دقيقتان",
minutes_few: "{{count}} دقائق",
minutes_many: "{{count}} دقيقة",
minutes_other: "{{count}} دقيقة",
minutesRead_zero: "قراءة سريعة",
minutesRead_one: "قراءة في دقيقة واحدة",
minutesRead_two: "قراءة في دقيقتين",
minutesRead_few: "قراءة في {{count}} دقائق",
minutesRead_many: "قراءة في {{count}} دقيقة",
minutesRead_other: "قراءة في {{count}} دقيقة",
section: {
gettingStarted: { title: "البدء", description: "اربط نظامك الأول وأجرِ أول استدعاء." },
guides: { title: "الأدلة", description: "اربط الأنظمة والمنصات الشائعة خطوة بخطوة." },
api: { title: "API", description: "REST وGraphQL والمصادقة والأخطاء ومعرّفات الطلبات." },
events: { title: "الأحداث", description: "خطافات الويب الصادرة والتواقيع وإعادة المحاولة وعدم التكرار." },
automation: { title: "الأتمتة", description: "المشغلات والشروط والإجراءات." },
connected: { title: "البيانات المتصلة", description: "أرسل بيانات الأجهزة والمستشعرات واربطها بالأصول." },
aiMcp: { title: "الذكاء الاصطناعي وMCP", description: "اسمح لوكلاء ذكاء اصطناعي معتمدين بالعمل مع AssetWRX بأمان." },
security: { title: "الأمان", description: "أقل صلاحية، وتدوير المفاتيح، وسجل التدقيق." },
troubleshooting: { title: "استكشاف الأخطاء وإصلاحها", description: "أصلح أكثر مشكلات التكامل شيوعًا حسب العَرَض." },
},
guide: {
integrationOverview: { title: "نظرة عامة على التكاملات", summary: "كيف يتصل AssetWRX بالأنظمة الأخرى." },
connectFirstSystem: { title: "اربط نظامك الأول", summary: "أنشئ وصولًا آمنًا وتأكد من أنه يعمل." },
authentication: { title: "المصادقة", summary: "كيفية مصادقة طلبات API." },
makeFirstRequest: { title: "أرسل أول طلب API", summary: "استدعِ API واقرأ استجابة ناجحة." },
connectErp: { title: "ربط نظام ERP", summary: "امنح نظام ERP (أو نظام أعمال آخر) وصولًا آمنًا خاصًا به إلى AssetWRX، ثم سلّم إكمال جانب ERP لفريق تقنية المعلومات.", time: "20 دقيقة، إضافة إلى وقت فريق تقنية المعلومات" },
connectPowerAutomate: { title: "ربط Power Automate", summary: "أنشئ أعمال AssetWRX وفحوصاته من تدفقات Microsoft، وابدأ تدفقًا كلما تغيّر شيء في AssetWRX." },
connectPowerBi: { title: "التقارير في Power BI", summary: "انقل أصولك وفحوصاتك وأعمالك إلى Power BI أو Excel، مع تحديثها وفق جدول." },
embedInAPortal: { title: "عرض AssetWRX داخل بوابة أخرى", summary: "ضع شاشات AssetWRX (العمل، أصل، فحص، مهمة) داخل بوابة عملائك أو الشبكة الداخلية.", time: "15 دقيقة لك، إضافة إلى فريق الويب" },
embedInDynamics: { title: "عرض AssetWRX في Dynamics 365", summary: "أصل AssetWRX في نموذج Customer Asset في Dynamics 365، مع تسجيل الدخول عبر Microsoft، ويُحدَّث النموذج عند إنجاز العمل.", time: "30 دقيقة لك، ونحو ساعة لفريق تقنية المعلومات" },
sendIotData: { title: "إرسال بيانات المستشعرات والأجهزة", summary: "اسمح للمستشعرات أو البوابات أو نظام آخر بإرسال القراءات والتنبيهات إلى AssetWRX، مرتبطة بالأصل الصحيح.", time: "15 دقيقة، إضافة إلى وقت فريق الأجهزة" },
receiveEvents: { title: "استقبال أحداث AssetWRX", summary: "اجعل AssetWRX يرسل رسالة إلى نظام آخر كلما تغيّر أصل أو فحص أو عمل أو طلب.", time: "15 دقيقة، إضافة إلى وقت فريق تقنية المعلومات" },
connectAiAgent: { title: "ربط وكيل ذكاء اصطناعي", summary: "اسمح لمساعد ذكاء اصطناعي معتمد بقراءة معلومات AssetWRX وطلب تغييرات يوافق عليها شخص.", time: "15 دقيقة، إضافة إلى إعداد أداة الذكاء الاصطناعي" },
uploadDownloadFiles: { title: "رفع الملفات وتنزيلها", summary: "اسمح لنظام آخر بإرسال الملفات إلى AssetWRX واستعادتها، باستخدام روابط آمنة قصيرة المدة.", time: "10 دقائق، إضافة إلى وقت فريق تقنية المعلومات" },
restApi: { title: "واجهة REST", summary: "الموارد والطرق والأشكال." },
paginationErrors: { title: "التقسيم إلى صفحات والأخطاء ومعرّفات الطلبات", summary: "اقرأ القوائم صفحة بصفحة وشخّص الإخفاقات." },
permissionsScopes: { title: "الأذونات والنطاقات", summary: "ما يسمح به كل نطاق." },
webhooks: { title: "خطافات الويب", summary: "كيف تعمل الإرسالات الصادرة." },
signatureVerification: { title: "التحقق من التوقيع", summary: "تأكد من أن الإرسال جاء فعلًا من AssetWRX." },
automationGettingStarted: { title: "الأتمتة: البدء", summary: "المشغلات والشروط والإجراءات." },
assetMatching: { title: "مطابقة الأصول", summary: "كيف تُربط الأحداث بالأصول." },
unresolvedEvents: { title: "الأحداث غير المحلولة", summary: "أصلح الأحداث التي لم تطابق أي أصل." },
mcpOverview: { title: "نظرة عامة على الذكاء الاصطناعي وMCP", summary: "كيف تعمل اتصالات الذكاء الاصطناعي." },
mcpSecurity: { title: "أمان الذكاء الاصطناعي ونموذج الموافقة", summary: "حافظ على أمان وصول الذكاء الاصطناعي." },
leastPrivilege: { title: "أقل صلاحية", summary: "امنح الاتصال ما يحتاجه فقط." },
keyRotation: { title: "تدوير المفاتيح وإلغاؤها", summary: "استبدل المفاتيح أو عطّلها بأمان." },
auditHistory: { title: "سجل التدقيق", summary: "اعرف من فعل ماذا." },
apiRejected: { title: "تم رفض استدعاء API", summary: "أخطاء 401 / 403 وأخطاء التحقق." },
webhookNotArriving: { title: "خطاف الويب لا يصل", summary: "الإرسالات لا تصل أبدًا إلى نقطة النهاية لديك." },
eventNoAsset: { title: "الحدث لا يجد أصلًا", summary: "تبقى الأحداث المتصلة دون حل." },
automationDidNotRun: { title: "الأتمتة لم تعمل", summary: "لم تُشغَّل وصفة." },
aiCannotConnect: { title: "وكيل الذكاء الاصطناعي لا يتصل", summary: "فشل اتصال الذكاء الاصطناعي." },
},
},
access: {
title: "الوصول الآمن",
notFound: "حساب الخدمة لهذا الاتصال غير متاح.",
keyCount: "{{active}} مفتاح (مفاتيح) نشط",
statusActive: "نشط",
statusRevoked: "مُلغى",
permissions: "الصلاحيات",
keys: "مفاتيح API",
keyLine: "{{scopeCount}} صلاحيات · أُنشئ في {{created}}",
expires: "تنتهي في",
rotate: "تدوير المفتاح",
rotateFailed: "تعذّر تدوير المفتاح.",
revokeFailed: "تعذر الإلغاء. لا يزال المفتاح يعمل.",
revoke: "إلغاء",
rotateTitle: "تدوير هذا المفتاح؟",
rotateMsg: "يتوقف المفتاح الحالي عن العمل الآن. أدخل المفتاح الجديد في Power BI أو Power Automate أو نظامك فورًا.",
revokeKeyTitle: "إلغاء هذا المفتاح؟",
revokeKeyMsg: "ستتوقف الاستدعاءات التي تستخدمه فورًا عن العمل.",
revokeAll: "إلغاء الوصول",
revokeAllTitle: "إلغاء كل الوصول؟",
revokeAllMsg: "يتم إلغاء حساب الخدمة وكل مفتاح فورًا. لا يمكن التراجع عن هذا.",
done: "لقد حفظت هذا",
},
connected: {
title: "الإدخال المتصل",
notFound: "مصدر البيانات لهذا الاتصال غير متاح.",
statusActive: "نشط",
statusPaused: "متوقف مؤقتًا",
statusDisabled: "معطّل",
tokenEnding: "رمز ينتهي بـ {{last}}",
rotateToken: "تدوير رمز الإدخال",
rotateFailed: "تعذّر تدوير الرمز.",
pause: "إيقاف مؤقت",
resume: "استئناف",
resolveFailed: "تعذّر حل الحدث.",
unresolvedTitle: "يتطلب اهتمامًا",
unresolvedEmpty: "لا توجد أحداث غير محلولة.",
reasonAmbiguous: "طابق أكثر من أصل واحد",
reasonNoMatch: "لا يوجد أصل مطابق",
resolveWith: "اربطه بـ",
resolveInAdvanced: "الحل في وحدة التحكم المتقدمة",
rulesTitle: "القواعد",
rulesEmpty: "لا توجد قواعد حتى الآن.",
manageRules: "إدارة القواعد",
cancel: "إلغاء",
newRule: "+ قاعدة جديدة",
ruleNameLabel: "اسم القاعدة (اختياري)",
ruleNamePlaceholder: "مثال: تنبيه ارتفاع درجة الحرارة",
matchLabel: "أي أحداث؟",
matchAll: "جميع الأحداث",
matchPrefix: "يبدأ بـ",
actionLabel: "ثم",
actionAlert: "رفع تنبيه",
actionReposition: "تحديث الموقع",
actionPublish: "نشر حدث",
actionJob: "إنشاء WRX",
actionValueLabel: "تفاصيل الإجراء",
valueAlertPlaceholder: "عنوان التنبيه (اختياري)",
valueJobPlaceholder: "عنوان WRX (اختياري)",
createRule: "إنشاء قاعدة (متوقفة مؤقتًا)",
ruleCreateFailed: "تعذّر إنشاء القاعدة.",
ruleUpdateFailed: "تعذّر تحديث القاعدة.",
ruleActivate: "تفعيل",
rulePause: "إيقاف مؤقت",
ruleAdvancedNote: "تحتاج إلى شروط أو قائمة تحقق تفتيش؟ افتح وحدة التحكم المتقدمة.",
eventsTitle: "الأحداث الأخيرة",
eventsEmpty: "لم يتم استلام أحداث حتى الآن.",
reprocess: "إعادة المعالجة",
reprocessFailed: "تعذّر إعادة معالجة الحدث.",
},
automation: {
title: "الأتمتة",
notFound: "الأتمتة لهذا الاتصال غير متاحة.",
status_active: "نشط",
status_paused: "متوقف مؤقتًا",
status_draft: "مسودة",
status_archived: "مؤرشف",
trigger: "المشغّل",
steps_zero: "{{count}} إجراء",
steps_one: "إجراء واحد",
steps_two: "إجراءان",
steps_few: "{{count}} إجراءات",
steps_many: "{{count}} إجراءً",
steps_other: "{{count}} إجراء",
runResult: "تشغيل الاختبار: {{status}}",
runFailed: "تعذّر تشغيل الأتمتة.",
activate: "تفعيل",
pause: "إيقاف مؤقت",
runNow: "تشغيل الآن",
editInBuilder: "تعديل في أداة الإنشاء",
actionFailed: "فشل الإجراء.",
historyTitle: "سجل التشغيل",
historyEmpty: "لا توجد عمليات تشغيل حتى الآن.",
retry: "إعادة المحاولة",
inboundTitle: "خطاف الويب الوارد",
inboundUrl: "رابط خطاف الويب (أرسل POST هنا)",
inboundNone: "أنشئ سرًا لتفعيل رابط الإدخال الوارد.",
inboundToken: "رمز سري (يُعرض مرة واحدة)",
rotateSecret: "تدوير السر",
lastRun: "آخر تشغيل",
never: "أبدًا",
nextRun: "التشغيل التالي",
testRun: "تشغيل تجريبي",
turnOn: "قم بالتشغيل",
edit: "تعديل",
hideSkipped: "إخفاء المتخطاة",
showSkipped_one: "تشغيل واحد متخطى",
showSkipped_other: "{{count}} تشغيل متخطى",
historyEmptyEvent: "لم يحدث شيء بعد — تعمل تلقائيًا عندما يحدث شيء في مساحة العمل.",
historyOnlySkipped: "تم تخطي كل عمليات التشغيل حتى الآن.",
fix: "إصلاح هذه الأتمتة",
showSkipped_zero: "لا شيء متخطى",
showSkipped_two: "تشغيلان متخطيان",
showSkipped_few: "{{count}} تشغيلات متخطاة",
showSkipped_many: "{{count}} تشغيلًا متخطى",
},
mcp: {
title: "اتصال الذكاء الاصطناعي (MCP)",
notFound: "خادم MCP لهذا الاتصال غير متاح.",
statusActive: "نشط",
statusDisabled: "معطّل",
statusError: "خطأ",
toolsResources: "{{tools}} أدوات · {{resources}} موارد",
test: "اختبار الاتصال",
testOk: "متصل · {{protocol}}",
testFail: "فشل الاتصال",
discover: "اكتشاف البيانات الوصفية",
discovered: "{{tools}} أدوات · {{resources}} موارد",
discoverFailed: "تعذّر اكتشاف البيانات الوصفية.",
enable: "تمكين",
disable: "تعطيل",
invocationsTitle: "النشاط الأخير",
invocationsEmpty: "لا يوجد نشاط حتى الآن.",
manageAdvanced: "الإدارة في وحدة التحكم المتقدمة",
actionFailed: "فشل الإجراء.",
credentials: "بيانات الاعتماد",
credentialsTitle: "تحديث بيانات الاعتماد",
credentialsSaved: "تم تحديث بيانات الاعتماد",
credentialsFailed: "تعذّر تحديث بيانات الاعتماد.",
auth_none: "بدون مصادقة",
auth_bearer: "رمز Bearer",
auth_api_key: "مفتاح API",
auth_custom_header: "رأس مخصص",
headerName: "اسم الرأس",
secretPlaceholder: "السر / الرمز",
saveCredentials: "حفظ بيانات الاعتماد",
},
files: {
  title: "الملفات المتبادلة",
  empty: "لا توجد ملفات بعد. تظهر هنا الملفات التي ترفعها أنظمتك إلى مساحة العمل هذه عبر أي اتصال ملفات.",
  loadFailed: "تعذّر تحميل الملفات.",
  download: "تنزيل",
  downloadFailed: "تعذّر تنزيل الملف.",
},
webhook: {
  title: "الأحداث",
  unavailable: "تعذّر تحميل اشتراك الأحداث لهذا الاتصال.",
  address: "يرسل إلى",
  secretEnding: "سر التوقيع ينتهي بـ {{last}}",
  secretLabel: "سر التوقيع",
  replace: "استبدال سر التوقيع",
  replaceTitle: "استبدال سر التوقيع؟",
  replaceMsg: "تُوقَّع الأحداث بالسر الجديد فورًا، لذا يرفضها النظام المستقبِل حتى يحصل على السر الجديد. أعطه السر الجديد فورًا.",
  replaceFailed: "تعذّر استبدال سر التوقيع.",
},
embeddedApps: {
  refusal_other: "حدث خطأ أثناء بدء الجلسة. حاول مرة أخرى؛ وإذا تكرر، تواصل مع دعم AssetWRX.",
  refusal_assertion: "لم يُقبل إثبات الهوية الذي أرسلته البوابة. اطلب من فريق تقنية المعلومات مراجعة إعدادات تسجيل الدخول.",
  refusal_scope_denied: "طلبت البوابة أمرًا غير مسموح لهذا التطبيق بفعله.",
  refusal_jit_refused: "تعذّر إضافة الشخص تلقائيًا.",
  refusal_unknown_user: "الشخص غير مرتبط بأي أحد في مساحة العمل هذه.",
  refusal_jit_domain_refused: "نطاق بريد الشخص ليس ضمن القائمة المسموح بها.",
  refusal_identity_unlinked: "ألغى مسؤول ربط هذا الشخص. اربطه مرة أخرى أدناه.",
  refusal_identity_collision: "تسجيل الدخول هذا يخص شخصًا آخر هنا.",
  refusal_user_disabled: "حساب الشخص في AssetWRX متوقف.",
  refusal_wrong_tenant: "استخدم الشخص حساب Microsoft تابعًا لشركة أخرى.",
  refusal_sso_required: "لم يسجّل الشخص الدخول عبر Microsoft.",
  refusal_not_entitled: "خطة مساحة العمل لا تشمل التضمين.",
  refusal_view_not_permitted: "يحتاج العرض إلى إذن لا يملكه هذا التطبيق.",
  refusal_not_a_member: "الشخص ليس عضوًا في مساحة العمل هذه.",
  refusal_bootstrap_expired: "استغرق الشخص أكثر من دقيقة لتسجيل الدخول. إعادة تحميل صفحة البوابة تحل المشكلة.",
  lastRefusalReason: "آخر رفض: {{reason}}",
  viewNeedsScope: "لا يمكن فتح هذه العروض حتى تحدد الإذن الخاص بها ضمن «ما يمكنه فعله»: {{views}}.",
  viewsHelp: "عند تحديد عرض يُحدَّد أيضًا الإذن الذي يحتاجه ضمن «ما يمكنه فعله».",
  disableMsg: "تتوقف كل البوابات التي تستخدمه عن عرض AssetWRX فورًا وتنتهي الجلسات المفتوحة. يمكنك إعادة تشغيله في أي وقت.",
  disableTitle: "إيقاف {{name}}؟",
  removeOriginConfirm: "إزالة الموقع",
  removeOriginMsg: "يتوقف هذا الموقع عن عرض AssetWRX فورًا. سيرى من يستخدمه مساحة فارغة حتى تضيفه مرة أخرى.",
  removeOriginTitle: "إزالة {{origin}}؟",
  removeOriginShort: "إزالة",
  outcomeCta: "إعداد تطبيق مضمّن",
  outcomeTitle: "اعرض AssetWRX داخل بوابة أخرى",
  ownerOnlyBodyUnnamed: "اطلب من مالك مساحة العمل إضافة تطبيق. توضح الأدلة أعلاه ما سيحتاجه.",
  ownerOnlyBody: "اطلب من {{owner}} إضافة تطبيق. توضح الأدلة أعلاه ما سيحتاجه.",
  ownerOnlyTitle: "مالك مساحة العمل وحده يمكنه إعداد التطبيقات المضمّنة",
title: "التطبيقات المُضمَّنة",
subtitle: "اعرض AssetWRX داخل بوابة أخرى، مثل Dynamics 365 أو بوابة العملاء. اختر المواقع التي يمكنها استضافته، والعروض التي يمكنها فتحها، وما يمكن لتلك العروض فعله.",
cardSubtitle: "اعرض عروض AssetWRX داخل بوابة أخرى.",
guidePortal: "طريقة الإعداد",
guideDynamics: "إعداد Dynamics 365",
create: "تطبيق مُضمَّن جديد",
defaultName: "تطبيق مُضمَّن",
loadFailed: "تعذّر تحميل تطبيقاتك المُضمَّنة. لم يتم تغييرها.",
emptyTitle: "لا توجد تطبيقات مُضمَّنة بعد",
emptyDesc: "أنشئ واحدًا لتحديد البوابة التي يمكنها استضافة AssetWRX وما يمكنها عرضه.",
adminOnly: "يمكن لمالكي مساحة العمل ومسؤوليها فقط إدارة التطبيقات المُضمَّنة.",
name: "الاسم",
save: "حفظ",
statusActive: "مُفعَّل",
statusDisabled: "متوقف",
enable: "تشغيل",
disable: "إيقاف",
publicId: "المعرّف العام",
publicIdHelp: "تمرّر البوابة المضيفة هذا المعرّف. ليس سريًا ولا يمنح أي صلاحية بمفرده.",
secretTitle: "سر المضيف",
secretHelp: "يستخدمه خادم بوابتك لبدء الجلسات المُضمَّنة. احتفظ به على الخادم، ولا تضعه أبدًا في صفحة ويب.",
secretNone: "لا يوجد سر بعد. لا يمكن للبوابة فتح AssetWRX حتى تنشئ واحدًا.",
secretSet: "السر {{prefix}}… أُنشئ في {{date}}",
secretCreate: "إنشاء سر",
secretRotate: "استبدال السر",
secretRotateTitle: "استبدال سر المضيف؟",
secretRotateMsg: "يتوقف السر الحالي عن العمل فورًا. حدّث خادم بوابتك بالسر الجديد.",
secretShownOnce: "انسخه الآن. لن يُعرض مرة أخرى.",
origins: "المواقع المسموح بها",
originsHelp: "عناوين دقيقة فقط، مثل https://contoso.crm.dynamics.com. لا يُسمح بأحرف البدل.",
originPlaceholder: "https://example.com",
addOrigin: "إضافة موقع",
removeOrigin: "إزالة {{origin}}",
noOrigins: "لا توجد مواقع بعد. لا يمكن لأي موقع استضافة هذا التطبيق حتى تضيف واحدًا.",
originErrorWildcard: "لا يُسمح بأحرف البدل. أضف كل موقع على حدة.",
originErrorInvalid: "أدخل عنوان موقع مثل https://portal.example.com بدون مسار.",
views: "العروض التي يمكنه فتحها",
scopes: "ما يمكنه فعله",
interactiveOff: "يتطلب تغيير البيانات ميزة التضمين التفاعلي في خطتك. حتى ذلك الحين، يُطبَّق العرض فقط.",
userCeiling: "لا يحصل أي شخص على أكثر من صلاحياته في AssetWRX.",
identityTitle: "تسجيل الدخول",
identityModeAssetwrx: "تسجيل الدخول إلى AssetWRX",
identityModeSso: "تسجيل الدخول الموحد عبر Microsoft Entra",
identityModeHost: "مقدَّم من المضيف (للمؤسسات)",
identityHelp_assetwrx: "يسجّل الأشخاص الدخول إلى AssetWRX داخل البوابة بحساباتهم الخاصة في AssetWRX.",
identityHelp_sso: "يسجّل الأشخاص الدخول بحساب Microsoft الخاص بمؤسستهم، في المستأجر أدناه. تُرفض الحسابات الأخرى والمستأجرون الآخرون.",
identityHelp_host: "يؤكد خادم البوابة هوية الشخص برمز هوية موقَّع من موفّر الهوية لديك، فلا حاجة إلى تسجيل دخول ثانٍ. يجب أن يكون الشخص مرتبطًا بمساحة العمل هذه أو أن يُضاف تلقائيًا.",
idpEntra: "Microsoft Entra ID",
idpOidc: "موفّر OpenID Connect آخر",
idpTenant: "معرّف مستأجر Entra",
idpTenantHelp: "معرّف الدليل (المستأجر) للمؤسسة. تُرفض عمليات تسجيل الدخول من أي مستأجر آخر.",
idpIssuer: "الجهة المُصدِرة",
idpIssuerHelp: "عنوان الويب الذي يعرّف مزوّد تسجيل الدخول. ينسخه فريق تقنية المعلومات من إعدادات المزوّد. يبدأ بـ https://.",
idpAudience: "الجمهور",
idpAudienceHelp: "معرّف التطبيق الذي تستخدمه بوابتك لدى مزوّد تسجيل الدخول. ينسخه فريق تقنية المعلومات من تسجيل التطبيق لدى المزوّد.",
jitEnable: "إضافة الأشخاص الجدد تلقائيًا",
jitHelp: "عند الإيقاف: لا يفتح عرض البوابة إلا الأشخاص المرتبطون مسبقًا أو الأعضاء الحاليون. عند التشغيل: ينضم أشخاص موفّر الهوية إلى مساحة العمل هذه عند وصولهم أول مرة. لا يُربط تلقائيًا أبدًا عنوان بريد إلكتروني له حساب AssetWRX قائم.",
jitDomains: "نطاقات البريد الإلكتروني المسموح بها",
jitDomainsHelp: "افصل بينها بفواصل. اتركه فارغًا للسماح لأي شخص يسجّل موفّر الهوية دخوله.",
jitTeam: "الفريق للأشخاص الجدد",
jitRole: "ينضم الأشخاص الجدد كأعضاء، وليس كمسؤولين أبدًا.",
sessionLifetime: "مدة الجلسة",
hoursShort: "{{count}} س",
identitySave: "حفظ إعدادات تسجيل الدخول",
identityStats: "الجلسات المفتوحة: {{sessions}} · الأشخاص المرتبطون: {{identities}} · المرفوضة (30 يومًا): {{denied}}",
lastDenied: "آخر رفض في {{date}}",
linkedIdentities: "الأشخاص المرتبطون",
noLinkedIdentities: "لا يوجد أحد مرتبط بعد.",
linkedVia_admin: "ربطه مسؤول",
linkedVia_jit: "أضيف تلقائيًا",
linkedVia_sso: "تسجيل الدخول عبر Microsoft",
unlink: "إلغاء الربط",
unlinkTitle: "إلغاء ربط هذا الشخص؟",
unlinkMsg: "تنتهي جلساته المضمّنة الآن، ولن يتمكن موفّر الهوية من تسجيل دخوله هنا حتى يُربط من جديد.",
linkSubject: "معرّف المستخدم لدى موفّر الهوية",
linkSubjectHelp: "معرّف الشخص لدى مزوّد تسجيل الدخول (في Microsoft Entra هو معرّف الكائن في صفحة المستخدم). ثم اختر العضو أدناه.",
link: "ربط",
theme: "المظهر",
themeAssetwrx: "AssetWRX",
themeHost: "مطابق للمضيف",
themeLight: "فاتح",
themeDark: "داكن",
viewWork: "العمل",
viewAssets: "الأصول",
viewAsset: "الأصل",
viewInspection: "الفحص",
viewJob: "المهمة",
viewRequest: "الطلب",
viewInspectionReport: "تقرير الفحص",
viewJobReport: "تقرير المهمة",
created: "أُنشئ في {{date}}",
lastUsed: "آخر استخدام {{date}}",
neverUsed: "لم يُستخدم قط",
delete: "حذف",
deleteTitle: "حذف {{name}}؟",
deleteMsg: "تتوقف البوابات التي تستخدمه عن العمل فورًا. لا يمكن التراجع عن ذلك.",
cancel: "إلغاء",
actionFailed: "لم يتم الحفظ. حاول مرة أخرى.",
},
apiKeys: {
create: "إنشاء مفتاح API",
defaultName: "مفتاح API",
createFailed: "تعذر إنشاء المفتاح. {{message}}",
address: "عنوان API",
howPowerBi: "في Power BI اختر الحصول على البيانات ← موجز OData، وأدخل {{url}}/v1/odata، ثم المصادقة الأساسية: أي اسم مستخدم وهذا المفتاح ككلمة مرور.",
howHeader: "أرسل المفتاح في الترويسة x-asset-inspector-key مع كل طلب.",
openGuide: "فتح دليل الإعداد",
done: "تم",
nameLabel: "الاسم",
createButton: "إنشاء المفتاح",
manage: "تدوير أو إلغاء",
hide: "إخفاء",
},
serviceAccounts: {
title: "مفاتيح API",
subtitle: "أنشئ مفتاحًا لـ Power BI أو Power Automate أو نظامك الخاص، ثم دوّره أو ألغِه من هنا. يظهر المفتاح مرة واحدة فقط.",
emptyTitle: "لا توجد مفاتيح API بعد",
emptyDesc: "أنشئ مفتاحًا عبر «إنشاء مفتاح API» أو من أي مسار اتصال.",
revokeTitle: "إلغاء هذا الوصول؟",
revokeMsg: "يتم إلغاء حساب الخدمة وكل مفتاح فورًا. لا يمكن التراجع عن هذا.",
lastUsed: "آخر استخدام في {{date}}",
neverUsed: "لم يُستخدم مطلقًا",
created: "أُنشئ في {{date}}",
},
aiSettings: {
title: "الذكاء الاصطناعي لـ AssetWRX (MCP)",
subtitle: "تحكم في ما يمكن للمساعدين المعتمدين بالذكاء الاصطناعي القيام به مع AssetWRX. كل تغيير يقترحه الذكاء الاصطناعي ما زال يحتاج إلى تأكيد.",
exposure: "وصول الذكاء الاصطناعي",
statusEnabled: "مُمكَّن",
statusDisabled: "معطّل",
enable: "تمكين وصول الذكاء الاصطناعي",
disable: "تعطيل",
endpointLabel: "نقطة نهاية MCP",
approvalsLoadFailed: "تعذّر تحميل طلبات الذكاء الاصطناعي التي تنتظر الموافقة.",
ttlLabel: "انتهاء صلاحية الاقتراح",
ttlHours_zero: "{{count}} ساعة",
ttlHours_one: "ساعة واحدة",
ttlHours_two: "ساعتان",
ttlHours_few: "{{count}} ساعات",
ttlHours_many: "{{count}} ساعة",
ttlHours_other: "{{count}} ساعة",
ttlHour: "ساعة واحدة",
toolsTitle: "الأدوات",
toolsEmpty: "لا توجد أدوات متاحة.",
writeAction: "يمكنه إجراء تغييرات (يحتاج إلى تأكيد)",
rowEnable: "تمكين",
rowDisable: "تعطيل",
resourcesTitle: "الموارد",
resourcesEmpty: "لا توجد موارد متاحة.",
activityTitle: "نشاط الذكاء الاصطناعي الأخير",
activityEmpty: "لا يوجد نشاط للذكاء الاصطناعي حتى الآن.",
actionFailed: "تعذّر التحديث. حاول مرة أخرى.",
},
connectedPanel: {
eyebrow: "الأصول المتصلة",
title: "إدخال الأحداث المتصلة",
subtitle: "إدارة المصادر، ومراجعة حركة البيانات الواردة، وحل المطابقات الغامضة، وإضافة القواعد. استخدم معالج التكوين أولاً، ثم الأقسام أدناه.",
},
connectedConfigWizard: {
eyebrow: "التكوين",
title: "إعداد الإدخال المتصل",
lead: "يرشدك هذا المعالج خلال إنشاء مصدر، وتأمين رمزه، ونسخ رابط الإدخال، وفهم القواعد الاختيارية.",
pillWelcome: "البدء",
pillSource: "المصدر",
pillEndpoint: "رابط الإدخال",
pillRule: "القواعد",
pillComplete: "تم",
welcomeTitle: "ما الذي تقوم بتكوينه",
welcomeIntro: "ستربط نظامًا خارجيًا (SCADA، بوابة، سكريبت) لإرسال أحداث JSON عبر POST إلى مساحة العمل هذه.",
welcomeStep1: "أنشئ مصدرًا متصلاً (صندوق وارد منطقي).",
welcomeStep2: "انسخ رمز الإدخال أحادي الاستخدام من النافذة المنبثقة الآمنة—نفس تدفق مفاتيح API.",
welcomeStep3: "انسخ رابط POST وحمولة نموذجية لتكاملك.",
welcomeStep4: "أضف قاعدة اختياريًا: عند مطابقة الأحداث لنمط معيّن، شغّل إجراءً واضحًا (مسودة، تنبيه، أو إشعار).",
sourceTitle: "إنشاء مصدر متصل",
sourceLead: "أعط المصدر اسمًا واضحًا سيتعرّف عليه فريقك. يجب أن يكون المفتاح الداخلي فريدًا؛ اتركه فارغًا للإنشاء التلقائي.",
fieldSourceName: "الاسم المعروض",
placeholderSourceName: "مثال: PLC مصنع الشمال",
fieldSourceKey: "المفتاح الداخلي (اختياري)",
hintSourceKey: "أحرف وأرقام وشرطات فقط. يُستخدم في السجلات والبيانات الوصفية—لا يُعرض للمرسلين.",
placeholderSourceKey: "مثال: north-plant-plc",
createSourceCta: "إنشاء المصدر وإظهار الرمز",
creating: "جارٍ الإنشاء…",
defaultSourceName: "مصدر متصل {{n}}",
endpointTitle: "إرسال الأحداث إلى هذا الرابط",
endpointLead: "يجب أن يستخدم المرسل طلب POST عبر HTTPS مع JSON. يُفضَّل استخدام الرمز الخاص بكل مصدر في رأس x-connected-source-token.",
postUrlLabel: "رابط الإدخال الخاص بك",
copyPostUrl: "نسخ سطر POST",
copySampleJson: "نسخ JSON نموذجي",
endpointNoSource: "أنشئ مصدرًا في الخطوة السابقة (أو استخدم مصدر جديد أعلاه) لترى رابط إدخالك هنا.",
endpointHeaderHint: "الرأس المطلوب عند استخدام رمز الإدخال:",
endpointBearerHint: "إذا استخدمت حساب خدمة لمساحة العمل بدلاً من ذلك، أرسل Authorization: Bearer <مفتاح API> مع صلاحيات connected_*.",
openApiKeys: "فتح مفاتيح API والوصول",
ruleStepTitle: "القواعد (اختياري)",
ruleStepLead: "تراقب القواعد الأحداث الواردة بعد تخزينها. عند تطابق مفتاح الحدث مع نمطك، يشغّل AssetWRX إجراءً واحدًا—مثل النشر إلى صندوق الأتمتة الصادر لتتمكن الوصفات من التفاعل.",
ruleStepHint: "استخدم أداة إنشاء القواعد أدناه لاختيار “عندما” و“ثم” بلغة واضحة. تبدأ القواعد الجديدة متوقفة مؤقتًا لتتمكن من المراجعة قبل التفعيل.",
completeTitle: "أنت جاهز للتكامل",
completeBody: "مرّر للأسفل لإدارة المصادر، وفحص الأحداث الأخيرة، وحل الحمولات غير المطابقة، وضبط القواعد. دوّر رمز الإدخال في أي وقت؛ يعرض كل تدوير السر الجديد مرة واحدة في النافذة المنبثقة نفسها.",
},
connectedIngestModal: {
title: "رمز الإدخال (يُعرض مرة واحدة)",
leadCreate: "انسخ هذا الرمز إلى مدير كلمات مرور أو مخزن أسرار. أرسله كرأس x-connected-source-token في كل طلب POST إلى هذا المصدر.",
leadRotate: "توقف رمز الإدخال السابق عن العمل عند التدوير. انسخ الرمز الجديد وحدّث كل مرسل قبل استئناف حركة البيانات.",
copiedTitle: "تم النسخ",
copiedBody: "تم نسخ القيمة إلى الحافظة.",
missingTokenTitle: "لم يُرجَع أي رمز",
missingTokenBody: "لم يُرجع الخادم رمز إدخال جديد. حاول مرة أخرى أو تحقق من سجلات Edge Function.",
},
connectedRules: {
builderTitle: "إنشاء قاعدة متصلة",
builderSubtitle: "تجيب القواعد على: “عندما يبدو الحدث كذا، افعل كذا.” تستخدم الأنماط مفاتيح الأحداث (مثل telemetry.temperature أو connected.*). تعمل الإجراءات فقط بعد تخزين الحدث؛ تتطلب عدة إجراءات أن يكون الحدث مطابقًا لأصل مسبقًا.",
fieldRuleName: "اسم القاعدة (اختياري)",
placeholderRuleName: "مثال: الإشعار عند وصول القياس عن بُعد",
whenLabel: "عند مطابقة الأحداث الواردة",
whenHint: "اختر مدى صرامة مطابقة مفتاح الحدث. تبدأ معظم الفرق بـ “أي حدث متصل” أو بادئة قصيرة.",
matchAll: "أي حدث متصل",
matchPrefix: "البادئة",
matchCustom: "نمط متقدم",
placeholderPrefix: "مثال: telemetry (يصبح telemetry.*)",
customHint: "للمستخدمين المتقدمين: أدخل نمطًا كاملاً مثل connected.* أو job.status_changed.",
thenLabel: "ثم قم بذلك",
actionTitle_outbox_publish: "النشر إلى صندوق الأتمتة الصادر",
actionBody_outbox_publish: "يُصدر حدث مساحة عمل يمكن للأنظمة الأخرى ووصفات الأتمتة استهلاكه—مشابه لتوزيع خطاف الويب داخل AssetWRX.",
actionTitle_asset_alert: "رفع تنبيه أصل",
actionBody_asset_alert: "يكتب إدخال نشاط ظاهر على الأصل المطابق. عنوان مخصص اختياري.",
actionTitle_asset_reposition: "تحديث موقع الأصل",
actionBody_asset_reposition: "يطبّق الموضع الذي أبلغ عنه الجهاز. ينتقل الأصل المتحرك بصمت؛ أي شيء يُفترض أن يبقى ثابتًا يرفع مطالبة لمديره.",
actionTitle_inspection_create: "إنشاء مسودة تفتيش",
actionBody_inspection_create: "يفتح مسودة تفتيش على الأصل المطابق. يتطلب UUID لقائمة تحقق.",
actionTitle_job_create: "إنشاء مسودة عمل",
actionBody_job_create: "يفتح مسودة عنصر عمل مرتبطة بالأصل المطابق عندما يعثر عليه المحلل.",
fieldOutboxEventType: "نوع حدث الصندوق الصادر",
fieldAlertTitle: "عنوان التنبيه (اختياري)",
placeholderAlertTitle: "يستخدم ملخص الحدث افتراضيًا إذا كان فارغًا",
fieldChecklistTemplateId: "معرّف قائمة التحقق",
hintChecklistTemplateId: "UUID لقائمة تحقق موجود في مساحة العمل هذه. تستخدم مسودة التفتيش هذا قائمة التحقق.",
placeholderUuid: "00000000-0000-0000-0000-000000000000",
fieldJobTitle: "عنوان المهمة (اختياري)",
placeholderJobTitle: "يستخدم عنوانًا مستمدًا من الحدث افتراضيًا",
sourceScopeLabel: "تطبيق هذه القاعدة على",
sourceScopeHint: "كل المصادر، أو أحداث من مصدر واحد أدناه فقط.",
sourceAll: "كل المصادر",
createRuleCta: "إنشاء قاعدة (تبدأ متوقفة مؤقتًا)",
ruleCreated: "تم إنشاء القاعدة",
defaultRuleName: "قاعدة لـ {{pattern}}",
ruleDescriptionAuto: "تم إنشاؤها من أداة إنشاء قواعد الإدخال المتصل.",
checklistRequiredTitle: "قائمة التحقق مطلوب",
checklistRequiredBody: "تحتاج مسودات التفتيش إلى UUID لقائمة تحقق. الصق واحدًا من قوائم تحقق مساحة عملك، أو اختر إجراءً مختلفًا.",
},
connectedSections: {
reload: "إعادة التحميل",
newSource: "مصدر جديد",
rotateToken: "تدوير الرمز",
sourcesTitle: "المصادر",
sourcesSubtitle: "لكل مصدر رابط إدخال ودورة حياة رمز خاصة به.",
sourcesEmpty: "لا توجد مصادر متصلة حتى الآن.",
sourceActivity: "آخر استلام: {{received}} · آخر حدث: {{last}}",
never: "أبدًا",
eventsTitle: "الأحداث الأخيرة",
eventsSubtitle: "أحدث الحمولات التي قبلتها واجهة API (إعادة المعالجة آمنة عند توجيه الدعم لذلك).",
eventsEmpty: "لا توجد أحداث متصلة حتى الآن.",
noSummary: "لا يوجد ملخص من المساعد حتى الآن.",
assetLabel: "الأصل",
unresolved: "غير محلول",
reprocess: "إعادة المعالجة",
reprocessed: "تمت إعادة معالجة الحدث",
unresolvedTitle: "قائمة الانتظار غير المحلولة",
unresolvedSubtitle: "أحداث لم يمكن مطابقتها بأصل واحد—حلها يدويًا، ثم أعد معالجتها إذا لزم الأمر.",
unresolvedEmpty: "لا توجد أحداث متصلة غير محلولة.",
resolveFirst: "الحل أولاً",
candidates_zero: "{{count}} أصل مرشح",
candidates_one: "أصل مرشح واحد",
candidates_two: "أصلان مرشحان",
candidates_few: "{{count}} أصول مرشحة",
candidates_many: "{{count}} أصلًا مرشحًا",
candidates_other: "{{count}} أصل مرشح",
resolved: "تم حل الحدث غير المحلول",
noCandidateTitle: "لا يوجد مرشح متاح",
noCandidateBody: "لا يحتوي هذا الحدث غير المحلول على أصل مرشح مخزَّن ليتم تطبيقه تلقائيًا.",
rulesListTitle: "القواعد المحفوظة",
rulesListSubtitle: "فعّل قاعدة عندما تكون راضيًا عن نمطها وإجرائها. لا تعمل القواعد المتوقفة مؤقتًا أبدًا.",
rulesEmpty: "لا توجد قواعد متصلة حتى الآن.",
pause: "إيقاف مؤقت",
activate: "تفعيل",
noDescription: "لم يُقدَّم وصف.",
ruleActivated: "القاعدة نشطة",
rulePaused: "القاعدة متوقفة مؤقتًا",
executionsTitle: "سجل التنفيذ",
executionsSubtitle: "أحدث عمليات تشغيل القواعد المتصلة مع حالة التدقيق.",
executionsEmpty: "لا توجد عمليات تنفيذ لقواعد متصلة حتى الآن.",
attempt: "محاولة",
executionEvent: "الحدث {{id}} · {{at}}",
alertActionTitle: "فشل إجراء الإدارة المتصل",
alertActionBody: "حدث خطأ ما. يُرجى المحاولة مرة أخرى.",
healthTitle: "سلامة التكامل",
healthSubtitle: "الحالة التشغيلية ووضعية إعادة المحاولة وأحدث نتائج الاستيعاب.",
healthLabel: "الصحة",
lastSuccessLbl: "آخر مزامنة ناجحة",
lastFailedLbl: "آخر مزامنة فاشلة",
logsLbl: "السجلات / السجل الزمني",
logsVal: "الأحداث: {{e}} · عمليات التشغيل: {{r}}",
retryFailed: "أعد محاولة آخر حدث فاشل",
copyPayload: "نسخ حمولة الاختبار",
credsNote: "بيانات الاعتماد: تُكشف رموز المصدر مرة واحدة، ثم تظهر ببادئتها وآخر أربعة أحرف منها فقط. استخدم مفاتيح حساب الخدمة ذات نطاقات connected_* لتكاملات رمز Bearer.",
needsAction: "مطلوب اتخاذ إجراء",
needsReview: "يلزم مراجعة",
healthyLbl: "سليم",
notConfigured: "غير مُهيَّأ",
errPrefix: "خطأ: {{m}}",
seeSummary: "راجع ملخص مخرجات التنفيذ.",
},
automationSubGuided: "موجّه",
automationSubRuns: "سجل التشغيل",
automationSubExpert: "محرر متقدم",
docsBarAutomationGuide: "دليل الأتمتة",
docsBarIntegrationsOverview: "نظرة عامة على خطافات الويب والاتصالات",
docsBarBrowseApi: "فتح مرجع API المباشر",
docsBarApiHandbook: "دليل الاتصال الكامل",
docsBarOpenApiKeys: "مفاتيح API وحسابات الخدمة",
docsBarConnectedPreview: "معاينة متصلة",
automationsKeysCalloutTitle: "لا يتم إنشاء حسابات الخدمة ومفاتيح API هنا",
automationsKeysCalloutBody: "استخدم تبويب مفاتيح API والوصول لإنشاء حسابات الخدمة، وإصدار مفاتيح API، والتحقق من البوابة، ونسخ نقاط النهاية. هذا التبويب للوصفات وسجل التشغيل فقط.",
automationsKeysCalloutCta: "فتح مفاتيح API والوصول",
apiExplorerLead: "مرجع للقراءة فقط لواجهة API العامة. ميزة «جرّبها» معطّلة داخل هذا العارض حتى لا تنكشف بيانات اعتمادك لمصادر عشوائية (CORS). استخدم مفاتيح API والوصول ← التحقق من الاتصال باستخدام جلستك، أو اختبر باستخدام مفتاح حساب خدمة من الشاشة نفسها.",
apiExplorerServerDescription: "واجهة برمجة مساحة عمل AssetWRX",
apiExplorerGoVerify: "افتح مفاتيح API والوصول للتحقق من الاتصال",
apiExplorerBack: "رجوع",
apiExplorerPhoneTitle: "يُفضَّل استعراضها على شاشة أكبر",
apiExplorerPhoneBody: "مرجع واجهة برمجة التطبيقات التفاعلي مُصمَّم للأجهزة اللوحية أو أجهزة سطح المكتب. افتح هذه الصفحة هناك لتصفّح نقاط النهاية والنماذج. لا يزال بإمكانك إدارة مفاتيح واجهة البرمجة أعلاه ونسخ عنوان URL الأساسي أدناه.",
apiExplorerBaseUrlLabel: "عنوان URL الأساسي",
apiExplorerCovers: "يشمل الأصول والأماكن والمواقع وقوائم التحقق وعمليات التفتيش وجداولها والمهام وخطط الصيانة وبرامجها وجهات الاتصال والفرق والرؤى والملفات وwebhooks والأتمتة والأجهزة المتصلة وPower BI ووكلاء الذكاء الاصطناعي. المواقع وقوائم التحقق والجداول والصيانة والفرق للقراءة فقط.",
apiExplorerSectionNeeds: "مفتاح الخطة: {{names}}.",
apiExplorerSectionOff: "غير مشمول في خطتك: {{names}} متوقف لمساحة العمل هذه.",
apiExplorerNotInPlan: "غير مشمول في خطتك، لذا تُرفض هذه الطلبات: {{sections}}.",
handbookTitleAutomation: "دليل الأتمتة (داخل التطبيق)",
handbookTitleIntegrations: "دليل API والاتصالات (داخل التطبيق)",
handbookLead: "هذا المحتوى مضمَّن مع التطبيق من ملف Markdown الأساسي في مستودع المنتج.",
handbookOpenHosted: "فتح النسخة المستضافة",
handbookCopyMarkdown: "نسخ Markdown",
handbookCopyDoneTitle: "تم النسخ",
handbookCopyDoneBody: "تم نسخ Markdown الدليل إلى حافظتك.",
handbookCopyFailedTitle: "فشل النسخ",
handbookCopyFailedBody: "تعذّر النسخ إلى الحافظة على هذا الجهاز.",
handbookOpenFailedTitle: "تعذّر فتح الرابط",
handbookOpenFailedBody: "تحقق من رابط الوثائق المستضافة في إعدادات بيئة مساحة عملك.",
docsFallbackTitle: "رابط الوثائق",
docsFallbackAutomationIntro: "لم تُهيَّأ الوثائق المستضافة حتى الآن. يمكنك نسخ مسارات المرجع الداخلية هذه لسجلاتك أو لمشاركتها مع من يدير التكاملات.",
docsFallbackApiIntro: "لم تُهيَّأ الوثائق المستضافة حتى الآن. يمكنك نسخ مسارات المرجع الداخلية هذه لسجلاتك أو لمشاركتها مع من يدير التكاملات.",
docsFallbackCopy: "نسخ مسارات المرجع",
docsFallbackClose: "إغلاق",
docsPathAutomation: "دليل الأتمتة (مرجع داخلي)",
docsPathApi: "API والتكاملات (مرجع داخلي)",
docsPathOpenApiYaml: "عقد OpenAPI (مرجع داخلي)",
showAdvancedDetails: "إظهار التفاصيل المتقدمة",
hideAdvancedDetails: "إخفاء التفاصيل المتقدمة",
loadingContracts: "جاري تحميل عقود التكامل…",
retryLoad: "إعادة التحميل",
navSectionMain: "الوحدات",
navSectionAutomation: "عروض المحفزات",
guidedBadge: "موجَّه",
recipeListTitle: "الوصفات في مساحة العمل هذه",
recipeListSubtitle: "فعّل، أوقف مؤقتًا، كرّر، أرشِف، شغّل مع JSON اختياري، دوّر الرموز الواردة، وأعد المحاولة من السجل.",
recipeNoActions: "بدون إجراءات",
recipeListEmpty: "لا توجد وصفات حتى الآن.",
recipePause: "إيقاف مؤقت",
recipePaused: "الوصفة متوقفة مؤقتًا",
recipeActivate: "تفعيل",
recipeActive: "الوصفة نشطة",
recipeManualRun: "تشغيل يدوي",
recipeDuplicate: "تكرار",
recipeDuplicated: "تم تكرار الوصفة",
recipeRotateToken: "تدوير الرمز",
recipeTokenRotated: "تم تدوير رمز خطاف الويب",
recipeArchive: "أرشفة",
recipeArchived: "تمت أرشفة الوصفة",
guidedWizard: {
title: "الأتمتة الموجَّهة",
subtitle: "اختر قائمة تحققًا، واملأ بعض الحقول، ثم أنشئ مسودة محفوظة على الخادم. يبقى التعديل المتقدم للوصفات ضمن محفزات الأحداث ← محرر متقدم.",
publicApiLead: "تُنفَّذ كل عمليات التشغيل في مساحة عملك على واجهة API العامة؛ لا يوجد شيء محاكى في التطبيق.",
apisShortcutLabel: "إنشاء حسابات الخدمة ومفاتيح API أو عرضها",
apisShortcutA11y: "فتح مفاتيح API والوصول لإدارة حسابات الخدمة ومفاتيح API",
pillType: "النوع",
pillBasics: "الأساسيات",
pillReview: "مراجعة",
pillArtifacts: "اختبار وحفظ",
pillDone: "تم",
next: "التالي",
back: "رجوع",
categoryWorkflow: "سير العمل اليومي",
categoryInspection: "التفتيش",
categoryJob: "المهام",
categoryAssetSync: "مزامنة الأصول",
categoryInboundWebhook: "خطافات ويب واردة",
categoryScheduled: "مُجدوَل",
categoryOutbound: "الاختبار والإشعارات",
fieldName: "الاسم",
placeholderName: "اسم داخلي قصير",
fieldDescription: "الوصف (اختياري)",
placeholderDescription: "من يستخدم هذا وأي نظام يستقبله",
fieldForwardUrl: "إعادة التوجيه إلى رابط HTTPS",
fieldDestinationUrl: "رابط HTTPS للوجهة",
fieldSigningSecret: "سر التوقيع (اختياري)",
placeholderSigningSecret: "اتركه فارغًا إذا كان المستقبل لا يتحقق من HMAC",
fieldFilterStatus: "فقط عندما تساوي حالة التفتيش (اختياري)",
placeholderFilterStatus: "مثال: completed — اتركه فارغًا للإرسال عند كل تحديث",
fieldAssetEvent: "حدث الأصل",
fieldIntervalMinutes: "الفترة (بالدقائق)",
fieldJobIdPath: "حقل معرّف العمل في نص JSON",
fieldStatusPath: "حقل الحالة في نص JSON",
reviewWhen: "عندما: ",
reviewDo: "قم بـ: ",
reviewNeedFix: "أصلح أي أخطاء في الأساسيات لرؤية الوصفة المجمّعة.",
artifactsLead: "انسخ عقد YAML أو JSON نموذجي للشركاء. عندما تكون جاهزًا، أنشئ مسودة — ثم فعّل الوصفة واستخدم التشغيل اليدوي مع JSON من القائمة أدناه.",
copyYaml: "نسخ عقد YAML",
manualRunHelp: "مساعدة التشغيل اليدوي",
copySampleEvent: "نسخ JSON نموذجي لحدث المجال",
copyManualInput: "نسخ إدخال نموذجي للتشغيل اليدوي",
saving: "جارٍ الحفظ…",
createDraftContinue: "إنشاء مسودة والاستمرار",
draftCreatedAlert: "تم إنشاء مسودة الأتمتة",
turnedOnAlert: "تم تشغيل الأتمتة",
turnOn: "قم بالتشغيل",
saveDraft: "حفظ كمسودة",
copiedTitle: "تم النسخ",
copiedYamlBody: "تم نسخ عقد YAML إلى الحافظة.",
copiedEventBody: "تم نسخ JSON نموذجي للحدث.",
copiedManualBody: "استخدم هذا النص كإدخال عند استدعاء عمليات التشغيل اليدوية بعد التفعيل.",
successTitle: "تم حفظ المسودة",
successBody: "تظهر وصفتك في القائمة أدناه. فعّلها عندما تكون جاهزًا، ثم استخدم التشغيل اليدوي للاختبار مع JSON.",
successBodyActive: "قيد التشغيل. يظهر كل تشغيل في تاريخ هذه الأتمتة.",
createAnother: "إنشاء أخرى",
alertNeedTypeTitle: "اختر نوعًا",
alertNeedTypeBody: "حدّد قائمة تحقق أتمتة للاستمرار.",
alertInvalidTitle: "تحقق من الحقول",
alertInvalidBody: "امْلأ الحقول المطلوبة للاستمرار.",
manualHarnessTitle: "أداة الاختبار اليدوي",
manualHarnessBodyGeneric: "أنشئ مسودة “webhook اختبار يدوي”، فعّلها، ثم استخدم التشغيل اليدوي على صف الوصفة مع JSON النموذجي.",
manualHarnessCreateFirstTitle: "أنشئ أولاً",
manualHarnessCreateFirstBody: "احفظ هذه الأتمتة كمسودة من “إنشاء مسودة والاستمرار”، ثم فعّلها واستخدم “التشغيل اليدوي” على صف الوصفة مع JSON النموذجي.",
},
manualRunModal: {
title: "تشغيل يدوي",
inputLabel: "إدخال JSON اختياري (كائن)",
run: "إضافة التشغيل إلى قائمة الانتظار",
cancel: "إلغاء",
errorInvalidJson: "أدخل JSON صالحًا أو اتركه فارغًا لـ {}.",
errorNotObject: "يجب أن يكون الإدخال كائن JSON (وليس مصفوفة).",
successTitle: "تمت إضافة التشغيل اليدوي إلى قائمة الانتظار",
successBody: "معرّف التشغيل: {{id}}\nالحالة: {{status}}",
goToRuns: "فتح سجل التشغيل",
},
accessWizard: {
pageTitle: "مفاتيح API والوصول",
pageSubtitle: "نظرة عامة، تحقق من البوابة، أدر المفاتيح، أنشئ مفتاحًا جديدًا، راجع الأتمتة الواردة، ثم انسخ رابط قاعدة REST والمسارات. لا شيء هنا يتجاوز أمان مساحة عملك.",
pillPurpose: "نظرة عامة",
pillVerify: "تحقق",
pillAccounts: "المفاتيح الحالية",
pillCreate: "مفتاح جديد",
pillInbound: "وارد",
pillEndpoints: "نقاط النهاية",
purposeTitle: "ما يمكنك ربطه",
purposeBody: "تتيح مفاتيح REST API للأنظمة الموثوقة قراءة بيانات مساحة العمل وكتابتها. تُهيَّأ خطافات الويب الصادرة من المنصة بشكل منفصل في دليل الاتصال. روابط الوصفات الواردة مخصصة لمشغّلات الأتمتة.",
openHandbook: "فتح دليل الاتصال الكامل",
verifyTitle: "التحقق من واجهة API لمساحة العمل (الجلسة)",
verifyLead: "يؤكد أن البوابة نفسها التي يستخدمها التطبيق لإدارة التكاملات قابلة للوصول بتسجيل دخولك الحالي.",
verifyAppLoginVsApiKeyTitle: "تسجيل الدخول للتطبيق مقابل مفاتيح API",
verifyAppLoginVsApiKeyBody: "تسجّل الدخول إلى هذا التطبيق بحساب المستخدم (نفس الجلسة في بقية AssetWRX). مفاتيح API مخصّصة فقط للأنظمة والسكربتات الخارجية التي تستدعي واجهة REST لمساحة العمل — ولا تحل محل تسجيل الدخول هنا.",
verifyConnection: "التحقق من الاتصال",
verifying: "جارٍ التحقق…",
sessionVerifyOk: "قابل للوصول. مساحة العمل {{workspaceId}} · المستخدم: {{principal}}",
accountsListTitle: "حسابات الخدمة الحالية",
accountsListLead: "المفاتيح مُجزَّأة بخوارزمية SHA-256 عند التخزين؛ يُعرض النص الصريح مرة واحدة فقط عند الإنشاء أو التدوير. حدّث القائمة بعد إنشاء مفتاح على جهاز آخر.",
accountsListSecretCalloutTitle: "لماذا لا يظهر المفتاح الكامل في هذه القائمة",
accountsListSecretCalloutBody: "يُخزَّن على الخادم تجزئة فقط. يظهر السر الكامل مرة واحدة في النافذة المنبثقة عند الإنشاء أو التدوير — انسخه حينها إلى مدير كلمات مرور. أدناه تظهر أسماء الحسابات والنطاقات فقط. إذا أغلقت النافذة دون حفظ، استخدم «تدوير المفتاح» لإصدار سر جديد.",
accountsAdminErrorHint: "يمكن لمسؤولي مساحة العمل فقط عرض أو إنشاء حسابات الخدمة ومفاتيح API. سجّل الدخول بحساب مسؤول، أو اطلب من المالك منحك صلاحية المسؤول.",
refreshList: "تحديث القائمة",
refreshLoading: "جارٍ التحميل…",
lastUsed: "آخر استخدام {{when}}",
neverUsed: "لم يُستخدم بعد",
rotatedOn: "تم تدوير المفتاح {{when}}",
revokedOn: "أُلغي {{when}}",
rotateKey: "تدوير المفتاح",
revoke: "إلغاء",
revoked: "مُلغى",
noAccounts: "لا توجد حسابات خدمة حتى الآن.",
createTitle: "إنشاء حساب خدمة",
createLead: "اختر اسمًا، ووصفًا اختياريًا، وصلاحيات، وانتهاء صلاحية اختياري للمفتاح. سترى المفتاح الكامل مرة واحدة — خزّنه في خزنة.",
endpointsTitle: "بوابة REST والمسارات",
endpointsLead: "تمر جميع استدعاءات REST ذات الإصدار عبر رابط القاعدة هذا. أضف المسارات من العقد (مثل /v1/assets). روابط الأتمتة الواردة منفصلة ومدرجة في خطوة الوارد.",
endpointsBaseLabel: "رابط قاعدة البوابة",
endpointsCopyBase: "نسخ رابط القاعدة",
endpointsCopiedTitle: "تم النسخ",
endpointsCopiedBody: "تم نسخ رابط قاعدة البوابة إلى الحافظة.",
endpointsExamplesTitle: "أمثلة (نسبةً إلى القاعدة)",
endpointsExampleStatus: "GET /v1/status — سلامة واجهة API لمساحة العمل (يتطلب status:read لمفاتيح API)",
endpointsExampleAssets: "GET /v1/assets — سرد الأصول (يتطلب assets:read)",
endpointsExampleInbound: "تستخدم الأتمتة الواردة روابط HTTPS خاصة بكل وصفة من خطوة الوارد، وليس رابط القاعدة هذا.",
endpointsExampleDocs: "كل مسار ومعامل استعلام وشكل نص موجود في مرجع OpenAPI المباشر.",
endpointsAuthHint: "من الأنظمة الأخرى: أرسل رأس apikey: <مفتاح AssetWRX القابل للنشر الخاص بك> وAuthorization: Bearer <مفتاح API لحساب خدمتك>. يستخدم هذا التطبيق جلسة تسجيل دخولك بدلاً من ذلك.",
endpointsOpenReference: "فتح مرجع API المباشر",
fieldName: "الاسم",
fieldDescription: "الوصف (اختياري)",
fieldExpiry: "تنتهي صلاحية المفتاح الأول في (تاريخ ISO اختياري)",
placeholderName: "مزامنة ليلية لـ ERP",
placeholderDescription: "ملاحظة داخلية",
saving: "جارٍ الحفظ…",
createShowKey: "إنشاء وإظهار المفتاح",
inboundTitle: "نقاط نهاية الوصفة الواردة",
inboundLead: "تُعرض للوصفات التي تستخدم مشغّل خطاف الويب الوارد. تظهر الروابط والأسرار على الوصفة بعد التفعيل.",
inboundToken: "الرمز {{prefix}}…{{last}}",
inboundEmpty: "أنشئ وصفة بمشغّل خطاف ويب وارد لإنشاء نقطة نهاية برمز.",
keyVerifyOk: "نجح طلب الاختبار بهذا المفتاح (GET /v1/status).",
keyVerifyFail: "تعذّر التحقق من المفتاح عبر GET /v1/status: {{message}}",
keyVerifySkipped: "أضف صلاحية “حالة مساحة العمل” (status:read) للتحقق من المفاتيح الجديدة تلقائيًا في المرة القادمة.",
keyRevealModalTitle: "مفتاح API الجديد",
keyRevealModalLead: "انسخ هذا السر واحفظه في مدير كلمات مرور. لن تتمكن من عرض المفتاح الكامل مرة أخرى في هذه القائمة.",
keyRevealCopy: "نسخ المفتاح",
keyRevealSaved: "لقد حفظته",
keyRevealMissingFromServer: "الخادم لم يُرجِع مفتاحاً. أعد المحاولة أو راجع سجلات دالة Edge.",
keyRevealCopiedTitle: "تم النسخ",
keyRevealCopiedBody: "تم نسخ مفتاح API إلى الحافظة.",
},
mcpWizard: {
pageTitle: "خوادم MCP لمساحة العمل",
pageSubtitle: "اربط خوادم MCP البعيدة المعتمدة عبر HTTPS، وخزّن الأسرار مشفَّرة، وشغّل الاكتشاف من الخلفية، ثم اختر الأدوات والموارد التي يمكن للمساعد اقتراحها.",
flowLabel: "إعداد موجَّه",
pillIntro: "نظرة عامة",
pillServer: "الخادم",
pillCredentials: "الأسرار",
pillVerify: "اختبار واكتشاف",
pillCatalog: "قائمة السماح",
pillHistory: "السجل",
loading: "جارٍ تحميل تكوين MCP…",
loadError: "تعذّر تحميل تكوين MCP.",
detailLoadError: "تعذّر تحميل الأدوات والموارد لهذا الخادم.",
introTitle: "ما الذي تقوم بإعداده",
introLead: "يسمح بروتوكول سياق النموذج (MCP) للمساعد التشغيلي باستدعاء أدوات خارجية وقراءة موارد خارجية بعد تأكيدك لكل اقتراح. تحتفظ مساحة العمل هذه بقائمة سماح صارمة.",
introWhatTitle: "قيود الإصدار 1",
introWhatBody: "يتم دعم نقاط نهاية HTTP JSON-RPC البعيدة فقط. تُشفَّر بيانات الاعتماد من جانب الخادم؛ لا يستقبل التطبيق أبدًا أسرارًا بنص صريح بعد الحفظ. يعمل الاكتشاف والاستدعاءات دائمًا عبر Edge Function لواجهة API العامة.",
introStepsTitle: "اتبع هذه الخطوات بالترتيب",
introStep1: "سجّل اسم الخادم ورابط قاعدة HTTPS الذي وثّقه المزوّد.",
introStep2: "احفظ بيانات الاعتماد إذا كانت نقطة النهاية تتطلب رمز bearer، أو رأس مفتاح API، أو رأسًا مخصصًا.",
introStep3: "اختبر الاتصال، ثم شغّل الاكتشاف لتظهر الأدوات والموارد في الكتالوج.",
introStep4: "فعّل فقط الأدوات والموارد التي يجب أن تستدعيها مساحة العمل هذه.",
introStep5: "فعّل اختياريًا “المساعد” لكل صف ليتمكن المخطط من اقتراح تلك الأداة أو المورد (ما زلت تؤكد قبل تشغيله).",
introStep6: "راجع سجل الاستدعاءات للتدقيق واستكشاف الأخطاء وإصلاحها.",
serverListTitle: "اختر أو أضف خادمًا",
serverListLead: "حدّد بطاقة لتعديلها، أو استخدم “إضافة خادم MCP” لصف جديد، ثم احفظ أدناه.",
serverCardCounts: "الأدوات: {{tools}} · الموارد: {{resources}}",
addServer: "إضافة خادم MCP",
serverFormTitle: "تفاصيل الخادم",
serverFormLead: "الصق رابط نقطة نهاية MCP الدقيق من المزوّد. يجب أن يستخدم HTTPS — استخدم التنسيق النموذجي أدناه إذا لم تكن متأكدًا.",
fieldName: "الاسم",
fieldDescription: "الوصف (اختياري)",
fieldBaseUrl: "رابط القاعدة (HTTPS)",
fieldBaseUrlPlaceholder: "https://mcp.example.com/v1",
fieldBaseUrlHint: "يجب أن يبدأ بـ https://. استخدم المسار الكامل الذي يوثّقه مستضيف MCP (غالبًا /mcp أو /sse أو /v1). لا يتم دعم HTTP وأسماء المضيف العارية.",
alertBaseUrlHttpsTitle: "رابط HTTPS مطلوب",
alertBaseUrlHttpsBody: "يجب أن يبدأ رابط قاعدة MCP بـ https://. مثال: https://mcp.example.com/v1",
invalidBaseUrlFormat: "أدخل رابطًا كاملاً يشمل https://، مثل https://mcp.example.com/v1",
fieldTimeoutMs: "المهلة (بالمللي ثانية)",
fieldMaxPayload: "الحد الأقصى لحجم الحمولة (بايت)",
fieldHeaderName: "اسم الرأس",
fieldSecret: "السر",
secretPlaceholderNew: "أدخل السر مرة واحدة لتشفيره",
secretPlaceholderRotate: "أدخل سرًا جديدًا لتدوير القيمة المخزَّنة",
saving: "جارٍ الحفظ…",
updateServer: "تحديث الخادم",
createServer: "إنشاء خادم",
serverSavedTitle: "تم حفظ خادم MCP",
serverSavedBody: "تم تخزين {{name}}. انتقل إلى الأسرار عندما تحتاج نقطة النهاية إلى مصادقة.",
serverSaveFailedTitle: "فشل الحفظ",
serverSaveFailed: "تعذّر حفظ خادم MCP.",
credentialsTitle: "بيانات اعتماد مشفَّرة",
credentialsLead: "اختر كيفية مصادقة الخلفية مع خادم MCP. استخدم “بدون” فقط للمستضيفات التي لا تتطلب سرًا.",
credentialsNeedServer: "احفظ خادمًا في الخطوة السابقة قبل إضافة بيانات الاعتماد.",
credentialStored: "مخزَّن: {{type}} {{prefix}}…{{last}}",
saveCredentials: "حفظ بيانات الاعتماد",
credentialsSavedTitle: "تم تحديث بيانات الاعتماد",
credentialsSavedBody: "تُشفَّر الأسرار عند التخزين. تُرجَع فقط بيانات وصفية مقنَّعة إلى التطبيق بعد ذلك.",
credentialsSaveFailedTitle: "فشل تحديث بيانات الاعتماد",
credentialsSaveFailed: "تعذّر حفظ بيانات الاعتماد.",
noSecretStored: "لا يوجد سر مخزَّن",
verifyTitle: "اختبار الاتصال والاكتشاف",
verifyLead: "يقوم الاختبار بمصافحة تهيئة خفيفة. يسرد الاكتشاف الأدوات والموارد لتتمكن من الموافقة عليها.",
verifyOrderTitle: "الترتيب المُوصى به",
verifyOrderBody: "شغّل اختبار الاتصال أولاً. إذا نجح، شغّل اكتشاف البيانات الوصفية، ثم انتقل إلى قائمة السماح لتمكين الإدخالات.",
verifyNeedServer: "احفظ خادمًا أولاً، ثم عد إلى هنا.",
testConnection: "اختبار الاتصال",
discoverMetadata: "اكتشاف البيانات الوصفية",
testOkTitle: "نجح اختبار الاتصال",
testOkBody: "اكتمل في {{ms}} مللي ثانية.",
discoverOkTitle: "اكتمل الاكتشاف",
discoverOkBody: "تم العثور على {{tools}} أدوات و {{resources}} موارد.",
testFailedTitle: "فشل اختبار الاتصال",
discoverFailedTitle: "فشل الاكتشاف",
actionFailedGeneric: "تعذّر إتمام هذه العملية.",
catalogTitle: "قائمة السماح للأدوات والموارد",
catalogLead: "تحدّد مساحة العمل تمكين/تعطيل إمكانية استدعاء الخلفية لإدخال ما من الأساس. تضيف مفاتيح المساعد رؤية للمخطط فوق ذلك.",
catalogNeedServer: "احفظ خادمًا وشغّل الاكتشاف قبل إدارة الكتالوج.",
toolsHeading: "الأدوات",
resourcesHeading: "الموارد",
noTools: "لم تُكتشف أدوات حتى الآن. شغّل اكتشاف البيانات الوصفية في الخطوة السابقة.",
noResources: "لم تُكتشف موارد حتى الآن. شغّل اكتشاف البيانات الوصفية في الخطوة السابقة.",
workspaceOn: "مساحة العمل مفعَّلة",
workspaceOff: "مساحة العمل معطَّلة",
assistantOn: "المساعد مفعَّل",
assistantOff: "المساعد معطَّل",
historyTitle: "سجل الاستدعاءات",
historyLead: "يسجّل كل استدعاء الهدف والتوقيت والحالة ومعاينات حمولة منقّاة.",
noInvocations: "لم يُسجَّل أي استدعاء MCP حتى الآن.",
invocationMeta: "المدة {{ms}} مللي ثانية · {{when}}",
maskedLine: "أحدث قناع لبيانات الاعتماد: {{mask}}",
alertNeedServerTitle: "احفظ خادمًا أولاً",
alertNeedServerBody: "أنشئ أو حدّد خادمًا، واملأ الحقول المطلوبة، واضغط على إنشاء خادم أو تحديث خادم قبل الاستمرار.",
alertServerFieldsTitle: "تحقق من الحقول المطلوبة",
alertServerFieldsBody: "أدخل اسمًا معروضًا ورابط قاعدة HTTPS قبل الاستمرار.",
alertNoServerTitle: "لم يتم تحديد خادم",
alertNoServerBody: "حدّد أو أنشئ خادمًا قبل حفظ بيانات الاعتماد.",
toolUpdateFailedTitle: "فشل تحديث الأداة",
toolUpdateFailed: "تعذّر تحديث أداة MCP.",
resourceUpdateFailedTitle: "فشل تحديث المورد",
resourceUpdateFailed: "تعذّر تحديث مورد MCP.",
},
editor: {
  saved: "تم تحديث الأتمتة",
  saveFailed: "تعذّر الحفظ",
  title: "تعديل الأتمتة",
  notGuidedTitle: "ليست أتمتة موجَّهة",
  notGuidedDesc: "أُنشئت هذه في المنشئ المتقدم. عدّلها هناك.",
  save: "حفظ",
},
guidedForm: {
  severityLabel: "عندما تجد",
  severityAny: "أي مشكلة",
  severityUrgent: "المشكلات العاجلة فقط",
  checklistLabel: "لقائمة التحقق هذه فقط",
  anyChecklist: "أي قائمة تحقق",
  assignLabel: "إسناد أمر العمل إلى",
  nobodyYet: "لا أحد بعد",
  urgencyLabel: "درجة استعجال أمر عمل التجديد",
  urgencyDefault: "عادية",
  urgencyHigh: "مرتفع",
  urgencyUrgent: "عاجل",
  thresholdLabel: "أوامر العمل بهذه القيمة أو أكثر ({{currency}})",
  approverLabel: "من يعتمدها",
  choosePerson: "اختر شخصًا",
  daysLabel: "بدون رد لمدة",
  daysOption_one: "يوم واحد",
  daysOption_other: "{{count}} يوم",
  assetCreated: "أُنشئ",
  assetUpdated: "تم التحديث",
  assetDeleted: "تم الحذف",
  titlePathLabel: "يأتي عنوان أمر العمل من هذا الحقل في JSON",
  unknownChoice: "لم يعد في مساحة العمل",
  wholeTeam: "الفريق بأكمله",
  notifyLabel: "إبلاغ",
  nobody: "لا أحد",
  choosePersonOrTeam: "اختر شخصًا أو فريقًا",
  close: "إغلاق",
  search: "بحث…",
  noMatch: "لا توجد نتائج مطابقة.",
  daysOption_zero: "لا أيام",
  daysOption_two: "يومان",
  daysOption_few: "{{count}} أيام",
  daysOption_many: "{{count}} يومًا",
},
},
connectedAssets: {
title: "الأصول المتصلة",
lead: "ستظهر موصلات إنترنت الأشياء ومراقبة الأصول المباشرة هنا. هذا القسم محجوز لميزات مستقبلية.",
backToIntegrations: "العودة إلى الأتمتة",
moreTitle: "النطاق وخارطة الطريق",
moreSummary: "الموصلات وحالة الأجهزة وتكامل الأتمتة.",
moreBody: "ستعرض الأصول المتصلة القراءات الحية وآخر ظهور وروابط للفحوصات والمهام عند تفعيل التكاملات في مساحة العمل. استخدم الأتمتة لتهيئة الموصلات وإدارة الوصول إلى البيانات.",
showMore: "عرض المزيد",
showLess: "عرض أقل",
},
apiAccess: {
catalogScopesLabel: "مجالات وصول API",
noScopes: "لم يتم تحديد مجالات وصول",
fullAccessChip: "وصول كامل إلى API",
scopesSectionTitle: "ما يمكن لهذا المفتاح استخدامه",
scopesSectionHint: "اختر حزمة بداية للأدوات الشائعة، ثم اضبط بدقة باستخدام مربعات الاختيار. فعّل فقط ما يحتاجه تكاملك.",
presetsLabel: "حزم البداية",
preset_starter_title: "التقارير والقوائم",
preset_starter_subtitle: "قراءة حالة مساحة العمل والأصول وعمليات التفتيش والأعمال — مناسب للوحات المعلومات والمزامنة للقراءة فقط.",
preset_field_title: "العمليات الميدانية",
preset_field_subtitle: "يضيف إنشاء وتحديث الأصول وجهات الاتصال وعمليات التفتيش والأعمال — نموذجي لأدوات الجوال أو الفرق.",
preset_automation_title: "الأتمتة والأحداث",
preset_automation_subtitle: "يشمل الوصفات وكتالوج الأتمتة وقراءة الأحداث — لسير عمل بأسلوب Zapier وخطافات الويب.",
preset_full_title: "كل شيء (المسؤول)",
preset_full_subtitle: "قوة API كاملة تشمل GraphQL وإدارة المفاتيح الأخرى. استخدمها فقط لبرامج الخوادم الموثوقة.",
preset_read_only_title: "قراءة فقط",
preset_read_only_subtitle: "عرض حالة مساحة العمل والأصول وجهات الاتصال وعمليات التفتيش والأعمال وموجز الأحداث. لا يمكن تغيير أي شيء.",
preset_power_bi_title: "Power BI",
preset_power_bi_subtitle: "قراءة الأصول وعمليات الفحص والأعمال عبر موجز OData. لا يمكن تغيير أي شيء.",
preset_power_automate_title: "Power Automate",
preset_power_automate_subtitle: "ما يحتاجه موصل Power Automate: قراءة الأصول، وقراءة الأعمال وعمليات الفحص وإنشاؤها، وبدء التدفقات من الأحداث.",
preset_asset_operations_title: "عمليات الأصول",
preset_asset_operations_subtitle: "إنشاء وتحديث الأصول وجهات الاتصال، مع وصول للقراءة إلى قوائم التحقق — للحفاظ على مزامنة سجل الأصول.",
preset_inspections_title: "عمليات التفتيش",
preset_inspections_subtitle: "إنشاء وتحديث عمليات التفتيش، مع وصول للقراءة إلى الأصول والأعمال وقوائم التحقق — لأدوات التفتيش.",
preset_wrx_operations_title: "عمليات WRX",
preset_wrx_operations_subtitle: "قراءة وكتابة كاملة عبر الأصول وجهات الاتصال وعمليات التفتيش والأعمال (WRX) بالإضافة إلى موجز الأحداث — للأنظمة التشغيلية.",
preset_full_integration_title: "تكامل كامل",
preset_full_integration_subtitle: "وصول كامل إلى API يشمل GraphQL وإدارة المفاتيح. استخدمه فقط لبرامج الخوادم الموثوقة.",
preset_custom_access_title: "مخصص",
preset_custom_access_subtitle: "اختر بالضبط مجالات الوصول التي يحتاجها هذا الاتصال.",
preset_ai_read_title: "قراءة معلومات الأصل",
preset_ai_read_subtitle: "اسمح لوكيل الذكاء الاصطناعي بقراءة الأصول وجهات الاتصال وعمليات التفتيش والأعمال. لا يمكنه إجراء تغييرات.",
preset_ai_inspection_title: "مساعد التفتيش",
preset_ai_inspection_subtitle: "اسمح لوكيل الذكاء الاصطناعي بقراءة الأصول وقوائم التحقق وإنشاء أو تحديث عمليات التفتيش.",
preset_ai_wrx_title: "مساعد WRX",
preset_ai_wrx_subtitle: "اسمح لوكيل الذكاء الاصطناعي بقراءة وتحديث الأصول وجهات الاتصال وعمليات التفتيش والأعمال (WRX).",
preset_ai_operations_title: "مساعد العمليات",
preset_ai_operations_subtitle: "وصول تشغيلي كامل لوكيل الذكاء الاصطناعي، يشمل الأتمتة وسياق الأحداث المتصلة.",
preset_custom_ai_title: "مخصص",
preset_custom_ai_subtitle: "اختر بالضبط الأدوات والمعلومات التي يمكن لاتصال الذكاء الاصطناعي هذا استخدامها.",
group_overview: "نظرة عامة والمساعد",
group_records: "الأصول وجهات الاتصال وعمليات التفتيش والأعمال",
group_events: "خطافات الويب والأحداث",
group_automation: "أداة إنشاء الأتمتة",
group_connected: "المصادر والأحداث والقواعد المتصلة",
group_advanced: "الإدارة المتقدمة وإدارة المفاتيح",
scope_status_read: "حالة مساحة العمل",
scope_dashboard_read: "بيانات لوحة المعلومات",
scope_dashboards_read: "لوحات المعلومات المحفوظة",
scope_assistant_context_read: "سياق المساعد (قراءة)",
scope_assets_read: "عرض الأصول",
scope_assets_write: "إنشاء وتعديل الأصول",
scope_contacts_read: "عرض جهات الاتصال",
scope_contacts_write: "إنشاء وتعديل جهات الاتصال",
scope_inspections_read: "عرض عمليات التفتيش",
scope_inspections_write: "إنشاء وتعديل عمليات التفتيش",
scope_jobs_read: "عرض الأعمال",
scope_jobs_write: "إنشاء وتعديل الأعمال",
scope_templates_read: "عرض قوائم التحقق",
scope_templates_write: "إنشاء قوائم التحقق وتعديلها",
scope_mcp_read: "عرض إعدادات الذكاء الاصطناعي (MCP)",
scope_mcp_write: "إدارة إعدادات الذكاء الاصطناعي (MCP)",
scope_mcp_invoke: "استخدام أدوات الذكاء الاصطناعي (MCP)",
scope_connected_sources_read: "عرض المصادر المتصلة",
scope_connected_sources_write: "إدارة المصادر المتصلة",
scope_connected_events_read: "عرض الأحداث المتصلة",
scope_connected_events_write: "إرسال الأحداث المتصلة",
scope_connected_rules_read: "عرض القواعد المتصلة",
scope_connected_rules_write: "إدارة القواعد المتصلة",
scope_webhooks_read: "عرض خطافات الويب الصادرة",
scope_webhooks_write: "إدارة خطافات الويب الصادرة",
scope_events_read: "قراءة موجز الأحداث",
scope_graphql_read: "GraphQL (قراءة)",
scope_graphql_write: "GraphQL (كتابة)",
scope_service_accounts_read: "عرض مفاتيح API وحسابات الخدمة",
scope_service_accounts_write: "إدارة مفاتيح API وحسابات الخدمة",
scope_automation_catalog_read: "عرض كتالوج الأتمتة",
scope_automation_recipes_read: "عرض الوصفات",
scope_automation_recipes_write: "إنشاء وتعديل الوصفات",
scope_automation_runs_read: "عرض عمليات تشغيل الوصفات",
scope_automation_actions_write: "تشغيل إجراءات الأتمتة",
alertNameTitle: "الاسم مطلوب",
alertNameBody: "أدخل اسمًا قصيرًا ليعرف فريقك الغرض من هذا التكامل.",
alertScopesTitle: "اختر مجالاً واحدًا على الأقل",
alertScopesBody: "اختر حزمة بداية أو حدّد مجال وصول واحد أو أكثر.",
alertExpiryTitle: "تحقق من تاريخ انتهاء الصلاحية",
alertExpiryBody: "استخدم تاريخًا ووقتًا صالحين، أو اترك تاريخ الانتهاء فارغًا.",
alertStoreKeyTitle: "انسخ مفتاح API الآن",
alertStoreKeyBody: "هذه هي المرة الوحيدة التي يُعرض فيها المفتاح الكامل. خزّنه في مدير كلمات مرور أو خزنة.\n\n{{key}}",
},
defaults: {
  memberNotice: "يمكن لمسؤول مساحة العمل فقط تغيير لغتها ومنطقتها الزمنية. إعداداتك الخاصة في التفضيلات.",
  saveFailedBody: "لم يُحفظ هذا التغيير. تحقّق من اتصالك وحاول مرة أخرى.",
  saveFailedTitle: "لم يُحفظ",
  currencyHint: "تُستخدم للتكاليف التي تضيفها. هي خاصة بك وليست بمساحة العمل؛ ويمكن للفريق تحديد عملته.",
regionalSummary: "الإعدادات الإقليمية الافتراضية",
regionalBody: "تُطبَّق إعدادات مساحة العمل عندما يترك أحد أعضاء الفريق اللغة أو المنطقة الزمنية فارغة في ملفه الشخصي. تتقدم الإعدادات الشخصية دائمًا.",
workspaceDefaultLanguage: "اللغة الافتراضية لمساحة العمل",
workspaceDefaultTimezone: "المنطقة الزمنية الافتراضية لمساحة العمل",
effectiveLanguage: "لغتك الفعلية",
effectiveTimezone: "منطقتك الزمنية الفعلية",
notSet: "غير محدد",
openOrganization: "تعديل في ملف المؤسسة",
loading: "جارٍ التحميل…",
orgHint: "تُعدَّل الإعدادات الافتراضية في ملف المؤسسة. تستخدم نفس القوائم المدعومة للغة والمنطقة الزمنية الشخصية.",
categorySubtitle: "الإعدادات الافتراضية لمساحة العمل الخاصة بك. تستخدم لعمليات التفتيش وأوامر العمل؛ يمكن للفرق تجاوز هذه.",
shareMethodEmail: "البريد الإلكتروني",
languageOptionA11y: "لغة مساحة العمل {{label}}",
timezoneOptionA11y: "المنطقة الزمنية الافتراضية لمساحة العمل",
currencyLabel: "عملتك",
currencyOptionA11y: "العملة {{code}}",
shareMethodLabel: "التواصل (طريقة المشاركة)",
shareMethodOptionA11y: "طريقة المشاركة الافتراضية {{label}}",
teamOverridesA11y: "فتح إعدادات الفريق وتجاوزاته",
teamOverridesLink: "إعدادات الفريق وتجاوزاته",
searchTimezone: "ابحث عن منطقة زمنية",
},
organization: {
defaultLanguageLabel: "اللغة الافتراضية",
timezoneLabel: "المنطقة الزمنية الافتراضية",
notSet: "غير محدد",
languageHelper: "يُستخدم عندما لا تُحدَّد اللغة الشخصية: ثم لغة الجهاز إن وُجدت ضمن المدعومة، ثم الإنجليزية (الولايات المتحدة).",
timezoneHelper: "يُستخدم عندما لا تُحدَّد المنطقة الزمنية الشخصية: ثم منطقة الجهاز، ثم UTC.",
},
assetTypes: {
headerSubtitle: "أنواع الأصول والأماكن الخاصة بك والتفاصيل التي يطلبها كل منها",
intro: "أضف أنواع الأصول التي تديرها مساحة العمل، مثل المبرّد أو غرفة الفندق أو المصعد، والتفاصيل التي تُملأ لكل منها. كل أصل من هذا النوع يطلب التفاصيل نفسها.",
add: "إضافة نوع أصل",
addTitle: "نوع أصل جديد",
editTitle: "تعديل نوع الأصل",
nameLabel: "الاسم",
namePlaceholder: "مثلًا مبرّد أو غرفة نزلاء",
nameRequired: "أدخل اسمًا للنوع",
kindLabel: "إنه",
kindLocked_zero: "لا يستخدمه أي أصل.",
kindLocked_one: "يستخدمه أصل واحد، لذا يبقى صنفه كما هو.",
kindLocked_two: "يستخدمه أصلان، لذا يبقى صنفه كما هو.",
kindLocked_few: "تستخدمه {{count}} أصول، لذا يبقى صنفه كما هو.",
kindLocked_many: "يستخدمه {{count}} أصلًا، لذا يبقى صنفه كما هو.",
kindLocked_other: "يستخدمه {{count}} أصل، لذا يبقى صنفه كما هو.",
descriptionLabel: "الوصف",
descriptionPlaceholder: "اختياري. ما الذي يشمله هذا النوع",
fieldsLabel: "التفاصيل المطلوب ملؤها",
fieldsHint: "يعرضها كل أصل من هذا النوع في صفحة تفاصيله وفي نموذج الإنشاء.",
fieldLabel: "اسم التفصيل",
fieldPlaceholder: "مثلًا غاز التبريد أو عدد الأسرّة",
fieldKinds: {
text: "نص",
number: "رقم",
date: "تاريخ",
choice: "اختيار من قائمة",
yes_no: "نعم أو لا",
},
optionsLabel: "الخيارات",
optionsPlaceholder: "افصل بينها بفواصل، مثلًا R410A, R32, R134a",
optionsRequired: "أضف خيارًا واحدًا على الأقل",
unitLabel: "الوحدة",
unitPlaceholder: "اختياري، مثلًا kW",
requiredLabel: "إلزامي",
removeField: "إزالة التفصيل",
addField: "إضافة تفصيل",
cancel: "إلغاء",
save: "حفظ",
saved: "تم حفظ نوع الأصل",
saveFailedTitle: "تعذّر حفظ نوع الأصل",
saveFailedBody: "تحقق من الاتصال وحاول مرة أخرى.",
fieldCount_zero: "لا تفاصيل",
fieldCount_one: "تفصيل واحد",
fieldCount_two: "تفصيلان",
fieldCount_few: "{{count}} تفاصيل",
fieldCount_many: "{{count}} تفصيلًا",
fieldCount_other: "{{count}} تفصيل",
usedBy_zero: "لا يستخدمه أي أصل",
usedBy_one: "يستخدمه أصل واحد",
usedBy_two: "يستخدمه أصلان",
usedBy_few: "تستخدمه {{count}} أصول",
usedBy_many: "يستخدمه {{count}} أصلًا",
usedBy_other: "يستخدمه {{count}} أصل",
archived: "مؤرشف",
edit: "تعديل",
archive: "أرشفة",
restore: "استعادة",
showArchived_zero: "لا توجد أنواع مؤرشفة",
showArchived_one: "عرض نوع مؤرشف واحد",
showArchived_two: "عرض نوعين مؤرشفين",
showArchived_few: "عرض {{count}} أنواع مؤرشفة",
showArchived_many: "عرض {{count}} نوعًا مؤرشفًا",
showArchived_other: "عرض {{count}} نوع مؤرشف",
hideArchived: "إخفاء الأنواع المؤرشفة",
emptyTitle: "لا توجد أنواع أصول خاصة بك بعد",
emptyBodyAdmin: "أضف نوعًا لتمنح صنفًا من الأصول تفاصيله الخاصة.",
emptyBody: "يمكن للمالك أو المسؤول إضافة أنواع أصول لمساحة العمل.",
archiveConfirmTitle: "أرشفة نوع الأصل هذا؟",
archiveConfirmBody: "تحتفظ الأصول التي تستخدمه به وبتفاصيلها. لن يظهر عند إضافة أصول جديدة. يمكنك استعادته في أي وقت.",
},
industryPacks: {
  later: "لاحقًا",
  onboardingFailedBody: "لم تصل كل قوائم التحقق الجاهزة لمجالك. اضغط إعادة المحاولة لفتح حزم القطاع وإضافتها.",
  onboardingFailedTitle: "لم تُضف بعض قوائم التحقق",
  openTemplates: "فتح قوائم التحقق",
  perAssetNote: "يضيف تثبيت الحزمة قوائم التحقق. تُقترح خطط الصيانة وما يجب إثباته على كل أصل مطابق لتقبلها هناك.",
title: "حزم القطاعات",
headerSubtitle: "أنواع أصول وقوائم تحقق وخطط جاهزة لقطاعك",
subtitle: "نقطة بداية مُعدة لما تديره. أضف المفيد، وغيّر ما تشاء، واحذف الباقي.",
disclaimer: "اقتراحات للبدء، وليست استشارة قانونية. تحقق مما ينطبق في مكان عملك.",
installed: "مُثبّتة",
notInstalled: "غير مُثبّتة",
installedCount_zero: "{{installed}} من أصل 0 قائمة",
installedCount_one: "{{installed}} من أصل قائمة واحدة",
installedCount_two: "{{installed}} من أصل قائمتين",
installedCount_few: "{{installed}} من أصل {{count}} قوائم",
installedCount_many: "{{installed}} من أصل {{count}} قائمةً",
installedCount_other: "{{installed}} من أصل {{count}} قائمة",
newAvailable_one: "تتوفر قائمة جديدة واحدة",
newAvailable_other: "تتوفر {{count}} قائمة جديدة",
install: "تثبيت الحزمة",
installing: "جارٍ التثبيت…",
addRecommended: "إضافة القوائم الموصى بها",
upToDate: "كل ما في هذه الحزمة موجود بالفعل.",
remove: "إزالة الحزمة",
removeConfirmTitle: "إزالة هذه الحزمة؟",
removeConfirmBody: "تبقى القوائم التي عدّلتها. تُزال فقط قوائم الحزمة غير المعدّلة، ويُحذف الأصل التجريبي مع آخر حزمة.",
removeConfirmAction: "إزالة",
removedToast_one: "تمت إزالة قائمة واحدة.",
removedToast_other: "تمت إزالة {{count}} قائمة.",
removedSampleNote: "تمت إزالة الأصل التجريبي أيضًا.",
keptNote_one: "تم الاحتفاظ بقائمة واحدة لأنك عدّلتها.",
keptNote_other: "تم الاحتفاظ بـ {{count}} قائمة لأنك عدّلتها.",
installedToast: "تمت إضافة قوائم التحقق. تجدها في قوائم التحقق.",
partialToast: "تعذرت إضافة بعض العناصر. حاول مرة أخرى.",
retry: "إعادة المحاولة",
sections: {
assetTypes: "ما يمكنك إضافته",
templates: "قوائم التحقق",
maintenance: "الصيانة",
compliance: "ما يجب إثباته",
},
suggestions: {
title: "من حزمة قطاعك",
body: "مقترح لهذا النوع من الأصول. لا يُضاف شيء حتى تختاره.",
addPlan: "إضافة خطة",
planAdded: "مُضافة",
declare: "تتبع هذا",
declared: "قيد التتبع",
empty: "لا يوجد مزيد لاقتراحه لهذا الأصل.",
},
packs: {
property: {
name: "العقارات",
description: "المنازل والشقق والوحدات التجارية — الحالة والدخول والخروج والسلامة من الحريق وما يلزمها من شهادات.",
},
fleet: {
name: "الأسطول",
description: "السيارات والشاحنات والمقطورات — الفحوص اليومية والأضرار والتسليم والصيانة بالتاريخ أو المسافة.",
},
equipment: {
name: "المعدات",
description: "الآلات والأدوات — فحص قبل الاستخدام والحالة والصيانة بساعات التشغيل وأدلة المعايرة.",
},
facilities: {
name: "المرافق",
description: "المباني ومعداتها — الصيانة المخططة وفحوص السلامة وغرف المعدات والأدلة النظامية.",
},
},
newAvailable_zero: "لا قوائم جديدة متاحة",
newAvailable_two: "تتوفر قائمتان جديدتان",
newAvailable_few: "تتوفر {{count}} قوائم جديدة",
newAvailable_many: "تتوفر {{count}} قائمة جديدة",
removedToast_zero: "لم تُزل أي قائمة.",
removedToast_two: "تمت إزالة قائمتين.",
removedToast_few: "تمت إزالة {{count}} قوائم.",
removedToast_many: "تمت إزالة {{count}} قائمة.",
keptNote_zero: "لم يُحتفظ بأي قائمة.",
keptNote_two: "تم الاحتفاظ بقائمتين لأنك عدّلتهما.",
keptNote_few: "تم الاحتفاظ بـ {{count}} قوائم لأنك عدّلتها.",
keptNote_many: "تم الاحتفاظ بـ {{count}} قائمة لأنك عدّلتها.",
},
automationDescribe: {
chosenPerson: "الشخص المختار",
chosenTeam: "الفريق المختار",
chosenChecklist: "قائمة التحقق المختارة",
chosenApprover: "المعتمِد المختار",
personAndTeam: "{{user}} و{{team}}",
theThreshold: "الحد المحدد",
yourUrl: "عنوان URL الخاص بك",
severityUrgent: "مشكلة عاجلة",
severityAny: "أي مشكلة",
templateClause: " باستخدام «{{name}}»",
assignedClause: " مُسندة إلى {{name}}",
notifyClause: " ويرسل إشعارًا إلى {{who}}",
statusClause: " لتصبح حالته «{{status}}»",
failedFollowUp: "عندما يكتشف فحصٌ {{severity}}{{template}}، سينشئ AssetWRX مهمة متابعة{{assigned}}{{notify}}.",
renewalWork: "عندما تبلغ شهادة أو مستند تاريخ التذكير، سينشئ AssetWRX مهمة تجديد على الأصل{{notify}}.",
highCostApproval: "عند إنشاء مهمة بقيمة {{amount}} أو أكثر، سيطلب AssetWRX من {{approver}} اعتمادها.",
unansweredChase_zero: "عندما لا يرد مقاول على دعوة أو طلب عرض سعر لمدة {{count}} يوم، سيرسل AssetWRX إشعارًا إلى {{who}}، ثم مرة أخرى كل أسبوع حتى يتم الرد.",
unansweredChase_one: "عندما لا يرد مقاول على دعوة أو طلب عرض سعر لمدة يوم واحد، سيرسل AssetWRX إشعارًا إلى {{who}}، ثم مرة أخرى كل أسبوع حتى يتم الرد.",
unansweredChase_two: "عندما لا يرد مقاول على دعوة أو طلب عرض سعر لمدة يومين، سيرسل AssetWRX إشعارًا إلى {{who}}، ثم مرة أخرى كل أسبوع حتى يتم الرد.",
unansweredChase_few: "عندما لا يرد مقاول على دعوة أو طلب عرض سعر لمدة {{count}} أيام، سيرسل AssetWRX إشعارًا إلى {{who}}، ثم مرة أخرى كل أسبوع حتى يتم الرد.",
unansweredChase_many: "عندما لا يرد مقاول على دعوة أو طلب عرض سعر لمدة {{count}} يومًا، سيرسل AssetWRX إشعارًا إلى {{who}}، ثم مرة أخرى كل أسبوع حتى يتم الرد.",
unansweredChase_other: "عندما لا يرد مقاول على دعوة أو طلب عرض سعر لمدة {{count}} يوم، سيرسل AssetWRX إشعارًا إلى {{who}}، ثم مرة أخرى كل أسبوع حتى يتم الرد.",
inspectionCompleted: "عند إكمال فحص، سيرسل AssetWRX تفاصيله إلى {{host}}.",
inspectionUpdated: "عند تحديث فحص{{status}}، سيرسل AssetWRX تفاصيله إلى {{host}}.",
jobCompleted: "عند إكمال مهمة، سيرسل AssetWRX تفاصيلها إلى {{host}}.",
jobStatusChanged: "عند تغيّر حالة مهمة، سيرسل AssetWRX تفاصيلها إلى {{host}}.",
assetCreated: "عند إنشاء أصل، سيرسل AssetWRX تفاصيله إلى {{host}}.",
assetDeleted: "عند حذف أصل، سيرسل AssetWRX تفاصيله إلى {{host}}.",
assetUpdated: "عند تحديث أصل، سيرسل AssetWRX تفاصيله إلى {{host}}.",
webhookTick_zero: "كل {{count}} دقيقة، سيستدعي AssetWRX {{host}}.",
webhookTick_one: "كل دقيقة، سيستدعي AssetWRX {{host}}.",
webhookTick_two: "كل دقيقتين، سيستدعي AssetWRX {{host}}.",
webhookTick_few: "كل {{count}} دقائق، سيستدعي AssetWRX {{host}}.",
webhookTick_many: "كل {{count}} دقيقةً، سيستدعي AssetWRX {{host}}.",
webhookTick_other: "كل {{count}} دقيقة، سيستدعي AssetWRX {{host}}.",
inboundForward: "عندما يتلقى Webhook الوارد لهذه الأتمتة بيانات JSON، سيعيد AssetWRX توجيهها إلى {{host}}.",
inboundJobStatus: "عندما يتلقى Webhook الوارد لهذه الأتمتة بيانات JSON، سيحدّث AssetWRX حالة المهمة المذكورة فيها بناءً عليها.",
inboundCreateJob: "عندما يتلقى Webhook الوارد لهذه الأتمتة بيانات JSON، سينشئ AssetWRX مهمة منها.",
manualTest: "عند تشغيلها يدويًا، سيرسل AssetWRX رسالة اختبار إلى {{host}}.",
fallback: "أتمتة",
},
};
